'use strict';

(function () {
  'use strict';
  angular.module('drip', [
  // DEPENDENCIES
  'md.data.table', 'chart.js', 'ui.sortable',
  // CONFIG
  'app.firedux', 'app.themes', 'app.routes',
  // APP
  'root']);
})();
angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/_components/products/products-vendor.comp.html',
    '<fd-ref fd-ref-path="app/constants/productCategories" then="$ctrl.$categories = $data"></fd-ref><fd-ref ng-if="!$ctrl.$products" fd-ref-path="vendors/{{$ctrl.vendorId}}/products" then="\n' +
    '    $ctrl.$products = $data;\n' +
    '    $ctrl.$productList = {};"></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; !$ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/metadata" then="$ctrl.$productList[productId] = $data"><then></then></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; $ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/sites" then="$ctrl.$countSites($data, productId)"></fd-ref><fd-user then="$ctrl.$isRep = $data.isRep"></fd-user><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isRep" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ui-sref="vendor.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ui-sref="product.add({vendorId: $ctrl.vendorId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Product category</span></th><th md-column="md-column"><span>Sites</span></th><!-- th(md-column)span|Days in DRIP--></tr></thead><tbody md-body="md-body"><tr ng-class="{ opacity5: product.pendingApproval }" ng-repeat="(productId, product) in $ctrl.$productList" ui-sref="product.update({productId: productId, vendorId: $ctrl.vendorId})" md-row="md-row" class="pointer"><td md-cell="md-cell"><p>{{product.displayName ? product.displayName : \'Pending Approval\'}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$categories[product.categoryId]}}</p></td><td md-cell="md-cell"><p>{{product.sites === 0 ? 0 : (product.sites || \'Loading...\')}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$products" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a product to this vendor to be able to track its sales and compare it to similar products.</div><md-button ui-sref="product.add({vendorId: $ctrl.vendorId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This vendor doesn\'t have products yet. Please wait until an AATAC representative adds a new product.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/_components/metadata/metadata-vendor.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin || $data.isSubadmin"></fd-user><fd-ref ng-if="$ctrl.vendorId &amp;&amp; !$ctrl.$current" fd-ref-path="vendors/{{$ctrl.vendorId}}/metadata" then="\n' +
    '    $ctrl.$vendor = $data;\n' +
    '    $ctrl.$form.$setPristine();\n' +
    '    $ctrl.$current = true"></fd-ref><div layout="row" layout-align="center" ng-init="$ctrl.$vendor = {}"><div class="margin padding-half md-whiteframe-2dp container"><vendor-update-action ng-if="$ctrl.UPDATE" vendor="$ctrl.$vendor" vendor-id="$ctrl.vendorId" then="\n' +
    '        $ctrl.UPDATE = false;\n' +
    '        $ctrl.$current = false" catch="$ctrl.UPDATE = false"></vendor-update-action><vendor-remove-action ng-if="$ctrl.REMOVE" vendor-id="$ctrl.vendorId" then="\n' +
    '        $ctrl.REMOVE = false;\n' +
    '        $ctrl.$redirect = true" catch="$ctrl.REMOVE = false"></vendor-remove-action><wc-ui-redirect ng-if="$ctrl.$redirect" wc-ui-redirect-sref="vendor.list"></wc-ui-redirect><vendor-detail ng-if="$ctrl.$vendor" vendor="$ctrl.$vendor" form="$ctrl.$form = $form"></vendor-detail><div ng-if="!$ctrl.$isAdmin" flex="100" layout="row" layout-align="end"><md-button disabled="disabled"><md-icon>visibility</md-icon>READ ONLY</md-button></div><div ng-if="$ctrl.$isAdmin" layout="row"><md-button ng-click="$ctrl.REMOVE = true" class="md-warn">DELETE</md-button><div flex="flex"></div><md-button ng-if="$ctrl.$form.$dirty" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">SAVE</span><span ng-if="$ctrl.$form.$pristine">SAVED</span></md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/_components/displays/displays-vendor.comp.html',
    '<fd-ref fd-ref-path="app/constants/productCategories" then="$ctrl.$categories = $data"></fd-ref><fd-ref ng-if="!$ctrl.$displays" fd-ref-path="vendors/{{$ctrl.vendorId}}/displays" then="\n' +
    '    $ctrl.$displays = $data;\n' +
    '    $ctrl.$displayList = {};"></fd-ref><fd-ref ng-if="$ctrl.$displays &amp;&amp; !$ctrl.$displayList[displayId]" ng-repeat="(displayId, display) in $ctrl.$displays" fd-ref-path="displays/{{displayId}}/metadata" then="$ctrl.$displayList[displayId] = $data"><then></then></fd-ref><fd-ref ng-if="$ctrl.$displays &amp;&amp; $ctrl.$displayList[displayId]" ng-repeat="(displayId, display) in $ctrl.$displays" fd-ref-path="displays/{{displayId}}/products" then="$ctrl.$displayList[displayId].products = $ctrl.$size($data)"></fd-ref><fd-user then="$ctrl.$isRep = $data.isRep"></fd-user><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isRep" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ui-sref="vendor.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ui-sref="display.add({vendorId: $ctrl.vendorId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Display name</span></th><th md-column="md-column"><span>Display notes</span></th><th md-column="md-column"><span>Products</span></th></tr></thead><tbody md-body="md-body"><tr ng-class="{ opacity5: display.pendingApproval }" ng-repeat="(displayId, display) in $ctrl.$displayList" ui-sref="display.update({displayId: displayId, vendorId: $ctrl.vendorId})" md-row="md-row" class="pointer"><td md-cell="md-cell"><p>{{display.displayName}}</p></td><td md-cell="md-cell"><p>{{display.notes}}</p></td><td md-cell="md-cell"><p>{{display.products || \'--\'}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$displays" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a display to this vendor to be able to track multiple products simultaneously.</div><md-button ui-sref="display.add({vendorId: $ctrl.vendorId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This vendor doesn\'t have displays yet.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/_components/detail/detail-vendor.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin || $data.isSubadmin; $ctrl.$isSubadmin = $data.isSubadmin"></fd-user><form name="vendorDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: vendorDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PROFILE INFO</b></div><md-input-container class="no-error-message"><label>Vendor Name</label><input ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.vendor.displayName"/></md-input-container><md-input-container class="no-error-message"><label>Notes</label><textarea ng-disabled="!$ctrl.$isAdmin" rows="3" ng-model="$ctrl.vendor.notes"></textarea></md-input-container><div style="width: 8rem; height: 6rem" layout="row" layout-align="center center" class="relative"><div ng-style="{backgroundImage: \'url(\'+$ctrl.vendor.logoUrl+\')\'}" style="background-color: grey" class="absolute-fill background-image"></div><md-button class="md-icon-button"><md-icon>add_a_photo</md-icon><wc-upload wc-upload-dimensions="{\n' +
    '            width: 800,\n' +
    '            height: 600\n' +
    '          }" then="$ctrl.$photoFile = $file"><then><fd-upload ng-if="$ctrl.$photoFile" fd-upload-file="$ctrl.$photoFile" before="$ctrl.percentage = $progress" then="$ctrl.vendor.logoUrl = $data.url; vendorDetailForm.$setDirty()"><before><wc-dialog wc-dialog-progress="{{$ctrl.percentage}}" wc-dialog-labels="{\n' +
    '                    title: \'Uploading (\' + $ctrl.percentage + \'%)\',\n' +
    '                    body: \'Please wait until image is fully uploaded.\'\n' +
    '                  }"></wc-dialog></before><catch><wc-toast wc-toast-message="Error uploading image"></wc-toast></catch></fd-upload></then></wc-upload></md-button></div></div><div ng-if="$ctrl.$isAdmin &amp;&amp; !$ctrl.$isSubadmin" flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>POINT OF CONTACT</b></div><md-input-container class="no-error-message"><label>Full name</label><input ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.vendor.contactName"/></md-input-container><md-input-container class="no-error-message"><label>Phone</label><input ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.vendor.contactPhone"/></md-input-container><md-input-container class="no-error-message"><label>Email</label><input autocomplete="off" type="email" ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.vendor.contactEmail"/></md-input-container></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/user/_components/detail/detail-user.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref fd-ref-path="vendors" fd-ref-array="rich" then="$ctrl.$vendors = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref fd-ref-path="products" fd-ref-array="rich" then="$ctrl.$products = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref fd-ref-path="products" then="$ctrl.$productsObj = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref fd-ref-path="displays" fd-ref-array="rich" then="$ctrl.$displays = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref fd-ref-path="displays" then="$ctrl.$displaysObj = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref fd-ref-path="users" fd-ref-array="rich" then="$ctrl.$users = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><form name="userDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: userDetailForm})" flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PROFILE INFO</b></div><md-input-container class="no-error-message"><label>User Name</label><input required="required" ng-model="$ctrl.user.displayName"/></md-input-container><md-input-container class="no-error-message"><label>Phone</label><input required="required" ng-model="$ctrl.user.phone"/></md-input-container><md-input-container class="no-error-message"><label>Company</label><input ng-model="$ctrl.user.company"/></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PERMISSIONS</b></div><md-switch ng-model="$ctrl.user.disabled" aria-label="Disable user">Disable user</md-switch><md-input-container class="no-error-message"><label>Role</label><md-select required="required" ng-model="$ctrl.user.role"><md-option ng-if="$ctrl.$isAdmin" value="admin">Admin</md-option><md-option value="subadmin">Subadmin</md-option><md-option value="rep">Representative</md-option><md-option ng-if="$ctrl.$isAdmin" value="vendor">Vendor</md-option></md-select></md-input-container><div ng-if="$ctrl.user.role === \'rep\'"><md-list><div class="md-body-2 padding-h-quarter"><b>DISPLAYS</b></div><md-list-item ng-if="!$ctrl.user.displays"><p class="opacity5">No displays</p></md-list-item><md-list-item ng-if="item" ng-repeat="(displayId, item) in $ctrl.user.displays"><p>{{$ctrl.$displaysObj[displayId].metadata.displayName}}</p><md-button ng-click="$ctrl.user.displays[displayId] = null" class="md-icon-button md-secondary"><md-icon>close</md-icon></md-button></md-list-item></md-list><div style="margin-left: 1rem" layout="row" layout-align="start center" class="padding-v-half"><md-autocomplete flex="flex" placeholder="Search for a display" md-no-cache="true" md-search-text="$ctrl.$displayQuery" md-items="display in $ctrl.$displays | filter: $ctrl.$displayQuery" md-item-text="display.metadata.displayName" md-selected-item-change="$ctrl.newDisplay = display.key" md-require-match="true" class="no-error-message"><md-item-template>{{display.metadata.displayName}}</md-item-template></md-autocomplete><md-button ng-click="$ctrl.user.displays[$ctrl.newDisplay] = true; $ctrl.$addProductsFromDisplay($ctrl.$displaysObj[$ctrl.newDisplay]); $ctrl.$displayQuery = \'\'" class="md-icon-button"><md-icon>add_circle</md-icon></md-button><div class="padding-quarter"></div></div></div><div ng-if="$ctrl.user.role === \'rep\'"><md-list><div class="md-body-2 padding-h-quarter"><b>PRODUCTS</b></div><md-list-item ng-if="!$ctrl.user.products"><p class="opacity5">No products</p></md-list-item><div ui-sortable="ui-sortable" ng-model="$ctrl.productsArray" ui-sortable-update="$ctrl.$updateOrder()"><md-list-item style="cursor: move" ng-repeat="productId in $ctrl.productsArray"><p>{{$ctrl.$productsObj[productId].metadata.displayName}}</p><md-button ng-click="$ctrl.productsArray.splice($index, 1); $ctrl.$updateOrder()" class="md-icon-button md-secondary"><md-icon>close</md-icon></md-button></md-list-item></div></md-list><div style="margin-left: 1rem" layout="row" layout-align="start center" class="padding-v-half"><md-autocomplete flex="flex" placeholder="Search for a product" md-no-cache="true" md-search-text="$ctrl.$productQuery" md-items="product in $ctrl.$products | filter: $ctrl.$productQuery" md-item-text="product.metadata.displayName" md-selected-item-change="$ctrl.newProduct = product.key" md-require-match="true" class="no-error-message"><md-item-template>{{product.metadata.displayName}}</md-item-template></md-autocomplete><md-button ng-click="$ctrl.productsArray.push($ctrl.newProduct); $ctrl.$updateOrder(); $ctrl.$productQuery = \'\'" class="md-icon-button"><md-icon>add_circle</md-icon></md-button><div class="padding-quarter"></div></div></div><div ng-if="$ctrl.user.role !== \'vendor\'" ng-init="$ctrl.user.vendorId = null"></div><div ng-if="$ctrl.user.role === \'vendor\'"><div md-colors="::{color: \'grey-600\'}" class="md-caption grey">Vendors</div><fd-ref ng-if="data" ng-repeat="(vendorId, data) in $ctrl.user.vendors" fd-ref-path="vendors/{{vendorId}}/metadata/displayName" then="$ctrl.$vendorNames[vendorId] = $data"><then layout="row" layout-align="start center"><div layout="column"><span class="padding-h-quarter">{{$ctrl.$vendorNames[vendorId]}}</span></div><div flex="flex"></div><md-button ng-click="$ctrl.user.vendors[vendorId] = null" class="md-accent">REMOVE</md-button></then></fd-ref><md-autocomplete ng-if="!$ctrl.selectedVendor" placeholder="Add a vendor" md-no-cache="true" md-items="vendor in $ctrl.$vendors | filter: $ctrl.$vendorQuery" md-item-text="vendor.metadata.displayName" md-search-text="$ctrl.$vendorQuery" md-selected-item-change="$ctrl.$setVendor(vendor)" md-selected-item="$ctrl.selectedVendor" md-require-match="true" class="no-error-message"><md-item-template>{{vendor.metadata.displayName}}</md-item-template></md-autocomplete><div class="padding-half"></div><fd-ref ng-if="$ctrl.user.repId" fd-ref-path="users/{{$ctrl.user.repId}}/displayName" then="$ctrl.$repName = $data"><then layout="row" layout-align="start center"><div layout="column"><div md-colors="::{color: \'grey-600\'}" class="md-caption grey">Representative</div><span class="padding-h-quarter">{{$ctrl.$repName}}</span></div><div flex="flex"></div><md-button ng-click="$ctrl.user.repId = null" class="md-accent">CHANGE</md-button></then></fd-ref><md-autocomplete ng-if="!$ctrl.user.repId" md-floating-label="Search for a representative" md-no-cache="true" md-items="user in $ctrl.$users | filter: $ctrl.$repQuery" md-item-text="user.displayName" md-search-text="$ctrl.$repQuery" md-selected-item-change="$ctrl.user.repId = user.key" md-require-match="true" class="no-error-message"><md-item-template>{{user.displayName}}</md-item-template></md-autocomplete></div></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/_components/products/products-supplier.comp.html',
    '<fd-ref fd-ref-path="app/constants/productCategories" then="$ctrl.$categories = $data"></fd-ref><fd-ref ng-if="!$ctrl.$products" fd-ref-path="suppliers/{{$ctrl.supplierId}}/products" then="\n' +
    '    $ctrl.$products = $data;\n' +
    '    $ctrl.$productList = {};"></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; !$ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/metadata" then="$ctrl.$productList[productId] = $data"><then></then></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; $ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/sites" then="$ctrl.$productList[productId].sites = $ctrl.$size($data)"></fd-ref><fd-user then="$ctrl.$isRep = $data.isRep"></fd-user><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isRep" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ui-sref="supplier.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ui-sref="product.add({supplierId: $ctrl.supplierId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Product category</span></th><th md-column="md-column"><span>Sites</span></th><!-- th(md-column)span|Days in DRIP--></tr></thead><tbody md-body="md-body"><tr ng-class="{ opacity5: product.pendingApproval }" ng-repeat="(productId, product) in $ctrl.$productList" ui-sref="product.update({productId: productId, supplierId: $ctrl.supplierId})" md-row="md-row" class="pointer"><td md-cell="md-cell"><p>{{product.displayName ? product.displayName : \'Pending Approval\'}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$categories[product.categoryId]}}</p></td><td md-cell="md-cell"><p>{{product.sites}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$products" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a product to this supplier to be able to track its sales and compare it to similar products.</div><md-button ui-sref="product.add({supplierId: $ctrl.supplierId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This supplier doesn\'t have products yet. Please wait until an AATAC representative adds a new product.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/_components/detail/detail-supplier.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><form name="supplierDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: supplierDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PROFILE INFO</b></div><md-input-container class="no-error-message"><label>Supplier Name</label><input ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.supplier.displayName"/></md-input-container><md-input-container class="no-error-message"><label>Email</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.supplier.email"/></md-input-container><md-input-container class="no-error-message"><label>Address</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.supplier.address"/></md-input-container><md-input-container class="no-error-message"><label>Territories</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.supplier.territories"/></md-input-container><md-input-container class="no-error-message"><label>Website</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.supplier.website"/></md-input-container><md-input-container class="no-error-message"><label>Notes</label><textarea ng-disabled="!$ctrl.$isAdmin" rows="3" ng-model="$ctrl.supplier.notes"></textarea></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>POINT OF CONTACT</b></div><md-input-container class="no-error-message"><label>Full name</label><input ng-model="$ctrl.supplier.contactName"/></md-input-container><md-input-container class="no-error-message"><label>Phone</label><input ng-model="$ctrl.supplier.contactPhone"/></md-input-container></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/_components/metadata/metadata-supplier.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="$ctrl.supplierId &amp;&amp; !$ctrl.$current" fd-ref-path="suppliers/{{$ctrl.supplierId}}/metadata" then="\n' +
    '    $ctrl.$supplier = $data;\n' +
    '    $ctrl.$form.$setPristine();\n' +
    '    $ctrl.$current = true"></fd-ref><div layout="row" layout-align="center" ng-init="$ctrl.$supplier = {}"><div class="margin padding-half md-whiteframe-2dp container"><supplier-update-action ng-if="$ctrl.UPDATE" supplier="$ctrl.$supplier" supplier-id="$ctrl.supplierId" then="\n' +
    '        $ctrl.UPDATE = false;\n' +
    '        $ctrl.$current = false" catch="$ctrl.UPDATE = false"></supplier-update-action><supplier-remove-action ng-if="$ctrl.REMOVE" supplier-id="$ctrl.supplierId" then="\n' +
    '        $ctrl.REMOVE = false;\n' +
    '        $ctrl.$redirect = true" catch="$ctrl.REMOVE = false"></supplier-remove-action><wc-ui-redirect ng-if="$ctrl.$redirect" wc-ui-redirect-sref="supplier.list"></wc-ui-redirect><supplier-detail ng-if="$ctrl.$supplier" supplier="$ctrl.$supplier" form="$ctrl.$form = $form"></supplier-detail><div ng-if="!$ctrl.$isAdmin" flex="100" layout="row" layout-align="end"><md-button disabled="disabled"><md-icon>visibility</md-icon>READ ONLY</md-button></div><div ng-if="$ctrl.$isAdmin" layout="row"><md-button ng-click="$ctrl.REMOVE = true" class="md-warn">DELETE</md-button><div flex="flex"></div><md-button ng-if="$ctrl.$form.$dirty" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">SAVE</span><span ng-if="$ctrl.$form.$pristine">SAVED</span></md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/products/products-site.comp.html',
    '<fd-ref fd-ref-path="app/constants/productCategories" then="$ctrl.$categories = $data"></fd-ref><fd-ref fd-ref-path="sites/{{$ctrl.siteId}}/products" then="\n' +
    '    $ctrl.$products = $data;\n' +
    '    $ctrl.$productList = {}"><then><fd-ref ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}" then="\n' +
    '        $ctrl.$productList[productId] = $data.metadataApproval || $data.metadata;\n' +
    '        $ctrl.$productList[productId].registrationDate = $ctrl.$products[productId].registration.date"></fd-ref></then></fd-ref><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$userProducts = $data.products"><then><div ng-init="$ctrl.$delete(productId, $ctrl.$products); $ctrl.$delete(productId, $ctrl.$productList)" ng-if="!(($ctrl.$products[productId].registrationApproval || $ctrl.$products[productId].registration).userId === $ctrl.$userId || $ctrl.$isAdmin || $ctrl.$isVendor)" ng-repeat="(productId, product) in $ctrl.$productList"></div></then></fd-user><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-if="!$ctrl.$isSubadmin" ng-hide="$ctrl.$query" ui-sref="site.addDisplay({ siteId: $ctrl.siteId })"><div layout="row" layout-align="center center"><md-icon>add</md-icon><span>ADD DISPLAY</span></div></md-button><md-button ng-hide="$ctrl.$query" ui-sref="site.addProducts({ siteId: $ctrl.siteId })" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon><span>ADD PRODUCTS</span></div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Registration date</span></th><th md-column="md-column"><span>Registered by</span></th><th md-column="md-column"><span>Contact name</span></th><th md-column="md-column"><span>Supplier</span></th><th md-column="md-column"><span>Reviews</span></th><th md-column="md-column"><span>Registration</span></th><th md-column="md-column"><span>Add review</span></th></tr></thead><tbody md-body="md-body"><tr ng-class="{ opacity5: $ctrl.$products[productId].registration.pendingApproval }" ng-repeat="product in $ctrl.$sort($ctrl.$productList, \'registrationDate\')" ui-sref="product.update({productId: product.$id})" md-row="md-row" class="pointer"><td md-cell="md-cell"><p>{{product.displayName}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !$ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registration.date | date}}</p><p ng-if="$ctrl.$isRep &amp;&amp; $ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registrationApproval.date | date}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !$ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registration.agent.displayName}}</p><p ng-if="$ctrl.$isRep &amp;&amp; $ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registrationApproval.agent.displayName}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !$ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registration.contact.displayName}}</p><p ng-if="$ctrl.$isRep &amp;&amp; $ctrl.$products[product.$id].registrationApproval">{{$ctrl.$products[product.$id].registrationApproval.contact.displayName}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="suppliers/{{$ctrl.$products[product.$id].registration.supplierId}}/metadata/displayName" then="$displayName = $data"><then><P>{{$displayName}}</P></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="products/{{product.$id}}/reviews" then="$ctrl.$countReviews($data, product.$id, $ctrl.siteId)"><then><p>{{$ctrl.$reviewLengths[product.$id]}}</p></then></fd-ref></td><td md-cell="md-cell"><md-button ng-click="$event.stopPropagation()" ui-sref="site.updateProduct({productId: product.$id, siteId: $ctrl.siteId})" class="md-icon-button"><md-tooltip>Product registration</md-tooltip><md-icon>assignment</md-icon></md-button></td><td md-cell="md-cell"><fd-ref fd-ref-path="products/{{product.$id}}/metadata/vendorId" then="$vendorId = $data"><then><md-button ng-click="$event.stopPropagation()" ui-sref="review.add({productId: product.$id, vendorId: $vendorId, siteId: $ctrl.siteId})" class="md-icon-button"><md-icon>post_add</md-icon></md-button></then></fd-ref></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl._($ctrl.$products).size()" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a product to this site.</div><md-button ui-sref="site.addProduct({ siteId: $ctrl.siteId })" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/suppliers/suppliers-site.comp.html',
    '<fd-ref fd-ref-path="sites/{{$ctrl.siteId}}/suppliers" then="\n' +
    '    $ctrl.$siteSuppliers = $data || {};\n' +
    '    $ctrl.$supplierList = $ctrl._($data).keys()"></fd-ref><fd-ref fd-ref-path="suppliers" then="$ctrl.$suppliersObj = $data"></fd-ref><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;"></fd-user><site-update-suppliers-action ng-if="$ctrl.UPDATE" site-id="$ctrl.siteId" suppliers="$ctrl.UPDATE" then="$ctrl.UPDATE = false" catch="$ctrl.UPDATE = false"></site-update-suppliers-action><supplier-add-action ng-if="$ctrl.CREATE_SUPPLIER" supplier="$ctrl.$newSupplier" then="$ctrl.CREATE_SUPPLIER = false; $ctrl.$isAddingSupplier = false; $ctrl.$newSupplier.displayName = \'\'; $ctrl.$supplierQuery = \'\'; $ctrl.UPDATE = $ctrl.addSupplier($data, $ctrl.$siteSuppliers);" catch="$ctrl.CREATE_SUPPLIER = false"></supplier-add-action><fd-ref fd-ref-path="suppliers" then="$ctrl.$suppliersObj = $data;"><before></before></fd-ref><fd-ref fd-ref-path="suppliers" fd-ref-array="rich" then="$ctrl.$suppliers = $data; $ctrl.$autocompleteSuppliers = []"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><div ng-if="supplier.metadata.displayName" ng-init="$ctrl.$autocompleteSuppliers.push(supplier)" ng-repeat="supplier in $ctrl.$suppliers"></div></then></fd-ref><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div layout="row" layout-align="start center" class="md-toolbar-tools"><div flex="flex"></div><div ng-if="$ctrl.$autocompleteSuppliers" layout="row" layout-align="start center"><md-autocomplete flex="flex" ng-init="$ctrl.$supplierQuery = $ctrl.$supplierQuery || $ctrl.$suppliersObj[$ctrl.newSupplier].metadata.displayName" placeholder="Add distibutor to site" md-no-cache="true" md-min-length="2" md-items="supplier in $ctrl.$autocompleteSuppliers | filter: $ctrl.$supplierQuery" md-item-text="supplier.metadata.displayName" md-search-text="$ctrl.$supplierQuery" md-selected-item-change="$ctrl.newSupplier = supplier.key" md-require-match="true" class="no-error-message md-body-1"><md-item-template>{{supplier.metadata.displayName}}</md-item-template></md-autocomplete><md-button ng-if="$ctrl.newSupplier" ng-click="$ctrl.UPDATE = $ctrl.addSupplier($ctrl.newSupplier, $ctrl.$siteSuppliers); $ctrl.$supplierQuery = \'\'" class="md-raised md-primary"><md-icon>add</md-icon>Add</md-button><md-button ng-if="!$ctrl.newSupplier &amp;&amp; $ctrl.$supplierQuery" ng-click="$ctrl.$newSupplier.displayName = $ctrl.$supplierQuery; $ctrl.CREATE_SUPPLIER = true" class="md-raised md-primary"><md-icon>add</md-icon>Create</md-button></div></div></md-toolbar><md-divider></md-divider><md-table-container><!-- supplierS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Distributor name</span></th><th md-column="md-column"></th></tr></thead><tbody md-body="md-body"><tr ng-repeat="(supplierId, supplier) in $ctrl.$siteSuppliers" md-row="md-row"><td md-cell="md-cell" class="pointer"><p>{{$ctrl.$suppliersObj[supplierId].metadata.displayName}}</p></td><td md-cell="md-cell"><md-button ng-click="$ctrl.UPDATE = $ctrl.removeSupplier(supplierId, $ctrl.$siteSuppliers)" class="md-icon-button"><md-icon>delete</md-icon></md-button></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl._($ctrl.$siteSuppliers).size()" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a distributor to this site.</div><div class="md-body-1 center">Start typing the name of the distributor in the upper right to add a new supplier to this site</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/productRegistration/productRegistration-site.comp.html',
    '<fd-user then="\n' +
    '    $ctrl.$user = $data;\n' +
    '    $ctrl.$isAdmin = $data.isAdmin;\n' +
    '    $ctrl.$isRep = $data.isRep;\n' +
    '    $ctrl.registration.agent.displayName = $ctrl.registration.agent.displayName || $ctrl.$user.displayName;\n' +
    '    $ctrl.registration.agent.phone = $ctrl.registration.agent.phone || $ctrl.$user.phone"></fd-user><form name="registrationDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: registrationDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><md-input-container ng-show="$ctrl.$isAdmin" ng-init="\n' +
    '        $ctrl.creationDate = $ctrl.newDate($ctrl.registration.date);\n' +
    '        $ctrl.registration.date = $ctrl.registration.date || $ctrl.creationDate.getTime()" class="no-error-message"><label>Registration date</label><md-datepicker ng-model="$ctrl.creationDate" ng-change="$ctrl.registration.date = $ctrl.creationDate.getTime()"></md-datepicker></md-input-container><md-input-container ng-show="$ctrl.$isAdmin" class="no-error-message"><label>Rep Name</label><input required="required" ng-model="$ctrl.registration.agent.displayName"/></md-input-container><md-input-container ng-show="$ctrl.$isAdmin" class="no-error-message"><label>Rep Telephone</label><input required="required" ng-model="$ctrl.registration.agent.phone"/></md-input-container><md-input-container class="no-error-message"><label>Store Contact Name</label><input required="required" ng-disabled="!$ctrl.$isRep" ng-model="$ctrl.registration.contact.displayName"/></md-input-container><md-input-container class="no-error-message"><label>Store Contact Telephone</label><input ng-disabled="!$ctrl.$isRep" ng-model="$ctrl.registration.contact.phone"/></md-input-container><md-input-container class="no-error-message"><label>Add any notes for this product at this site</label><textarea rows="3" ng-disabled="!$ctrl.$isAdmin &amp;&amp; ($ctrl.isApproval || ($ctrl.registration.isApproved &amp;&amp; !$ctrl.$isRep))" ng-model="$ctrl.registration.notes"></textarea></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div layout="row" layout-align="start center" class="md-body-2 padding-v-half"><b>IMAGES</b><div flex="flex"></div><md-button ng-if="$ctrl.$isRep || !($ctrl.isApproval || ($ctrl.registration.isApproved &amp;&amp; !$ctrl.$isRep))" class="md-icon-button relative"><md-icon>add_a_photo</md-icon><input ngf-select="$ctrl.$photoFiles = $files" ngf-multiple="true" ngf-fix-orientation="true" ngf-accept="\'image/*\'" ngf-resize="{\n' +
    '            width: 800,\n' +
    '            height: 600\n' +
    '          }" class="hidden-input"/><fd-upload ng-repeat="$file in $ctrl.$photoFiles" fd-upload-file="$file" before="$ctrl.percentage = $progress" then="$ctrl.registration.gallery.push($data.url)"><before><wc-dialog wc-dialog-progress="{{$ctrl.percentage}}" wc-dialog-labels="{\n' +
    '                title: \'Uploading (\' + $ctrl.percentage + \'%)\',\n' +
    '                body: \'Please wait until image is fully uploaded.\'\n' +
    '              }"></wc-dialog></before><catch><wc-toast wc-toast-message="Error uploading image"></wc-toast></catch></fd-upload></md-button></div><div ng-init="$ctrl.registration.gallery = $ctrl.registration.gallery || []" layout="row" layout-align="center" class="margin-quarter"><div flex="50"><div ng-click="" ng-repeat="image in $ctrl.registration.gallery" class="ratio-4-3 margin-quarter pointer relative"><div ng-style="{ backgroundImage: \'url(\'+image+\')\', transform: \'rotate(\'+($ctrl.registration.galleryRotation[$index] || 0)+\'deg)\' }" ng-click="$ctrl.IMAGE_EXPANDED = image; $ctrl.EXPANDED_ROTATION = $ctrl.registration.galleryRotation[$index] || 0" class="absolute-fill background-image"></div><md-button style="position:absolute; top: 0; right: 56px" ng-click="$ctrl.registration.galleryRotation[$index] = ($ctrl.registration.galleryRotation[$index] || 0) - 90" class="md-icon-button margin-half md-primary"><md-icon>rotate_left</md-icon></md-button><md-button style="position:absolute; top: 0; right: 28px" ng-click="$ctrl.registration.galleryRotation[$index] = ($ctrl.registration.galleryRotation[$index] || 0) + 90" class="md-icon-button margin-half md-primary"><md-icon>rotate_right</md-icon></md-button><md-button ng-if="$ctrl.$isRep" style="position:absolute; top: 0; right: 0" ng-click="$ctrl.registration.gallery.splice($index, 1)" class="md-icon-button margin-half md-primary"><md-icon>delete</md-icon></md-button></div></div></div><wc-dialog ng-if="$ctrl.IMAGE_EXPANDED" wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.IMAGE_EXPANDED = false"><wc-dialog-template><img ng-src="{{$ctrl.IMAGE_EXPANDED}}" ng-style="{transform: \'rotate(\'+$ctrl.EXPANDED_ROTATION+\'deg)\'}"/></wc-dialog-template></wc-dialog></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/productMetadata/productMetadata-site.comp.html',
    '<fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$userVendor = $data.vendorId;"><then><fd-ref fd-ref-path="sites/{{$ctrl.siteId}}/products/{{$ctrl.productId}}/{{$ctrl.$isRep ? \'registrationApproval\' : \'registration\'}}" then="\n' +
    '        $ctrl.$registration = $data;\n' +
    '        $ctrl.$isApproval = $data.pendingApproval"><then><fd-ref ng-if="!$ctrl.$registration" fd-ref-path="sites/{{$ctrl.siteId}}/products/{{$ctrl.productId}}/registration" then="\n' +
    '            $ctrl.$registration = $data"></fd-ref></then></fd-ref></then></fd-user><site-update-product-action ng-if="$ctrl.UPDATE" product-id="$ctrl.productId" site-id="$ctrl.siteId" supplier-id="$ctrl.supplierId" registration="$ctrl.$registration" then="$ctrl.UPDATE = false;" catch="$ctrl.UPDATE = false"></site-update-product-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="site.update" wc-ui-redirect-params="{ siteId: $ctrl.siteId }"></wc-ui-redirect><div layout="row" layout-align="center"><div class="margin padding-half md-whiteframe-2dp container"><site-product-registration ng-if="$ctrl.$registration" registration="$ctrl.$registration" form="$ctrl.$form = $form"></site-product-registration><div layout="row"><md-button ng-if="!$ctrl.$isRep &amp;&amp; !$ctrl.$userVendor" ui-sref="site.update({siteId: $ctrl.siteId})"><md-icon>arrow_back</md-icon><span class="padding-h-quarter">BACK</span></md-button><md-button ng-if="$ctrl.$isAdmin" ng-click="$ctrl.$deleteRegistration()"><md-icon>delete</md-icon><span class="padding-h-quarter">DELETE REGISTRATION</span></md-button><div flex="flex"></div><md-button ng-if="$ctrl.$isRep" ui-sref="site.update({siteId: $ctrl.siteId})">CANCEL</md-button><md-button disabled="disabled" ng-if="!$ctrl.$isRep"><md-icon>visibility</md-icon><span class="padding-h-quarter">READ ONLY</span></md-button><md-button ng-disabled="$ctrl.$form.$invalid || !$ctrl.productId" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary">UPDATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/metadata/metadata-site.comp.html',
    '<fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$userVendors = $data.vendors;"><then><fd-ref ng-if="$ctrl.siteId &amp;&amp; !$ctrl.$current &amp;&amp; $ctrl.$userVendors" fd-ref-path="sites/{{$ctrl.siteId}}/metadata" then="\n' +
    '        $ctrl.$site = $data || {};\n' +
    '        $ctrl.$form.$setPristine();\n' +
    '        $ctrl.$current = true"></fd-ref><fd-ref ng-if="$ctrl.siteId &amp;&amp; !$ctrl.$current &amp;&amp; !$ctrl.$userVendors" fd-ref-path="sites/{{$ctrl.siteId}}/metadataApproval" then="\n' +
    '        $ctrl.$site = $data;\n' +
    '        $ctrl.$form.$setPristine();\n' +
    '        $ctrl.$current = $ctrl.$site"><then><fd-ref ng-if="!$ctrl.$site" fd-ref-path="sites/{{$ctrl.siteId}}/metadata" then="\n' +
    '            $ctrl.$site = $data || {};\n' +
    '            $ctrl.$form.$setPristine();\n' +
    '            $ctrl.$current = true"></fd-ref></then></fd-ref></then></fd-user><div layout="row" layout-align="center"><div class="margin padding-half md-whiteframe-2dp container"><site-update-action ng-if="$ctrl.UPDATE" site="$ctrl.$site" site-id="$ctrl.siteId" then="\n' +
    '        $ctrl.UPDATE = false;\n' +
    '        $ctrl.$current = false" catch="$ctrl.UPDATE = false"></site-update-action><site-remove-action ng-if="$ctrl.REMOVE" site="$ctrl.$site" site-id="$ctrl.siteId" then="\n' +
    '        $ctrl.REMOVE = false;\n' +
    '        $ctrl.$current = false;\n' +
    '        $ctrl.REDIRECT_BACK = true" catch="$ctrl.REMOVE = false"></site-remove-action><wc-ui-redirect ng-if="$ctrl.REDIRECT_BACK" wc-ui-redirect-sref="site.list"></wc-ui-redirect><site-detail ng-if="$ctrl.$site" site="$ctrl.$site" site-id="$ctrl.$siteId" is-disabled="$ctrl.$userVendors" form="$ctrl.$form = $form"></site-detail><div layout="row"><md-button ng-if="$ctrl.$isAdmin" ng-click="$ctrl.REMOVE = true" class="md-warn">DELETE</md-button><div flex="flex"></div><md-button ng-hide="$ctrl.$userVendors" ng-if="$ctrl.$form.$dirty" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button disabled="disabled" ng-show="$ctrl.$userVendors" class="md-raised md-primary"><md-icon>visibility</md-icon>READ ONLY</md-button><md-button ng-hide="$ctrl.$userVendors" ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">SAVE</span><span ng-if="$ctrl.$form.$pristine">SAVED</span></md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/_components/detail/detail-site.comp.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$siteId = $data.siteId;"></wc-ui-params><fd-ref ng-if="$ctrl.approvalId" fd-ref-path="approval/siteUpdate/{{$ctrl.approvalId}}/diff" then="$ctrl.$approvals = $ctrl.$invert($data)"></fd-ref><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin; $ctrl.$isRep = $data.isRep; $ctrl.$teamId = $data.teamId"></fd-user><form name="siteDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: siteDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PROFILE INFO</b></div><md-input-container ng-show="$ctrl.$approvals.displayName || !$ctrl.$approvals" class="no-error-message"><label>Site Name</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.displayName" class="capitalize"/></md-input-container><div layout="row"><md-input-container flex="flex" ng-show="$ctrl.$approvals.tier || !$ctrl.$approvals" ng-if="$ctrl.$isRep" class="no-error-message"><label>Tier</label><md-select required="required" ng-disabled="!$ctrl.$isAdmin &amp;&amp; $ctrl.site.tierSet" ng-model="$ctrl.site.tier"><md-option value="tier1">Tier 1</md-option><md-option value="tier2">Tier 2</md-option><md-option value="tier3">Tier 3</md-option><md-option value="tier4">Tier 4</md-option></md-select></md-input-container><md-button ng-if="!$ctrl.$isAdmin &amp;&amp; $ctrl.$isRep &amp;&amp; $ctrl.site.tierSet" ng-click="$ctrl.CHANGE = true">Change</md-button><wc-dialog ng-if="$ctrl.CHANGE" wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.CHANGE = false"><wc-dialog-template class="relative"><div layout="column" class="padding-half"><div class="md-title">Change tier</div><div ng-if="!$ctrl.$isAdmin" class="md-body-1 opacity75">An admin will be notified if you change the tier type.</div><br/><md-input-container flex="flex" ng-init="$ctrl.newTier = $ctrl.site.tier" ng-show="$ctrl.$approvals.tier || !$ctrl.$approvals" ng-if="$ctrl.$isRep" class="no-error-message"><label>New tier</label><md-select required="required" ng-model="$ctrl.newTier"><md-option value="tier1">Tier 1</md-option><md-option value="tier2">Tier 2</md-option><md-option value="tier3">Tier 3</md-option><md-option value="tier4">Tier 4</md-option></md-select></md-input-container></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.CHANGE = false">Cancel</md-button><md-button ng-click="$ctrl.CHANGE = false; $ctrl.$updateTier($ctrl.newTier, $ctrl.site, $ctrl.$siteId, $ctrl.$userId, $ctrl.$isAdmin)" class="md-primary md-raised">Change</md-button></div></wc-dialog-template></wc-dialog></div><md-input-container ng-show="$ctrl.$approvals.notes || !$ctrl.$approvals" class="no-error-message"><label>Notes</label><textarea ng-readonly="$ctrl.isDisabled" autocomplete="false" rows="3" ng-model="$ctrl.site.notes"></textarea></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" ng-if="$ctrl.$isAdmin" class="padding-half"><div class="md-body-2 padding-v-half"><b>LOCATION OWNER OPERATOR</b></div><md-input-container ng-show="$ctrl.$approvals[\'contactName\'] || !$ctrl.$approvals" class="no-error-message"><label>Full name</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.contactName"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'contactPhone\'] || !$ctrl.$approvals" class="no-error-message"><label>Store phone</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.contactPhone"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'email\'] || !$ctrl.$approvals" class="no-error-message"><label>Store email</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" ng-model="$ctrl.site.email"/></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>ADDRESS</b></div><md-input-container ng-show="$ctrl.$approvals[\'address.address1\'] || !$ctrl.$approvals" class="no-error-message"><label>Main Adress</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.address.address1" class="capitalize"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'address.address2\'] || !$ctrl.$approvals" class="no-error-message"><label>Unit, Apartment, House</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" ng-model="$ctrl.site.address.address2" class="capitalize"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'address.city\'] || !$ctrl.$approvals" class="no-error-message"><label>City</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.address.city" class="capitalize"/></md-input-container><div layout="row"><md-input-container flex="50" ng-show="$ctrl.$approvals[\'address.state\'] || !$ctrl.$approvals" class="no-error-message"><label>State</label><md-select ng-disabled="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.address.state"><md-option ng-value="state" ng-repeat="state in $ctrl.$states"><div class="uppercase">{{state}}</div></md-option></md-select></md-input-container><md-input-container flex="50" ng-show="$ctrl.$approvals[\'address.zip\'] || !$ctrl.$approvals" class="no-error-message"><label>Zip Code</label><input ng-readonly="$ctrl.isDisabled" autocomplete="false" required="required" ng-model="$ctrl.site.address.zip"/></md-input-container></div></div><div ng-if="$ctrl.checkAddress" flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><fd-ref fd-ref-path="sites" fd-ref-array="rich" then="$ctrl.$sites = $data"></fd-ref><div ng-if="$ctrl.site.address.address1.length &gt; 3"><div ng-repeat-start="site in $ctrl.$sites | filter : {metadata: {address: {address1: $ctrl.site.address.address1}}}" class="md-body-2 padding-v-half"><b>Are you refering to this location?</b></div><div ng-repeat-end="ng-repeat-end" layout="row" layout-align="start center"><div flex="flex" class="md-body-1">{{site.metadata.displayName}} - {{site.metadata.address.address1}} {{site.metadata.address.address2}}, {{site.metadata.address.city}}</div><md-button ng-click="$ctrl.$claimSite(site.key, $ctrl.$userId, $ctrl.$teamId)" class="md-raised md-primary">USE</md-button></div></div></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/review/_components/detail/detail-review.comp.html',
    '<fd-user then="$ctrl.$user = $data; $ctrl.$isAdmin = $data.isAdmin; $ctrl.$isRep = $data.isRep"></fd-user><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><wc-ui-params then="$ctrl.$siteId=$data.siteId"></wc-ui-params><div ng-if="$ctrl.$siteId" ng-init="$ctrl.review.siteId = $ctrl.$siteId"></div><form name="reviewDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: reviewDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PRODUCT PERFORMANCE</b></div><md-input-container ng-show="$ctrl.$isAdmin" ng-init="$ctrl.creationDate = $ctrl.newDate($ctrl.review.date)" class="no-error-message"><label>Review date</label><md-datepicker ng-model="$ctrl.creationDate" ng-change="$ctrl.review.date = $ctrl.creationDate.getTime()"></md-datepicker></md-input-container><fd-ref ng-if="$ctrl.$user" fd-ref-path="products/{{$ctrl.productId}}/sites" then="$sites = $data; $ctrl.$getSites($sites)"></fd-ref><fd-ref ng-if="$ctrl.review.siteId" fd-ref-path="sites/{{$ctrl.review.siteId}}/metadata" then="$ctrl.$site = $data"></fd-ref><a ng-if="!$ctrl.$isRep" ui-sref="site.update({siteId: $ctrl.review.siteId})" class="md-body-1 padding-v">{{$ctrl.$site.displayName}} - {{$ctrl.$site.address.address1}}, {{$ctrl.$site.address.city}}, {{$ctrl.$site.metadata.address.state}}</a><md-autocomplete ng-if="$ctrl.$isRep &amp;&amp; $ctrl.$autocompleteSites" required="required" md-floating-label="Search for a site" md-no-cache="true" md-min-length="2" md-items="site in $ctrl.$autocompleteSites | filter: $ctrl.$query" md-item-text="site.displayName + \' - \' + site.address.address1 + \', \' + site.address.city + \', \' + site.address.state" md-search-text="$ctrl.$query" md-selected-item-change="$ctrl.review.siteId = site.key" md-selected-item="$ctrl.$sites[$ctrl.review.siteId]" md-require-match="true" class="no-error-message"><md-item-template>{{site.displayName}} - {{site.address.address1}}, {{site.address.city}}, {{site.metadata.address.state}}</md-item-template></md-autocomplete><!--md-input-container.no-error-messagelabel|Site\n' +
    'md-select(\n' +
    '  ng-model="$ctrl.review.siteId")\n' +
    '  md-option(\n' +
    '    ng-repeat="(siteId, site) in $ctrl.$sites"\n' +
    '    ng-value="siteId")\n' +
    '    |{{site}}--><md-input-container class="no-error-message"><label>Units sold</label><input type="number" required="required" ng-model="$ctrl.review.amount"/></md-input-container><md-input-container class="no-error-message"><label>Notes</label><textarea rows="3" ng-model="$ctrl.review.notes"></textarea></md-input-container><div class="padding-half"><div layout="row" layout-align="start center" class="md-body-2 padding-v-half"><b>IMAGES</b><div flex="flex"></div></div><div ng-if="$ctrl.review.gallery" layout="row" layout-align="center" class="margin-quarter"><div flex="50"><div ng-repeat="image in $ctrl.review.gallery" ng-style="{ backgroundImage: \'url(\'+image+\')\' }" class="background-image ratio-4-3 margin-quarter"></div></div></div></div></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/_components/sites/sites-product.comp.html',
    '<wc-ui-params then="$ctrl.query = $data.query; $ctrl.$query = $data.query;"></wc-ui-params><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="\n' +
    '  $ctrl.$isReady = true;\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$teamId = $data.teamId;\n' +
    '  $ctrl.$isVendor = $data.vendorId || $data.vendors;\n' +
    '  $ctrl.$loadSites()"></fd-user><div style="min-height: 80vh" layout="row" layout-align="center stretch" class="padding-half"><md-virtual-repeat-container class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a site" ng-model="$ctrl.$query" ng-blur="$ctrl.$updateSearch($ctrl.$query)"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$updateSearch($ctrl.$query)" class="md-primary md-raised">SEARCH</md-button><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'; $ctrl.$updateSearch($ctrl.$query)" class="md-icon-button"><md-icon>cancel</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-subheader ng-if="$ctrl.$isRep" class="md-no-sticky"><div layout="row"><span>TOTAL SITES</span><div flex="flex"></div><span>{{$ctrl.$totalSites}}</span></div></md-subheader><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Site name</span></th><!--th(md-column)span|Contact name--><!--th(md-column)span|Contact phone--><th md-column="md-column"><span>Address</span></th><th md-column="md-column"><span>Site Id</span></th><th md-column="md-column"></th></tr></thead><tbody md-body="md-body"><tr md-virtual-repeat="site in $ctrl.$toArray($ctrl.$sites) | filter: $ctrl.$query" md-item-size="66" ng-click="$ctrl.$go(site)" md-row="md-row" class="pointer"><td md-cell="md-cell"><p class="md-truncate">{{site.displayName}}</p></td><!--td(md-cell)p|{{site.contactName}}--><!--td(md-cell)p|{{site.contactPhone}}--><td md-cell="md-cell" style="width: 40%"><p class="md-truncate">{{site.address.address1}} {{site.address.address2}}, {{site.address.city}}, {{site.address.state}} {{site.address.zip}}</p></td><td md-cell="md-cell"><p class="md-truncate">{{site.key}}</p></td><td md-cell="md-cell"> <md-button ng-click="$event.stopPropagation()" ui-sref="site.updateProduct({productId: $ctrl.productId, siteId: site.key})" class="md-icon-button"><md-tooltip>Product registration</md-tooltip><md-icon>assignment</md-icon></md-button></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$sites" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add sites to this product</div><md-button ui-sref="site.list" class="md-raised md-primary">VIEW SITES</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep &amp;&amp; $ctrl.$isReady" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This product has not been registered in any site. Please wait until it is registered by an AATAC representative.</div><p></p></div></div></md-table-container></md-virtual-repeat-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/_components/reviews/reviews-product.comp.html',
    '<fd-user then="$ctrl.$isRep = $data.isRep; $ctrl.$isAdmin = $data.isAdmin; $ctrl.$isSubadmin = $data.isSubadmin"></fd-user><wc-ui-params then="\n' +
    '    $ctrl.$siteId=$data.siteId;\n' +
    '    $ctrl.$vendorId=$data.vendorId"></wc-ui-params><fd-ref fd-ref-path="products/{{$ctrl.productId}}/metadata/price" then="$ctrl.$productPrice = $data"></fd-ref><fd-ref ng-init="$ctrl.$reviews = []" fd-ref-path="products/{{$ctrl.productId}}/reviews" fd-ref-array="rich" then="$reviews = $data.reverse()"><then><div ng-repeat="review in $ctrl.$reviews" ng-if="!review.review" ng-init="$ctrl.$reviews.splice($index, 1)"></div><fd-ref ng-repeat="review in $reviews" fd-ref-path="reviews/{{review.key}}" then="$ctrl.$reviews[$index] = $data"><then><fd-ref fd-ref-path="sites/{{$ctrl.$reviews[$index].siteId}}/metadata" then="$ctrl.$reviews[$index].siteName = $data.displayName || null; $ctrl.$reviews[$index].siteAddress = $data.address.address1 || null; $ctrl.$reviews[$index].siteZip = $data.address.zip || null; $ctrl.$reviews[$index].siteCity = $data.address.city || null; $ctrl.$reviews[$index].key = review.key"></fd-ref></then></fd-ref></then></fd-ref><fd-ref ng-init="$ctrl.$reviewsApproval = []" fd-ref-path="products/{{$ctrl.productId}}/reviewsApproval" fd-ref-array="rich" then="$reviewsApproval = $data.reverse()"><then><div ng-repeat="review in $ctrl.$reviewsApproval" ng-if="!review.review" ng-init="$ctrl.$reviewsApproval.splice($index, 1)"></div><fd-ref ng-repeat="review in $reviewsApproval" fd-ref-path="reviews/{{review.key}}" then="$ctrl.$reviewsApproval[$index] = $data"><then><fd-ref fd-ref-path="sites/{{$ctrl.$reviewsApproval[$index].siteId}}/metadata/displayName" then="$ctrl.$reviewsApproval[$index].siteName = $data || null; $ctrl.$reviewsApproval[$index].key = review.key"></fd-ref></then></fd-ref></then></fd-ref><review-remove-action ng-if="$ctrl.REMOVE" review-id="$ctrl.REMOVE" then="$ctrl.REMOVE = false" catch="$ctrl.REMOVE = false"></review-remove-action><product-upload-reviews ng-if="$ctrl.UPLOAD_REVIEWS" product-id="$ctrl.productId" then="$ctrl.UPLOAD_REVIEWS = false" catch="$ctrl.UPLOAD_REVIEWS = false"></product-upload-reviews><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isRep" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ng-click="$ctrl.UPLOAD_REVIEWS = true" hide-xs="hide-xs"><div layout="row" layout-align="center center"><md-icon>file_upload</md-icon>UPLOAD REVIEWS</div></md-button><md-button ng-hide="$ctrl.$query" ui-sref="review.add({productId: $ctrl.productId, vendorId: $ctrl.$vendorId, siteId: $ctrl.$siteId})" hide-gt-xs="hide-gt-xs"><div layout="row" layout-align="center center"><md-icon>add</md-icon>ADD REVIEW</div></md-button><md-button ng-hide="$ctrl.$query" ui-sref="review.add({productId: $ctrl.productId, vendorId: $ctrl.$vendorId, siteId: $ctrl.$siteId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>ADD REVIEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column" ng-if="$ctrl.$isRep"><span>Review date</span></th><th md-column="md-column"><span>Site name</span></th><th md-column="md-column"><span>Site address</span></th><th md-column="md-column"><span>Site zip</span></th><th md-column="md-column"><span>Site city</span></th><th md-column="md-column"><span>Units sold</span></th><th md-column="md-column"><span>Sales</span></th><th md-column="md-column"><span>Notes</span></th></tr></thead><tbody md-body="md-body"><tr ng-repeat="review in $ctrl.$reviewsApproval | filter: $ctrl.$query" md-row="md-row" class="opacity5"><td md-cell="md-cell" ng-if="$ctrl.$isRep"><p>{{review.review.date | date}}</p></td><td md-cell="md-cell"><p>{{review.siteName}}</p></td><td md-cell="md-cell"><p>{{review.siteAddress}}</p></td><td md-cell="md-cell"><p>{{review.siteZip}}</p></td><td md-cell="md-cell"><p>{{review.review.amount}}</p></td><td md-cell="md-cell"><p>{{review.review.amount * $ctrl.$productPrice | currency}}</p></td></tr><tr ng-repeat="review in $ctrl.$reviews | filter: $ctrl.$query" md-row="md-row"><td md-cell="md-cell" ng-if="$ctrl.$isRep"><p>{{review.review.date | date}}</p></td><td md-cell="md-cell"><p><a ui-sref="review.update({reviewId: review.key})">{{review.siteName}}</a></p></td><td md-cell="md-cell" style="min-width: 10rem"><p>{{review.siteAddress}}</p></td><td md-cell="md-cell"><p>{{review.siteZip}}</p></td><td md-cell="md-cell"><p>{{review.siteCity}}</p></td><td md-cell="md-cell"><p>{{review.review.amount}}</p></td><td md-cell="md-cell"><p>{{review.review.amount * $ctrl.$productPrice | currency}}</p></td><td md-cell="md-cell" style="min-width: 10rem"><p>{{review.review.notes}}</p></td><td md-cell="md-cell" ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin"><md-button ng-disabled="$ctrl.REMOVE" ng-click="$ctrl.REMOVE = review.key" class="md-icon-button"><md-icon>delete</md-icon></md-button></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$reviews.length &amp;&amp; !$ctrl.$reviewsApproval.length" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This product has no reviews, add updates and sales performance here.</div><md-button ui-sref="review.add({productId: $ctrl.productId, vendorId: $ctrl.$vendorId, siteId: $ctrl.$siteId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This product has no reviews, please wait until the AATAC reps add reviews to this product.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/_components/reports/reports-product.comp.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$siteId=$data.siteId;\n' +
    '    $ctrl.$vendorId=$data.vendorId"></wc-ui-params><fd-ref fd-ref-path="products/{{$ctrl.productId}}/metadata/price" then="$ctrl.$productPrice = $data"><then><fd-ref ng-init="$ctrl.$reviews = []" fd-ref-path="products/{{$ctrl.productId}}/reviews" fd-ref-array="rich" then="$reviews = $data"><then><fd-ref ng-repeat="review in $reviews" fd-ref-path="reviews/{{review.key}}" then="$ctrl.$addReview($data, review.key, $ctrl.$productPrice)"></fd-ref></then></fd-ref></then></fd-ref><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><div class="margin-half"><canvas ng-if="$ctrl.chart" id="line" chart-data="$ctrl.chart.data" chart-labels="$ctrl.chart.labels" chart-options="$ctrl.chart.options" class="chart chart-line"></canvas><p ng-if="!$ctrl.chart">No data available for chart</p></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/_components/metadata/metadata-product.comp.html',
    '<fd-ref ng-if="$ctrl.productId &amp;&amp; !$ctrl.$current" fd-ref-path="products/{{$ctrl.productId}}" then="\n' +
    '    $ctrl.$product = $data.metadataApproval || $data.metadata || {};\n' +
    '    $ctrl.$form.$setPristine();\n' +
    '    $ctrl.$current = true"></fd-ref><fd-user then="$ctrl.$isRep = $data.isRep; $ctrl.$isAdmin = $data.isAdmin || $data.isSubadmin"></fd-user><div layout="row" layout-align="center" ng-init="$ctrl.$product = {}"><div class="margin padding-half md-whiteframe-2dp container"><product-update-action ng-if="$ctrl.UPDATE" product="$ctrl.$product" product-id="$ctrl.productId" then="\n' +
    '        $ctrl.UPDATE = false;\n' +
    '        $ctrl.$current = false" catch="$ctrl.UPDATE = false"></product-update-action><product-remove-action ng-if="$ctrl.REMOVE" product-id="$ctrl.productId" then="\n' +
    '        $ctrl.REMOVE = false;\n' +
    '        $ctrl.$redirect = true" catch="$ctrl.REMOVE = false"></product-remove-action><wc-ui-redirect ng-if="$ctrl.$redirect" wc-ui-redirect-sref="product.list"></wc-ui-redirect><product-detail ng-if="$ctrl.$product" product="$ctrl.$product" form="$ctrl.$form = $form"></product-detail><div ng-if="!$ctrl.$isRep" flex="100" layout="row" layout-align="end"><md-button disabled="disabled"><md-icon>visibility</md-icon>READ ONLY</md-button></div><div ng-if="$ctrl.$isRep" layout="row"><md-button ng-if="$ctrl.$isAdmin" ng-click="$ctrl.REMOVE = true" class="md-warn">DELETE</md-button><div flex="flex"></div><md-button ng-if="$ctrl.$form.$dirty" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">SAVE</span><span ng-if="$ctrl.$form.$pristine">SAVED</span></md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/_components/detail/detail-product.comp.html',
    '<fd-ref ng-if="$ctrl.approvalId" fd-ref-path="approval/productUpdate/{{$ctrl.approvalId}}/diff" then="$ctrl.$approvals = $ctrl.$invert($data)"></fd-ref><fd-user then="$ctrl.$isAdmin = $data.isAdmin || $data.isSubadmin; $ctrl.$isRep = $data.isRep"></fd-user><form name="productDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: productDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PRODUCT INFO</b></div><md-input-container ng-show="$ctrl.$approvals[\'displayName\'] || !$ctrl.$approvals" class="no-error-message"><label>Product Name</label><input ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.product.displayName" class="capitalize"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'categoryId\'] || !$ctrl.$approvals" class="no-error-message"><!-- CATEGORIES DATA--><fd-ref fd-ref-path="app/constants/productCategories" fd-ref-array="rich" fd-ref-query="{orderByValue: true}" then="$ctrl.$categories = $data"></fd-ref><label>Product category</label><md-select ng-disabled="!$ctrl.$isAdmin" required="required" ng-model="$ctrl.product.categoryId"><md-option ng-repeat="category in $ctrl.$categories" ng-value="category.key">{{category.value}}</md-option></md-select></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'display\'] || !$ctrl.$approvals" class="no-error-message"><label>Display</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.product.display"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'caseCount\'] || !$ctrl.$approvals" class="no-error-message"><label>Case count</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.product.caseCount"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'unitsPerSite\'] || !$ctrl.$approvals" class="no-error-message"><label>Units per site</label><input required="required" ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.product.unitsPerSite"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'price\'] || !$ctrl.$approvals" class="no-error-message"><label>Retail price</label><input ng-disabled="!$ctrl.$isAdmin" type="number" required="required" ng-model="$ctrl.product.price"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'distributorPrice\'] || !$ctrl.$approvals" class="no-error-message"><label>Distributor price & minimum</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.product.distributorPrice"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'marketing\'] || !$ctrl.$approvals" class="no-error-message"><label>Marketing and POP</label><input ng-disabled="!$ctrl.$isAdmin" ng-model="$ctrl.product.marketing"/></md-input-container><md-input-container ng-show="$ctrl.$approvals[\'notes\'] || !$ctrl.$approvals" class="no-error-message"><label>Notes</label><textarea ng-disabled="!$ctrl.$isAdmin" rows="3" ng-model="$ctrl.product.notes"></textarea></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" ng-if="$ctrl.$isRep" class="padding-half"><div class="md-body-2 padding-v-half"><b>ALLOWED TIERS</b></div><md-list><md-list-item layout="row" ng-repeat="i in [1,2,3,4]" layout-align="start center"><p>Tier {{i}}</p><md-checkbox ng-model="$ctrl.product.tiers[\'tier\' + i]" ng-disabled="!$ctrl.$isAdmin" style="margin-bottom: 0" class="md-secondary"></md-checkbox></md-list-item></md-list></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/category/_components/reviews/reviews-category.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref fd-ref-path="categories/{{$ctrl.categoryId}}/reviews" fd-ref-array="rich" then="$ctrl.$reviews = $data"></fd-ref><category-add-review-action ng-if="$ctrl.ADD" category-id="$ctrl.categoryId" then="$ctrl.ADD = false" catch="$ctrl.ADD = false"></category-add-review-action><category-remove-review-action ng-if="$ctrl.REMOVE" category-id="$ctrl.categoryId" review-id="$ctrl.REMOVE" then="$ctrl.REMOVE = false" catch="$ctrl.REMOVE = false"></category-remove-review-action><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isAdmin" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ng-click="$ctrl.ADD = true" hide-gt-xs="hide-gt-xs"><div layout="row" layout-align="center center"><md-icon>add</md-icon>ADD REVIEW</div></md-button><md-button ng-click="$ctrl.ADD = true" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>ADD REVIEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Review date</span></th><th md-column="md-column"><span>Sales amount</span></th><th md-column="md-column"></th></tr></thead><tbody md-body="md-body"><tr ng-repeat="review in $ctrl.$reviews | filter: $ctrl.$query" md-row="md-row"><td md-cell="md-cell"><p>{{review.timestamp | date}}</p></td><td md-cell="md-cell"><p>{{review.amount}}</p></td><td md-cell="md-cell"><md-button ng-click="$ctrl.REMOVE = review.key" class="md-icon-button"><md-icon>delete</md-icon></md-button></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$reviews.length" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isAdmin" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This category has no reviews, add a review to track its performance and compare it to other products.</div><md-button ng-click="$ctrl.ADD = true" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/_components/products/products-display.comp.html',
    '<fd-ref fd-ref-path="app/constants/productCategories" then="$ctrl.$categories = $data"></fd-ref><fd-ref ng-if="!$ctrl.$products" fd-ref-path="suppliers/{{$ctrl.supplierId}}/products" then="\n' +
    '    $ctrl.$products = $data;\n' +
    '    $ctrl.$productList = {};"></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; !$ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/metadata" then="$ctrl.$productList[productId] = $data"><then></then></fd-ref><fd-ref ng-if="$ctrl.$products &amp;&amp; $ctrl.$productList[productId]" ng-repeat="(productId, product) in $ctrl.$products" fd-ref-path="products/{{productId}}/sites" then="$ctrl.$productList[productId].sites = $ctrl.$size($data)"></fd-ref><fd-user then="$ctrl.$isRep = $data.isRep"></fd-user><div layout="row" layout-align="center" class="padding-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="$ctrl.$isRep" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><div flex="flex"></div><md-button ui-sref="supplier.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ui-sref="product.add({supplierId: $ctrl.supplierId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- PRODUCTS--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Product category</span></th><th md-column="md-column"><span>Sites</span></th><!-- th(md-column)span|Days in DRIP--></tr></thead><tbody md-body="md-body"><tr ng-class="{ opacity5: product.pendingApproval }" ng-repeat="(productId, product) in $ctrl.$productList" ui-sref="product.update({productId: productId, supplierId: $ctrl.supplierId})" md-row="md-row" class="pointer"><td md-cell="md-cell"><p>{{product.displayName ? product.displayName : \'Pending Approval\'}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$categories[product.categoryId]}}</p></td><td md-cell="md-cell"><p>{{product.sites}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$products" layout="column" layout-align="center center" class="margin padding"><!-- IS REP--><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a product to this supplier to be able to track its sales and compare it to similar products.</div><md-button ui-sref="product.add({supplierId: $ctrl.supplierId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div><!-- IS NOT REP--><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">This supplier doesn\'t have products yet. Please wait until an AATAC representative adds a new product.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/_components/metadata/metadata-display.comp.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="$ctrl.displayId &amp;&amp; !$ctrl.$current" fd-ref-path="displays/{{$ctrl.displayId}}" then="\n' +
    '    $ctrl.$display = {metadata: $data.metadata, products: $data.products || {}};\n' +
    '    $ctrl.$form.$setPristine();\n' +
    '    $ctrl.$current = true"></fd-ref><div layout="row" layout-align="center" ng-init="$ctrl.$display = {}"><div class="margin padding-half md-whiteframe-2dp container"><display-update-action ng-if="$ctrl.UPDATE" display="$ctrl.$display" display-id="$ctrl.displayId" then="\n' +
    '        $ctrl.UPDATE = false;\n' +
    '        $ctrl.$current = false" catch="$ctrl.UPDATE = false"></display-update-action><display-remove-action ng-if="$ctrl.REMOVE" display-id="$ctrl.displayId" vendor-id="$ctrl.$display.metadata.vendorId" then="\n' +
    '        $ctrl.REMOVE = false;\n' +
    '        $ctrl.$redirect = true" catch="$ctrl.REMOVE = false"></display-remove-action><wc-ui-redirect ng-if="$ctrl.$redirect" wc-ui-redirect-back="true"></wc-ui-redirect><display-detail ng-if="$ctrl.$display" display="$ctrl.$display" form="$ctrl.$form = $form"></display-detail><div ng-if="!$ctrl.$isAdmin" flex="100" layout="row" layout-align="end"><md-button disabled="disabled"><md-icon>visibility</md-icon>READ ONLY</md-button></div><div ng-if="$ctrl.$isAdmin" layout="row"><md-button ng-click="$ctrl.REMOVE = true" class="md-warn">DELETE</md-button><div flex="flex"></div><md-button ng-if="$ctrl.$form.$dirty" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">SAVE</span><span ng-if="$ctrl.$form.$pristine">SAVED</span></md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/_components/detail/detail-display.comp.html',
    '<fd-user then="$ctrl.$isRep = $data.isRep"></fd-user><form name="displayDetailForm" layout="row" layout-wrap="layout-wrap"><div ng-init="$ctrl.form({$form: displayDetailForm})"></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>DISPLAY INFO</b></div><md-input-container class="no-error-message"><label>Display Name</label><input ng-disabled="!$ctrl.$isRep" required="required" ng-model="$ctrl.display.metadata.displayName"/></md-input-container><md-input-container class="no-error-message"><label>Notes</label><textarea ng-disabled="!$ctrl.$isRep" rows="3" ng-model="$ctrl.display.metadata.notes"></textarea></md-input-container></div><div flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-half"><div class="md-body-2 padding-v-half"><b>PRODUCTS</b></div><div layout="row"><fd-ref fd-ref-path="products" then="$ctrl.$productsObj = $data;"></fd-ref><fd-ref fd-ref-path="products" fd-ref-array="rich" then="$ctrl.$products = $data; $ctrl.$autocompleteProducts = []"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><div ng-if="product.metadata.displayName" ng-init="$ctrl.$autocompleteProducts.push(product)" ng-repeat="product in $ctrl.$products"></div></then></fd-ref><md-autocomplete flex="flex" ng-init="$ctrl.$productQuery = $ctrl.$productQuery || $ctrl.$productsObj[$ctrl.newProduct].metadata.displayName" placeholder="Add product to display" md-no-cache="true" md-min-length="2" md-items="product in $ctrl.$autocompleteProducts | filter: $ctrl.$productQuery" md-item-text="product.metadata.displayName" md-search-text="$ctrl.$productQuery" md-selected-item-change="$ctrl.newProduct = product.key" md-require-match="true" class="no-error-message md-body-1"><md-item-template>{{product.metadata.displayName}}</md-item-template></md-autocomplete><md-button ng-if="$ctrl.newProduct" ng-click="$ctrl.display.products[$ctrl.newProduct] = true; $ctrl.$productQuery = \'\'; $ctrl.newProduct = \'\'" class="md-raised md-primary"><md-icon>add</md-icon>Add</md-button></div><div ng-repeat="(productId, data) in $ctrl.display.products" ng-if="data" layout="row" class="padding"><div flex="flex">{{$ctrl.$productsObj[productId].metadata.displayName}}</div><md-icon ng-click="$ctrl.display.products[productId] = null">close</md-icon></div></div></form>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/uploadedSites/uploadedSites-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref fd-ref-path="importForApproval/sites" then="$ctrl.$approvals = $data; $ctrl.processUrls($ctrl.$approvals)"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div flex="flex" ng-if="$ctrl.$approvals" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><h2>Imported sites</h2><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Download the request file for review and then re-upload it after you have made appropriate changes."></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column" flex="flex"><span>Upload date</span></th><th md-column="md-column"><span>User name</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="(userId, uploadTime) in $ctrl.$approvals" class="pointer"><td md-cell="md-cell" flex="flex"><p>{{uploadTime | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{userId}}/displayName" then="userName = $data"><then><p>{{userName}}</p></then></fd-ref></td><td md-cell="md-cell"><md-button ng-if="$ctrl.$urls[userId]" target="_blank" ng-href="{{$ctrl.$urls[userId]}}"><div layout="row" layout-align="center center"><md-icon>file_download</md-icon>DOWNLOAD REQUEST FILE</div></md-button></td><td md-cell="md-cell"><md-button class="md-accent md-raised md-hue-2"><wc-upload then="$ctrl.$file = $file"><then><fd-upload ng-if="$ctrl.$file" fd-upload-file="$ctrl.$file" fd-upload-filename="$ctrl.$isAdmin ? \'/sitesData.xlsx\' : \'/uploads/\' + $ctrl.$userId + \'/sitesData.xlsx\'" before="$ctrl.$progress = $progress" then="$ctrl.notifyImport(userId); $ctrl.$file = null"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="true"><wc-dialog-template><div class="padding"><div class="md-title">Uploading file ({{$ctrl.$progress}}%)</div><div class="md-body-1">Please wait until the upload is complete</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></fd-upload></then><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></wc-upload><div layout="row" layout-align="center center"><md-icon>file_upload</md-icon>IMPORT REVIEWED FILE (MAX 400)</div></md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/updateSite/updateSite-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="!$ctrl.$approvals.length" fd-ref-path="approval/siteUpdate" fd-ref-array="rich" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><approval-approve-action ng-if="$ctrl.APPROVE" type="siteUpdate" batch="\n' +
    '    $ctrl.$approvalSelected.length\n' +
    '      ? $ctrl.$approvalSelected\n' +
    '      : $ctrl.$approvalAll" then="\n' +
    '    $ctrl.APPROVE = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];" catch="$ctrl.APPROVE = false"></approval-approve-action><approval-deny-action ng-if="$ctrl.DENY" type="siteUpdate" batch="$ctrl.$approvalSelected" then="\n' +
    '    $ctrl.DENY = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];\n' +
    '    $ctrl.$approvals = []" catch="$ctrl.DENY = false"></approval-deny-action><div flex="flex" ng-if="$ctrl.$approvals.length" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div ng-show="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Selected ({{$ctrl.$approvalSelected.length}})</h2><div flex="flex"></div><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.DENY = true">DENY</md-button><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.APPROVE = true" class="md-raised md-accent">APPROVE</md-button></div><div ng-hide="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Site updates</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isAdmin" ng-disabled="!$ctrl.$approvals.length" ng-click="$ctrl.APPROVE = true" class="md-raised md-primary">APPROVE ALL</md-button></div></md-toolbar><md-divider></md-divider><md-table-container ng-init="\n' +
    '      $ctrl.$approvalSelected = [];\n' +
    '      $ctrl.$approvalAll = [];"><!-- VENDORS--><table md-table="md-table" md-row-select="" multiple="" ng-model="$ctrl.$approvalSelected"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Change date</span></th><th md-column="md-column"><span>Agent name</span></th><th md-column="md-column"><span>Site name</span></th><th md-column="md-column"><span>Fields updated</span></th></tr></thead><tbody md-body="md-body"><tr ng-init="$ctrl.$approvalAll.push(review.key)" md-row="md-row" md-select="review.key" md-auto-select="true" ng-show="$ctrl.$isAdmin || review.userId === $ctrl.$userId" ng-repeat="review in $ctrl.$approvals" class="pointer"><td md-cell="md-cell"><p>{{review.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{review.userId}}/displayName" then="review.userName = $data"><then><p>{{review.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="sites/{{review.siteId}}/metadataApproval/displayName" then="review.siteName = $data"><then><p>{{review.siteName}}</p></then></fd-ref></td><td md-cell="md-cell"><span ng-repeat="field in review.diff">{{field}}<span ng-hide="$last">,&nbsp;</span></span></td><td md-cell="md-cell"><md-button ui-sref="site.update({siteId: review.siteId, approval: review.key})">REVIEW NEW DATA</md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/updateReview/updateReview-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="!$ctrl.$approvals.length" fd-ref-path="approval/review" fd-ref-array="rich" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><approval-approve-action ng-if="$ctrl.APPROVE" type="review" batch="\n' +
    '    $ctrl.$approvalSelected.length\n' +
    '      ? $ctrl.$approvalSelected\n' +
    '      : $ctrl.$approvalAll" then="\n' +
    '    $ctrl.APPROVE = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];" catch="$ctrl.APPROVE = false"></approval-approve-action><approval-deny-action ng-if="$ctrl.DENY" type="review" batch="$ctrl.$approvalSelected" then="\n' +
    '    $ctrl.DENY = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];\n' +
    '    $ctrl.$approvals = []" catch="$ctrl.DENY = false"></approval-deny-action><div flex="flex" ng-if="$ctrl.$approvals.length" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div ng-show="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Selected ({{$ctrl.$approvalSelected.length}})</h2><div flex="flex"></div><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.DENY = true">DENY</md-button><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.APPROVE = true" class="md-raised md-accent">APPROVE</md-button></div><div ng-hide="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>New product reviews</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isAdmin" ng-disabled="!$ctrl.$approvals.length" ng-click="$ctrl.APPROVE = true" class="md-raised md-primary">APPROVE ALL</md-button></div></md-toolbar><md-divider></md-divider><md-table-container ng-init="\n' +
    '      $ctrl.$approvalSelected = [];\n' +
    '      $ctrl.$approvalAll = [];"><!-- VENDORS--><table md-table="md-table" md-row-select="" multiple="" ng-model="$ctrl.$approvalSelected"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Change date</span></th><th md-column="md-column"><span>Agent name</span></th><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Site name</span></th><th md-column="md-column"><span>Amount</span></th></tr></thead><tbody md-body="md-body"><tr ng-init="$ctrl.$approvalAll.push(review.key)" md-row="md-row" md-select="review.key" md-auto-select="true" ng-show="$ctrl.$isAdmin || review.userId === $ctrl.$userId" ng-repeat="review in $ctrl.$approvals" class="pointer"><td md-cell="md-cell"><p>{{review.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{review.userId}}/displayName" then="review.userName = $data"><then><p>{{review.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="reviews/{{review.reviewId}}/productId" then="productId = $data"><then><fd-ref fd-ref-path="products/{{productId}}/metadata/displayName" then="review.reviewProductName = $data"><then><p>{{review.reviewProductName}}</p></then></fd-ref></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="reviews/{{review.reviewId}}/siteId" then="siteId = $data"><then><fd-ref fd-ref-path="sites/{{siteId}}/metadata/displayName" then="review.reviewSiteName = $data"><then><p>{{review.reviewSiteName}}</p></then></fd-ref></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="reviews/{{review.reviewId}}/review/amount" then="review.amount = $data"><then><p>{{review.amount}}</p></then></fd-ref></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/tierUpdates/tierUpdates-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref fd-ref-path="tierUpdates" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div flex="flex" ng-if="$ctrl.$approvals" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><h2>Tier updates</h2><div flex="flex"></div></div></md-toolbar><md-divider></md-divider><md-table-container><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column" flex="flex"><span>Action date</span></th><th md-column="md-column"><span>User name</span></th><th md-column="md-column"><span>Site</span></th><th md-column="md-column"><span>Old tier</span></th><th md-column="md-column"><span>New tier</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="(itemId, item) in $ctrl.$approvals"><td md-cell="md-cell" flex="flex"><p>{{item.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{item.userId}}/displayName" then="item.userName = $data"><then><p>{{item.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="sites/{{item.siteId}}/metadata/displayName" then="item.siteName = $data"><then><p>{{item.siteName}}</p></then></fd-ref></td><td md-cell="md-cell"><p>{{item.oldTier}}</p></td><td md-cell="md-cell"><p>{{item.newTier}}</p></td><td md-cell="md-cell"><md-button ng-click="$ctrl.$reject(itemId, item)">Reject</md-button><md-button ng-click="$ctrl.$approve(itemId)" class="md-accent md-raised md-hue-2">Approve</md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/updateProduct/updateProduct-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="!$ctrl.$approvals.length" fd-ref-path="approval/productUpdate" fd-ref-array="rich" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><approval-approve-action ng-if="$ctrl.APPROVE" type="productUpdate" batch="\n' +
    '    $ctrl.$approvalSelected.length\n' +
    '      ? $ctrl.$approvalSelected\n' +
    '      : $ctrl.$approvalAll" then="\n' +
    '    $ctrl.APPROVE = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];" catch="$ctrl.APPROVE = false"></approval-approve-action><approval-deny-action ng-if="$ctrl.DENY" type="productUpdate" batch="$ctrl.$approvalSelected" then="\n' +
    '    $ctrl.DENY = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];\n' +
    '    $ctrl.$approvals = []" catch="$ctrl.DENY = false"></approval-deny-action><div flex="flex" ng-if="$ctrl.$approvals.length" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div ng-show="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Selected ({{$ctrl.$approvalSelected.length}})</h2><div flex="flex"></div><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.DENY = true">DENY</md-button><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.APPROVE = true" class="md-raised md-accent">APPROVE</md-button></div><div ng-hide="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Product updates</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isAdmin" ng-disabled="!$ctrl.$approvals.length" ng-click="$ctrl.APPROVE = true" class="md-raised md-primary">APPROVE ALL</md-button></div></md-toolbar><md-divider></md-divider><md-table-container ng-init="\n' +
    '      $ctrl.$approvalSelected = [];\n' +
    '      $ctrl.$approvalAll = [];"><!-- VENDORS--><table md-table="md-table" md-row-select="" multiple="" ng-model="$ctrl.$approvalSelected"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Change date</span></th><th md-column="md-column"><span>Agent name</span></th><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Fields updated</span></th></tr></thead><tbody md-body="md-body"><tr ng-init="$ctrl.$approvalAll.push(review.key)" md-row="md-row" ng-show="$ctrl.$isAdmin || review.userId === $ctrl.$userId" md-select="review.key" md-auto-select="true" ng-repeat="review in $ctrl.$approvals" class="pointer"><td md-cell="md-cell"><p>{{review.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{review.userId}}/displayName" then="review.userName = $data"><then><p>{{review.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="products/{{review.productId}}/metadataApproval/displayName" then="review.productName = $data"><then><p>{{review.productName}}</p></then></fd-ref></td><td md-cell="md-cell"><span ng-repeat="field in review.diff">{{field}}<span ng-hide="$last">,&nbsp;</span></span></td><td md-cell="md-cell"><md-button ui-sref="product.update({productId: review.productId, approval: true})">REVIEW NEW DATA</md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/registerProductSite/registerProductSite-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref ng-if="!$ctrl.$approvals.length" fd-ref-path="approval/registerProductSite" fd-ref-array="rich" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><approval-approve-action ng-if="$ctrl.APPROVE" type="registerProductSite" batch="\n' +
    '    $ctrl.$approvalSelected.length\n' +
    '      ? $ctrl.$approvalSelected\n' +
    '      : $ctrl.$approvalAll" then="\n' +
    '    $ctrl.APPROVE = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];" catch="$ctrl.APPROVE = false"></approval-approve-action><approval-deny-action ng-if="$ctrl.DENY" type="registerProductSite" batch="$ctrl.$approvalSelected" then="\n' +
    '    $ctrl.DENY = false;\n' +
    '    $ctrl.$approvalSelected = [];\n' +
    '    $ctrl.$approvalAll = [];\n' +
    '    $ctrl.$approvals = []" catch="$ctrl.DENY = false"></approval-deny-action><div flex="flex" ng-if="$ctrl.$approvals.length" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div ng-show="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Selected ({{$ctrl.$approvalSelected.length}})</h2><div flex="flex"></div><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.DENY = true">DENY</md-button><md-button ng-if="$ctrl.$approvalSelected.length &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.APPROVE = true" class="md-raised md-accent">APPROVE</md-button></div><div ng-hide="$ctrl.$approvalSelected.length" class="md-toolbar-tools"><h2>Product registrations in site</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isAdmin" ng-disabled="!$ctrl.$approvals.length" ng-click="$ctrl.APPROVE = true" class="md-raised md-primary">APPROVE ALL</md-button></div></md-toolbar><md-divider></md-divider><md-table-container ng-init="\n' +
    '      $ctrl.$approvalSelected = [];\n' +
    '      $ctrl.$approvalAll = [];"><!-- VENDORS--><table md-table="md-table" md-row-select="" multiple="" ng-model="$ctrl.$approvalSelected"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Change date</span></th><th md-column="md-column"><span>Agent name</span></th><th md-column="md-column"><span>Site name</span></th><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Fields updated</span></th></tr></thead><tbody md-body="md-body"><tr ng-init="$ctrl.$approvalAll.push(review.key)" ng-show="$ctrl.$isAdmin || review.userId === $ctrl.$userId" md-row="md-row" md-select="review.key" md-auto-select="true" ng-repeat="review in $ctrl.$approvals" class="pointer"><td md-cell="md-cell"><p>{{review.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{review.userId}}/displayName" then="review.userName = $data"><then><p>{{review.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="sites/{{review.siteId}}/metadata/displayName" then="review.siteName = $data"><then><p>{{review.siteName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="products/{{review.productId}}/metadata/displayName" then="review.productName = $data"><then><p>{{review.productName}}</p></then></fd-ref></td><td md-cell="md-cell"><span ng-repeat="field in review.diff">{{field}}<span ng-hide="$last">,&nbsp;</span></span></td><td md-cell="md-cell"><md-button ui-sref="site.updateProduct({productId: review.productId, siteId: review.siteId, approval: true})">REVIEW NEW DATA</md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/_components/invalidTier/invalidTier-approval.comp.html',
    '<fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><fd-ref fd-ref-path="invalidTiers" then="$ctrl.$approvals = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div flex="flex" ng-if="$ctrl.$approvals" class="md-whiteframe-2dp"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><h2>Invalid product tiers</h2><div flex="flex"></div></div></md-toolbar><md-divider></md-divider><md-table-container><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column" flex="flex"><span>Action date</span></th><th md-column="md-column"><span>User name</span></th><th md-column="md-column"><span>Site</span></th><th md-column="md-column"><span>Product</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="(itemId, item) in $ctrl.$approvals"><td md-cell="md-cell" flex="flex"><p>{{item.timestamp | date}}</p></td><td md-cell="md-cell"><fd-ref fd-ref-path="users/{{item.userId}}/displayName" then="item.userName = $data"><then><p>{{item.userName}}</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="sites/{{item.siteId}}/metadata" then="item.site = $data"><then><p>{{item.site.displayName}} ({{item.site.tier}})</p></then></fd-ref></td><td md-cell="md-cell"><fd-ref fd-ref-path="products/{{item.productId}}/metadata" then="item.product = $data"><then><p>{{item.product.displayName}} ({{$ctrl.$getTiers(item.product.tiers)}})</p></then></fd-ref></td><td md-cell="md-cell"><md-button ng-click="$ctrl.$reject(itemId, item)">Reject</md-button><md-button ng-click="$ctrl.$approve(itemId)" class="md-accent md-raised md-hue-2">Approve</md-button></td></tr></tbody></table></md-table-container></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/update/update-vendor.route.html',
    '<wc-ui-params then="$ctrl.$vendorId=$data.vendorId"></wc-ui-params><fd-ref ng-if="$ctrl.$vendorId" fd-ref-path="vendors/{{$ctrl.$vendorId}}/metadata" then="$ctrl.$vendor = $data"></fd-ref><fd-user then="\n' +
    '  $ctrl.$userVendors = $data.vendors;\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-if="!$ctrl.$userVendors" ui-sref="vendor.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Vendor</div><h2>{{$ctrl.$vendor.displayName}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="This view lets you update the vendor info, products and sales"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><md-tabs ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin" md-dynamic-height="true" class="md-primary md-hue-2"><md-tab label="PRODUCTS"><vendor-products vendor-id="$ctrl.$vendorId"></vendor-products></md-tab><md-tab label="DISPLAYS" ng-if="$ctrl.$isAdmin"><vendor-displays vendor-id="$ctrl.$vendorId"></vendor-displays></md-tab><md-tab label="PROFILE"><vendor-metadata vendor-id="$ctrl.$vendorId"></vendor-metadata></md-tab></md-tabs><vendor-products ng-if="!$ctrl.$isAdmin &amp;&amp; !$ctrl.$isSubadmin" vendor-id="$ctrl.$vendorId">     </vendor-products>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/list/list-vendor.route.html',
    '<fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '  $ctrl.$teamId = $data.teamId"><then><fd-ref fd-ref-path="teams/{{$ctrl.$teamId}}/vendors" then="$ctrl.$teamVendors = $data"></fd-ref><fd-ref fd-ref-path="vendors" fd-ref-array="rich" then="$ctrl.$vendors = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref></then></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Vendors</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isAdmin" href="https://us-central1-drip-1e853.cloudfunctions.net/vendorXls" layout="row" layout-align="start center"><md-icon>view_list</md-icon><div class="padding-h-quarter">Download list</div></md-button></div></md-toolbar><div ng-if="!$ctrl.$isSubadmin &amp;&amp; !$ctrl.$isAdmin" class="margin-half"><div>You\'re not authorized to see this page</div><md-button ui-sref="product">Go to products</md-button></div><div ng-if="$ctrl.$isSubadmin || $ctrl.$isAdmin" layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a vendor" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="vendor.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="vendor.add" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- VENDORS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Vendor name</span></th><th md-column="md-column"><span>Contact name</span></th><th md-column="md-column"><span>Contact phone</span></th><th md-column="md-column"><span>Products</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="vendor in $ctrl.$getFilteredVendors($ctrl.$vendors, $ctrl.$teamVendors, $ctrl.$isAdmin) | filter: $ctrl.$query" ui-sref="vendor.update({vendorId: vendor.key})" class="pointer"><td md-cell="md-cell"><p>{{vendor.metadata.displayName}}</p></td><td md-cell="md-cell"><p>{{vendor.metadata.contactName}}</p></td><td md-cell="md-cell"><p>{{vendor.metadata.contactPhone}}</p></td><td md-cell="md-cell" ng-init="vendor.productCount = $ctrl.$count(vendor.products)"><p>{{vendor.productCount}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$getFilteredVendors($ctrl.$vendors, $ctrl.$teamVendors, $ctrl.$isAdmin).length" layout="column" layout-align="center center" class="margin padding"><div ng-if="$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a vendor to track how their products are selling and compare them to other products.</div><md-button ui-sref="vendor.add" class="md-raised md-primary">GET STARTED</md-button><p></p></div><div ng-if="!$ctrl.$isRep" layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">No vendors added.</div><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/vendor/add/add-vendor.route.html',
    '<fd-user then="$ctrl.$teamId = $data.teamId"></fd-user><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="teams/{{$ctrl.$teamId}}/metadata/displayName" then="$ctrl.$teamName = $data;"></fd-ref><vendor-add-action ng-if="$ctrl.CREATE" vendor="$ctrl.$vendor" team-id="$ctrl.$teamId" then="$ctrl.CREATE = false" catch="$ctrl.CREATE = false"></vendor-add-action><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="vendor.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Vendor {{$ctrl.$teamName ? \'for \' + $ctrl.$teamName : \'\'}}</div><h2>New vendor</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the vendor and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$vendor = {}" class="margin padding-half md-whiteframe-2dp container"><vendor-detail vendor="$ctrl.$vendor" form="$ctrl.$form = $form"></vendor-detail><div layout="row"><div flex="flex"></div><md-button ui-sref="vendor.list">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/user/update/update-user.route.html',
    '<wc-ui-params then="$ctrl.$userId=$data.userId; $ctrl.$embedded = $data.embedded;">     </wc-ui-params><md-toolbar ng-if="!$ctrl.$embedded" class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="user.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">User</div><h2>{{$ctrl.$user.displayName}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Update the info from the user and then click on UPDATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><fd-ref ng-if="$ctrl.$userId" fd-ref-path="users/{{$ctrl.$userId}}" then="$ctrl.$user = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div layout="row" layout-align="center"><div class="container"><div class="padding-half margin-half md-whiteframe-2dp"><user-detail user-id="$ctrl.$userId" user="$ctrl.$user" form="$ctrl.$form = $form"></user-detail><div layout="row"><md-button hide="hide" show-gt-sm="show-gt-sm" ng-click="$ctrl.REMOVE = true" class="md-accent">DELETE</md-button><md-button hide-gt-sm="hide-gt-sm" ng-click="$ctrl.REMOVE = true" class="md-accent md-icon-button"><md-icon>delete</md-icon></md-button><md-button hide="hide" show-gt-sm="show-gt-sm" ng-click="$ctrl.PASSWORD = true">UPDATE PASSWORD</md-button><md-button hide-gt-sm="hide-gt-sm" ng-click="$ctrl.PASSWORD = true" class="md-icon-button"><md-icon>lock</md-icon></md-button><md-button hide="hide" show-gt-sm="show-gt-sm" ng-click="$ctrl.$impersonate($ctrl.$userId)">IMPERSONATE</md-button><div flex="flex"></div><md-button hide="hide" show-gt-sm="show-gt-sm" ui-sref="user.list">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.UPDATE = true" class="md-primary md-raised">UPDATE</md-button></div><user-remove-action ng-if="$ctrl.REMOVE" user-id="$ctrl.$userId" team-id="$ctrl.$user.teamId" then="$ctrl.REMOVE = false; $ctrl.REDIRECT = true" catch="$ctrl.REMOVE = false"></user-remove-action><user-update-action ng-if="$ctrl.UPDATE" user-id="$ctrl.$userId" user="$ctrl.$user" then="$ctrl.UPDATE = false; $ctrl.REDIRECT = true" catch="$ctrl.UPDATE = false"></user-update-action><user-admin-password-action ng-if="$ctrl.PASSWORD" user-id="$ctrl.$userId" user="$ctrl.$user" then="$ctrl.PASSWORD = false" catch="$ctrl.PASSWORD = false"></user-admin-password-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="user.list"></wc-ui-redirect></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/user/list/list-user.route.html',
    '<wc-ui-params then="\n' +
    '  $ctrl.$embedded = $data.embedded;">     </wc-ui-params><md-toolbar ng-if="!$ctrl.$embedded" class="md-hue-2"><div class="md-toolbar-tools"><h2>Users</h2><div flex="flex"></div><!--md-button.md-icon-button.opacity5(ng-click="")\n' +
    'md-icon|help\n' +
    '--></div></md-toolbar><fd-user then="$ctrl.$isAdmin = $data.isAdmin; $ctrl.$user = $data"></fd-user><fd-ref ng-if="$ctrl.$user" fd-ref-path="teams" then="$ctrl.$teams = $data; $ctrl.$getUsers($ctrl.$user)"></fd-ref><div layout="column" layout-align="start" class="margin-half"><div ng-repeat="(teamId, team) in $ctrl.$teams" ng-if="$ctrl.$user.teamId === teamId || $ctrl.$isAdmin" class="padding-h-half padding-v"><div layout="row" layout-align="center"><div class="container"><div ng-if="$ctrl.$isAdmin" style="margin-bottom: 0.5rem" class="md-title opacity5">{{team.metadata.displayName}}</div></div></div><div layout="row" layout-align="center"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search by name, email, phone or role" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-hide="$ctrl.$query" ui-sref="user.add({teamId: teamId})" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-hide="$ctrl.$query" ui-sref="user.add({teamId: teamId})" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Full Name</span></th><th md-column="md-column"><span>Email</span></th><th md-column="md-column"><span>Phone</span></th><th md-column="md-column"><span>Company</span></th><th md-column="md-column"><span>Role</span></th><th md-column="md-column"><span>UserId</span></th></tr></thead><tbody md-body="md-body"><tr ng-hide="user.REMOVE" ng-if="teamId === user.teamId" ng-class="{ opacity5: user.disabled }" ng-repeat="user in $ctrl.$users | filter: $ctrl.$query" md-row="md-row"><td md-cell="md-cell"><a ng-if="$ctrl.$embedded" target="_parent" ng-href="https://drip.webcat.page/user/{{user.key}}">{{user.displayName}}</a><a ng-if="!$ctrl.$embedded" ui-sref="user.update({userId: user.key})">{{user.displayName}}</a></td><td md-cell="md-cell"><p>{{user.email}}</p></td><td md-cell="md-cell"><p>{{user.phone}}</p></td><td md-cell="md-cell"><p>{{user.company}}</p></td><td md-cell="md-cell"><p>{{user.role}}</p></td><td md-cell="md-cell"><p>{{user.key}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!team.users" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a user to let representatives, clients and admins get access to the platform.</div><md-button ui-sref="user.add({teamId: teamId})" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/user/add/add-user.route.html',
    '<wc-ui-params then="$ctrl.$teamId = $data.teamId"><then><fd-user then="$ctrl.$teamId = $ctrl.$teamId || $data.teamId; $ctrl.$isAdmin = $data.isAdmin"></fd-user></then></wc-ui-params><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="teams/{{$ctrl.$teamId}}/metadata/displayName" then="$ctrl.$teamName = $data;"></fd-ref><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="user.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">{{$ctrl.$teamName}} User</div><h2>New user</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the user and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$user = {}" class="margin padding-half md-whiteframe-2dp container"><div layout="row" layout-wrap="layout-wrap" class="padding-quarter"><form autocomplete="off" name="addUserForm" flex-order-xs="2" flex-xs="100" flex-gt-xs="50" layout="column" layout-align="start stretch" class="padding-quarter"><div class="md-body-2"><b>CREDENTIALS</b></div><md-input-container class="no-error-message"><label>Email</label><input required="required" type="email" ng-model="$ctrl.$credentials.email"/></md-input-container><md-input-container class="no-error-message"><label>Password</label><input required="required" ng-model="$ctrl.$credentials.password"/></md-input-container></form><div flex-order-xs="1" flex-xs="100" flex-gt-xs="50" layout="column" class="padding-half"><!--md-icon|info--><p class="md-subhead">There are three types of users:<span ng-if="$ctrl.$isAdmin"><br/><b>Admins:&nbsp;</b>They have access to all information.</span><span><br/><b>Subadmins:&nbsp;</b>They have access to all {{$ctrl.$teamName}} information.</span><br/><b>Representatives:&nbsp;</b>They can add updates to site locations and product sales.<span ng-if="$ctrl.$isAdmin"><br/><b>Vendors:&nbsp;</b>They can only see information from a specific vendor and its products.</span></p></div></div><user-detail user="$ctrl.$user" form="$ctrl.$form = $form"></user-detail><div layout="row" layout-align="end"><md-button ui-sref="user.list">CANCEL</md-button><md-button ng-disabled="addUserForm.$invalid || $ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-primary md-raised">ADD USER</md-button></div><user-add-action ng-if="$ctrl.CREATE" credentials="$ctrl.$credentials" user="$ctrl.$user" team-id="$ctrl.$teamId" then="$ctrl.CREATE = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false"></user-add-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="user.list"></wc-ui-redirect></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/team/update/update-team.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$teamId=$data.teamId;"></wc-ui-params><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="teams/{{$ctrl.$teamId}}/metadata" then="$ctrl.$team = $data"></fd-ref><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="teams/{{$ctrl.$teamId}}/vendors" then="$ctrl.$teamVendors = $data || {}"></fd-ref><fd-ref fd-ref-path="vendors" then="$ctrl.$vendors = $data"></fd-ref><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="team.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column" class="md-truncate"> <div class="md-body-1">Team</div><h2>{{$ctrl.$team.displayName}}</h2></div><div flex="flex"></div></div></md-toolbar><md-content><div class="padding"><form name="vendorsForm" class="md-whiteframe-2dp"><div class="md-title padding">Vendors</div><md-list><md-list-item ng-repeat="(vendorId, vendor) in $ctrl.$vendors"><p>{{vendor.metadata.displayName}}</p><md-checkbox ng-model="$ctrl.$teamVendors[vendorId]" class="md-secondary"></md-checkbox></md-list-item></md-list><div layout="row" layout-align="end" class="padding-half"><md-button ui-sref="team.list">CANCEL</md-button><md-button ng-click="vendorsForm.$setPristine(); $ctrl.$save($ctrl.$teamVendors, $ctrl.$teamId)" ng-disabled="!vendorsForm.$dirty" class="md-raised md-primary">SAVE</md-button></div></form></div></md-content>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/team/list/list-team.route.html',
    '<md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Teams</h2><div flex="flex"></div><md-button ng-click="" class="md-icon-button opacity5"><md-icon>help</md-icon></md-button></div></md-toolbar><fd-ref fd-ref-path="teams" fd-ref-array="rich" then="$ctrl.$teams = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><team-add-action ng-if="$ctrl.ADD" then="$ctrl.ADD = false" catch="$ctrl.ADD = false"></team-add-action><div layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a team" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-hide="$ctrl.$query" ng-click="$ctrl.ADD = true" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-hide="$ctrl.$query" ng-click="$ctrl.ADD = true" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- SITES--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Team name</span></th><th md-column="md-column"><span>Vendors</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="team in $ctrl.$teams | orderBy: \'metadata.displayName\' | filter: $ctrl.$query" ui-sref="team.update({teamId: team.key})" class="pointer"><td md-cell="md-cell"><p>{{team.metadata.displayName}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$count(team.vendors)}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$teams.length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a team to let other companies manage their own reps</div><md-button ng-click="$ctrl.ADD = true" class="md-raised md-primary"><span>GET STARTED</span></md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/update/update-supplier.route.html',
    '<wc-ui-params then="$ctrl.$supplierId=$data.supplierId"></wc-ui-params><fd-ref ng-if="$ctrl.$supplierId" fd-ref-path="suppliers/{{$ctrl.$supplierId}}/metadata" then="$ctrl.$supplier = $data"></fd-ref><fd-user then="\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$isAdmin = $data.isAdmin"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Distributor</div><h2>{{$ctrl.$supplier.displayName}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="This view lets you update the distributor info"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><md-tabs ng-if="$ctrl.$isAdmin" md-dynamic-height="true" class="md-primary md-hue-2"><md-tab label="PROFILE"><supplier-metadata supplier-id="$ctrl.$supplierId"></supplier-metadata></md-tab></md-tabs><supplier-products ng-if="!$ctrl.$isAdmin" supplier-id="$ctrl.$supplierId">     </supplier-products>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/list/list-supplier.route.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Distributors</h2><div flex="flex"></div></div></md-toolbar><fd-ref fd-ref-path="suppliers" fd-ref-array="rich" then="$ctrl.$suppliers = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a supplier" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="supplier.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="supplier.add" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- SUPPLIERS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Distributor name</span></th><th md-column="md-column"><span>Contact name</span></th><th md-column="md-column"><span>Contact phone</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-show="supplier.metadata.displayName" ng-repeat="supplier in $ctrl.$suppliers | filter: $ctrl.$query" ui-sref="supplier.update({supplierId: supplier.key})" class="pointer"><td md-cell="md-cell"><p>{{supplier.metadata.displayName}}</p></td><td md-cell="md-cell"><p>{{supplier.metadata.contactName}}</p></td><td md-cell="md-cell"><p>{{supplier.metadata.contactPhone}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$suppliers.length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a distributor to track which distributors provide the different stores from a central place.</div><md-button ui-sref="supplier.add" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/supplier/add/add-supplier.route.html',
    '<wc-ui-params then="$ctrl.$redirectBack = $data.redirectBack"></wc-ui-params><supplier-add-action ng-if="$ctrl.CREATE" supplier="$ctrl.$supplier" then="$ctrl.CREATE = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false"></supplier-add-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-back="$ctrl.$redirectBack" wc-ui-redirect-sref="supplier"></wc-ui-redirect><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$redirectBack = true; $ctrl.REDIRECT = true" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Distributor</div><h2>New distributor</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the distributor and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$supplier = {}" class="margin padding-half md-whiteframe-2dp container"><supplier-detail supplier="$ctrl.$supplier" form="$ctrl.$form = $form"></supplier-detail><div layout="row"><div flex="flex"></div><md-button ui-sref="supplier.list">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/updateProduct/updateProduct-site.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$siteId=$data.siteId;\n' +
    '    $ctrl.$productId=$data.productId;\n' +
    '    $ctrl.$backApproval = $data.approval">     </wc-ui-params><fd-user then="$ctrl.$userVendor = $data.vendorId"></fd-user><fd-ref fd-ref-path="sites/{{$ctrl.$siteId}}/metadata/displayName" then="$ctrl.$siteName = $data"></fd-ref><fd-ref fd-ref-path="sites/{{$ctrl.$siteId}}/metadata/address" then="$ctrl.$siteAddress = $data.address1 + \', \' + $data.city + \', \' + $data.state"></fd-ref><fd-ref fd-ref-path="products/{{$ctrl.$productId}}/metadata/displayName" then="$ctrl.$productName = $data"></fd-ref><fd-ref ng-if="!$ctrl.$backApproval" fd-ref-path="sites/{{$ctrl.$siteId}}/products/{{$ctrl.$productId}}/registration" then="$ctrl.$registration = $data"></fd-ref><fd-ref ng-if="$ctrl.$backApproval" fd-ref-path="sites/{{$ctrl.$siteId}}/products/{{$ctrl.$productId}}/registrationApproval" then="$ctrl.$registration = $data"></fd-ref><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column" class="md-truncate"> <div class="md-body-1">{{$ctrl.$siteName}} - {{$ctrl.$siteAddress}}</div><h2>Product registration - {{$ctrl.$productName}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="You can see here when this product was registered"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><!--md-tabs.md-primary.md-hue-2(md-dynamic-height="true")\n' +
    'md-tab(label="metadata")--><site-product-metadata product-id="$ctrl.$productId" site-id="$ctrl.$siteId"></site-product-metadata>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/update/update-site.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$siteId = $data.siteId;\n' +
    '    $ctrl.$productId = $data.productId;\n' +
    '    $ctrl.$approval = $data.approval"></wc-ui-params><fd-ref ng-if="$ctrl.$siteId" fd-ref-path="sites/{{$ctrl.$siteId}}/metadata" then="$ctrl.$site = $data"></fd-ref><fd-ref ng-if="$ctrl.$siteId &amp;&amp; $ctrl.$isRep &amp;&amp; !$ctrl.$current" fd-ref-path="sites/{{$ctrl.$siteId}}/metadataApproval" then="$ctrl.$siteApproval = $data; $ctrl.$current = true"></fd-ref><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$userVendors = $data.vendors;"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column" class="md-truncate"> <div class="md-body-1">Site</div><h2 ng-if="!$ctrl.$siteApproval" style="text-transform: capitalize">{{$ctrl.$site.displayName}} - {{$ctrl.$site.address.address1}}, {{$ctrl.$site.address.city}}, {{$ctrl.$site.address.state}}</h2><h2 ng-if="$ctrl.$siteApproval" class="opacity5">{{$ctrl.$siteApproval.displayName}} - {{$ctrl.$siteApproval.address.address1}}, {{$ctrl.$siteApproval.address.city}}, {{$ctrl.$siteApproval.address.state}}</h2></div><div flex="flex"></div><streetview-el ng-if="$ctrl.$site.address &amp;&amp; !$ctrl.$approval &amp;&amp; !$ctrl.$siteApproval" address="$ctrl.$site.address"></streetview-el><streetview-el ng-if="$ctrl.$siteApproval.address &amp;&amp; !$ctrl.$approval" address="$ctrl.$siteApproval.address" class="opacity5"></streetview-el></div></md-toolbar><div ng-if="$ctrl.$approval" layout="row" layout-wrap="layout-wrap" layout-align="center" class="margin md-whiteframe-2dp padding-half"><div flex-gt-sm="50" flex="100"><div class="md-subhead padding-h-half"><b>New data</b></div><site-detail site-id="$ctrl.$siteId" site="$ctrl.$siteApproval" approval-id="$ctrl.$approval" form="$ctrl.$form = $form"></site-detail></div><div flex-gt-sm="50" flex="100"> <div class="md-subhead padding-h-half"><b>Previous data</b></div><site-detail disabled="disabled" site-id="$ctrl.$siteId" site="$ctrl.$site" approval-id="$ctrl.$approval"></site-detail></div><div flex="100" layout="row" layout-align="end" ng-if="$ctrl.$isAdmin"><site-update-action ng-if="$ctrl.UPDATE &amp;&amp; !$ctrl.REDIRECT" site="$ctrl.$siteApproval" site-id="$ctrl.$siteId" then="$ctrl.DENY = true" catch="$ctrl.UPDATE = false"></site-update-action><approval-deny-action ng-if="$ctrl.DENY &amp;&amp; !$ctrl.REDIRECT" type="siteUpdate" batch="[$ctrl.$approval]" then="\n' +
    '        $ctrl.REDIRECT = true" catch="$ctrl.DENY = false"></approval-deny-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="site.list"></wc-ui-redirect><md-button ng-disabled="$ctrl.$form.$pristine" ng-click="$ctrl.$current = false">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || $ctrl.$form.$pristine" ng-click="$ctrl.UPDATE = true" class="md-raised md-primary"><span ng-if="$ctrl.$form.$dirty">CHANGE</span><span ng-if="$ctrl.$form.$pristine">CHANGES</span></md-button></div></div><md-tabs ng-if="!$ctrl.$approval" md-dynamic-height="true" class="md-primary md-hue-2"><md-tab ng-if="$ctrl.$isRep || $ctrl.$isAdmin" label="products"><site-products site-id="$ctrl.$siteId"></site-products></md-tab><md-tab ng-if="!$ctrl.$userVendors &amp;&amp; !$ctrl.$isSubadmin || $ctrl.$isAdmin" label="distributors"><site-suppliers site-id="$ctrl.$siteId"></site-suppliers></md-tab><md-tab label="PROFILE"><site-metadata site-id="$ctrl.$siteId"></site-metadata></md-tab></md-tabs>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/register/register-site.route.html',
    '<div layout="column" class="absolute-fill"><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="site.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Site</div><h2>Register site</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the site following the instructions on each step"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div ng-if="!$ctrl.url" style="padding: 1rem">Verifying identity...</div><iframe ng-if="$ctrl.url" flex="flex" ng-src="{{$ctrl.url}}" height="100%" width="100%" style="border: 0"></iframe></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/list/list-site.route.html',
    '<div layout="column" class="absolute-fill"> <fd-user then="\n' +
    '    $ctrl.$isRep = $data.isRep;\n' +
    '    $ctrl.$isAdmin = $data.isAdmin;\n' +
    '    $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '    $ctrl.$teamId = $data.teamId;\n' +
    '    $ctrl.$userVendorId = $data.vendorId"></fd-user><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2 ng-if="!$ctrl.$isAdmin">Sites ({{$ctrl.$totalSites}})</h2><h2 ng-if="$ctrl.$isAdmin">Sites</h2><div flex="flex"></div><md-button ng-if="$ctrl.$isRep &amp;&amp; !$ctrl.$sitesForApproval &amp;&amp; !$ctrl.$isSubadmin || $ctrl.$isAdmin" ng-click="$ctrl.$showUploadDialog = true" hide-xs="hide-xs"><div layout="row" layout-align="center center"><md-icon>file_upload</md-icon>IMPORT SITES</div></md-button><md-button ng-if="$ctrl.$isAdmin" ng-href="https://us-central1-drip-1e853.cloudfunctions.net/siteXls?userId={{$ctrl.$userId}}" layout="row" layout-align="start center"><md-icon>view_list</md-icon><div class="padding-h-quarter">Download sites</div></md-button></div></md-toolbar><md-toolbar ng-if="$ctrl.$sitesForApproval &amp;&amp; !$ctrl.$isAdmin" md-theme="grey-theme"><div class="md-toolbar-tools"><div flex="flex" class="md-body-1">Your sites are being processed. This may take up to 48 hours.</div><md-button ng-click="$ctrl.cancelImport($ctrl.$userId)">CANCEL IMPORT</md-button></div></md-toolbar><div ng-if="true" layout="column" flex="flex"><fd-ref ng-if="$ctrl.$isRep &amp;&amp; $ctrl.$position" fd-ref-path="sites" fd-ref-array="rich" then="$ctrl.$sites = $ctrl.$processSites($data); $ctrl.$currentSorting = \'metadata.distance\'; $ctrl.$sortedSites = $ctrl.$sort($ctrl.$sites, \'metadata.distance\')"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref ng-if="$ctrl.$isRep &amp;&amp; !$ctrl.$isAdmin" fd-ref-path="importForApproval/sites/{{$ctrl.$userId}}" then="$ctrl.$sitesForApproval = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref ng-if="!$ctrl.$isRep &amp;&amp; $ctrl.$userVendorId" ng-init="$ctrl.$sites = []" fd-ref-path="vendors/{{$ctrl.$userVendorId}}/products" fd-ref-array="rich" then="$products = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><fd-ref ng-repeat="product in $products" fd-ref-path="products/{{product.key}}/sites" fd-ref-array="rich" then="product.sites = $data"><then><fd-ref ng-repeat="site in product.sites" fd-ref-path="sites/{{site.key}}/metadata" then="$ctrl.$sites.push({key: site.key, metadata: $data})"></fd-ref></then></fd-ref></then></fd-ref><div flex="flex" layout="row" layout-align="center stretch" class="padding-half"><div layout="column" class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a site" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-hide="$ctrl.$query || !$ctrl.$isRep" ui-sref="site.register" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-hide="$ctrl.$query || !$ctrl.$isRep" ui-sref="site.register" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>Add site</div></md-button></div></md-toolbar><md-divider></md-divider><md-virtual-repeat-container flex="flex"><md-table-container><!-- SITES--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.displayName\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.displayName\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>Site name</span></th><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.tier\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.tier\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>Tier</span></th><th md-column="md-column" class="pointer"><span>Products</span></th><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.address.address1\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.address.address1\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>Address</span></th><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.address.city\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.address.city\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>City</span></th><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.address.zip\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.address.zip\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>Zip</span></th><th md-column="md-column" ng-click="$ctrl.$currentSorting = \'metadata.distance\'; $ctrl.$shouldReverse = !$ctrl.$shouldReverse" class="pointer"><md-icon ng-show="$ctrl.$currentSorting === \'metadata.distance\'" style="margin-top: 0.6rem; margin-right: -0.5rem">keyboard_arrow_{{$ctrl.$shouldReverse ? \'up\' : \'down\'}}</md-icon><span>Distance (miles)</span></th><th md-column="md-column" class="pointer"><span>Site Id</span></th><!--th(md-column)span|Street View--></tr></thead><tbody md-body="md-body"><tr md-row="md-row" md-virtual-repeat="site in $ctrl.$filterSites($ctrl.$sortedSites, $ctrl.$teamId, $ctrl.$isAdmin, $ctrl.$isSubadmin, $ctrl.$userId) | filter: $ctrl.siteFilter($ctrl.$query)" ng-class="{ opacity5: site.metadataApproval }" ng-disabled="$ctrl.$userVendorId" ng-click="$ctrl.$goToSite(site.key)" class="pointer"><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !site.metadataApproval" class="capitalize">{{site.metadata.displayName}}</p><p ng-if="$ctrl.$isRep &amp;&amp; site.metadataApproval" class="capitalize">{{site.metadataApproval.displayName}}</p></td><td md-cell="md-cell"><p>{{site.metadata.tier.replace(\'tier\', \'\')}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$count(site.products) || 0}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !site.metadataApproval" class="capitalize">{{site.metadata.address.address1}}</p><p ng-if="$ctrl.$isRep &amp;&amp; site.metadataApproval" class="capitalize">{{site.metadataApproval.address.address1}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !site.metadataApproval" class="capitalize">{{site.metadata.address.city}}, {{site.metadata.address.state}}</p><p ng-if="$ctrl.$isRep &amp;&amp; site.metadataApproval" class="capitalize">{{site.metadataApproval.address.city}}, {{site.metadataApproval.address.state}}</p></td><td md-cell="md-cell"><p ng-if="!$ctrl.$isRep || !site.metadataApproval" class="capitalize">{{site.metadata.address.zip}}</p><p ng-if="$ctrl.$isRep &amp;&amp; site.metadataApproval" class="capitalize">{{site.metadataApproval.address.zip}}</p></td><td md-cell="md-cell"><p>{{site.metadata.distance}}</p></td><td md-cell="md-cell"><p>{{site.key}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$filterSites($ctrl.$sites, $ctrl.$teamId, $ctrl.$isAdmin, $ctrl.$isSubadmin, $ctrl.$userId).length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add sites to your profile to open all features for your products.</div><md-button ui-sref="site.add" class="md-raised md-primary"><span>GET STARTED</span></md-button><p></p></div></div></md-table-container></md-virtual-repeat-container></div></div></div></div><wc-dialog ng-if="$ctrl.$showUploadDialog" wc-dialog-template="true" wc-dialog-modal="false" catch="$ctrl.$showUploadDialog = false"><wc-dialog-template layout="column" style="max-width: 55rem"><md-content layout="column" class="padding"><div class="md-title">Importing sites from an .xlsx file</div><div class="md-body-1 opacity5">To import sites from an Excel file, you have to make sure that it has an .xlsx extension and that meets the following format:</div><md-content style="height: 8rem" class="padding-v-half"><div layout="column" style="min-width: 50rem; padding: 0" class="cell"><div layout="row" class="md-caption"><div flex="flex" class="cell">displayName</div><div flex="flex" class="cell">contactName</div><div flex="flex" class="cell">contactPhone</div><div flex="flex" class="cell">notes</div><div flex="flex" class="cell">address1</div><div flex="flex" class="cell">address2</div><div flex="flex" class="cell">city</div><div flex="flex" class="cell">state</div><div flex="flex" class="cell">zip</div><div flex="flex" ng-if="$ctrl.$isAdmin" class="cell">userId</div></div><div layout="row" class="md-caption"><div flex="flex" class="cell">Store name</div><div flex="flex" class="cell">John Williams</div><div flex="flex" class="cell">(123) 456 - 7890</div><div flex="flex" class="cell">Very good site!</div><div flex="flex" class="cell">100 Address St.</div><div flex="flex" class="cell">Unit A</div><div flex="flex" class="cell">Athenas</div><div flex="flex" class="cell">AR</div><div flex="flex" class="cell">24680</div><div flex="flex" ng-if="$ctrl.$isAdmin" class="cell">{{$ctrl.$userId}}</div></div><div layout="row" class="md-caption"><div flex="flex" class="cell">Store 2</div><div flex="flex" class="cell">Bryan Anderson</div><div flex="flex" class="cell">(123) 456 - 7890</div><div flex="flex" class="cell">Very bad site!</div><div flex="flex" class="cell">200 Address St.</div><div flex="flex" class="cell">Apt 204</div><div flex="flex" class="cell">New York</div><div flex="flex" class="cell">NY</div><div flex="flex" class="cell">12345</div><div flex="flex" ng-if="$ctrl.$isAdmin" class="cell">{{$ctrl.$userId}}</div></div></div></md-content></md-content><md-content layout="row" layout-align="end"><md-button ng-if="$ctrl.$isRep &amp;&amp; !$ctrl.$sitesForApproval || $ctrl.$isAdmin" ng-click="$ctrl.$showUploadDialog = true" hide-xs="hide-xs"><wc-upload then="$ctrl.$file = $file"><then><fd-upload ng-if="$ctrl.$file" fd-upload-file="$ctrl.$file" fd-upload-filename="$ctrl.$isAdmin ? \'/sitesData.xlsx\' : \'/uploadRequests/\' + $ctrl.$userId + \'/sitesData.xlsx\'" before="$ctrl.$progress = $progress" then="$ctrl.notifyImport($ctrl.$userId, $ctrl.$isAdmin); $ctrl.$file = null"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="true"><wc-dialog-template><div class="padding"><div class="md-title">Uploading file ({{$ctrl.$progress}}%)</div><div class="md-body-1">Please wait until the upload is complete</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></fd-upload></then><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></wc-upload><div layout="row" layout-align="end"><md-icon>file_upload</md-icon>IMPORT (MAX 400 SITES)</div></md-button></md-content></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/addProducts/addProducts-site.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$buildUrl(\'https://drip.igniteit.io/productsWizard/\' + $data.siteId)"></wc-ui-params><div layout="column" class="absolute-fill"><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Site</div><h2>Register products</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the site following the instructions on each step"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div ng-if="!$ctrl.$url" style="padding: 1rem">Verifying identity...</div><iframe ng-if="$ctrl.$url" flex="flex" ng-src="{{$ctrl.$url}}" height="100%" width="100%" style="border: 0"></iframe></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/addProduct/addProduct-site.route.html',
    '<wc-ui-params then="\n' +
    '  $ctrl.$siteId = $data.siteId;\n' +
    '  $ctrl.$productId = $data.productId;\n' +
    '  $ctrl.$productParams = $data.productId;\n' +
    '  $ctrl.$supplierParams = $data.supplierId;">     </wc-ui-params><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$teamId = $data.teamId;\n' +
    '  $ctrl.$userProducts = $data.products"></fd-user><fd-ref fd-ref-path="sites/{{$ctrl.$siteId}}/metadata/displayName" then="$ctrl.$siteName = $data"></fd-ref><fd-ref fd-ref-path="sites/{{$ctrl.$siteId}}/metadata/tier" then="$ctrl.$siteTier = $data"></fd-ref><fd-ref ng-if="$ctrl.$productId" fd-ref-path="products/{{$ctrl.$productId}}/metadata/tiers" then="$ctrl.$productTiers = $data"></fd-ref><div ng-if="$ctrl.CREATE"><site-add-product-action ng-if="$ctrl.validateTiers($ctrl.$siteTier, $ctrl.$productTiers)" product-id="$ctrl.$productId" site-id="$ctrl.$siteId" registration="$ctrl.$registration" then="$ctrl.CREATE = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false"></site-add-product-action><wc-dialog ng-if="!$ctrl.validateTiers($ctrl.$siteTier, $ctrl.$productTiers)" wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.CREATE = false"><wc-dialog-template class="relative"><div style="max-width: 20rem" class="padding-half"><div class="md-title">Continue?</div><span>Site\'s Tier Level does not match.</span><span ng-if="!$ctrl.$isAdmin">&nbsp;You may continue but the admin will be notified.</span></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.CREATE = false">Cancel</md-button><md-button ng-click="$ctrl.ADD_CONFIRMED = true" class="md-primary md-raised"><span>Add product</span><span ng-if="!$ctrl.$isAdmin">&nbsp;and notify admin</span></md-button></div><site-add-product-action ng-if="$ctrl.ADD_CONFIRMED" product-id="$ctrl.$productId" site-id="$ctrl.$siteId" registration="$ctrl.$registration" then="$ctrl.CREATE = false; $ctrl.$sendRequest({ siteId: $ctrl.$siteId, productId: $ctrl.$productId, userId: $ctrl.$userId }); $ctrl.ADD_CONFIRMED = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false; $ctrl.ADD_CONFIRMED = false"></site-add-product-action></wc-dialog-template></wc-dialog></div><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="site.update" wc-ui-redirect-params="{ siteId: $ctrl.$siteId }"></wc-ui-redirect><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Site - {{$ctrl.$siteName}}</div><h2>Add product to site</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the product to the site, then add images and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$registration = {}" class="margin padding-half md-whiteframe-2dp container"><div class="padding-half"><div layout="row" layout-wrap="layout-wrap"><div flex="50"> <div class="md-body-2"><b>PRODUCT TO ADD</b></div><div class="padding-quarter"></div><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="products" fd-ref-array="rich" then="$ctrl.$products = $ctrl.$filterProducts($data, $ctrl.$teamId, $ctrl.$isAdmin, $ctrl.$isRep); $ctrl.$autocompleteProducts = []"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><div ng-if="$ctrl.$userProducts[product.key] || $ctrl.$isAdmin" ng-init="$ctrl.$autocompleteProducts.push(product)" ng-repeat="product in $ctrl.$products"></div></then></fd-ref><md-input-container ng-if="$ctrl.$productParams === product.key" ng-init="$displayName = product.metadataApproval.displayName || product.metadata.displayName" ng-repeat="product in $ctrl.$products" class="no-error-message"><label>Product name</label><input readonly="readonly" ng-model="$displayName"/></md-input-container><md-input-container ng-if="!$ctrl.$productId" class="no-error-message"><label>Search for a product</label><input ng-model="$ctrl.$query"/></md-input-container><md-content style="max-height: 12rem;background:white" ng-if="!$ctrl.$productId"><div ng-repeat="product in $ctrl.$autocompleteProducts | filter: $ctrl.$query" ng-click="$ctrl.$productId = product.key; $ctrl.$productName = product.metadata.displayName" style="cursor:pointer" layout="row" layout-align="start center"><a flex="flex" href="">{{product.metadata.displayName}}</a><md-button>SELECT</md-button></div></md-content><div layout="row" layout-align="start center" ng-if="$ctrl.$productId"><div flex="flex">{{$ctrl.$productName}}</div><md-button ng-click="$ctrl.$productId = \'\'; $ctrl.$productName = \'\'; $ctrl.$query = \'\'">CHANGE</md-button></div></div></div></div><site-product-registration registration="$ctrl.$registration" form="$ctrl.$form = $form"></site-product-registration><div ng-if="!$ctrl.validateTiers($ctrl.$siteTier, $ctrl.$productTiers)" class="padding-half"><span>* This product does not match this site\'s Tier.</span><span ng-if="!$ctrl.$isAdmin">&nbsp;You can still add it but an admin will be notified</span></div><div layout="row"><div flex="flex"></div><md-button ui-sref="site.update({siteId: $ctrl.$siteId})">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || !$ctrl.$productId" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/addDisplay/addDisplay-site.route.html',
    '<wc-ui-params then="\n' +
    '  $ctrl.$siteId = $data.siteId;">     </wc-ui-params><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$userDisplays = $data.displays"></fd-user><fd-ref fd-ref-path="sites/{{$ctrl.$siteId}}/metadata/displayName" then="$ctrl.$siteName = $data"></fd-ref><site-add-product-action ng-if="$ctrl.CREATE" products="$ctrl.$displaysObj[$ctrl.$displayId].products" site-id="$ctrl.$siteId" registration="$ctrl.$registration" then="$ctrl.CREATE = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false"></site-add-product-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="site.update" wc-ui-redirect-params="{ siteId: $ctrl.$siteId }"></wc-ui-redirect><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Site - {{$ctrl.$siteName}}</div><h2>Add display to site</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the display to the site, then add images and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$registration = {}" class="margin padding-half md-whiteframe-2dp container"><div class="padding-half"><div layout="row" layout-wrap="layout-wrap"><div flex="50"> <div class="md-body-2"><b>DISPLAY TO ADD</b></div><div class="padding-quarter"></div><fd-ref fd-ref-path="displays" then="$ctrl.$displaysObj = $data"></fd-ref><fd-ref fd-ref-path="displays" fd-ref-array="rich" then="$ctrl.$displays = $data; $ctrl.$autocompleteDisplays = []"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><div ng-if="$ctrl.$userProducts[product.key] || $ctrl.$isAdmin" ng-init="$ctrl.$autocompleteProducts.push(product)" ng-repeat="product in $ctrl.$products"></div><div ng-if="$ctrl.$userDisplays[display.key] || $ctrl.$isAdmin" ng-init="$ctrl.$autocompleteDisplays.push(display)" ng-repeat="display in $ctrl.$displays"></div></then></fd-ref><md-autocomplete md-floating-label="Search for a display" md-no-cache="true" md-items="display in $ctrl.$autocompleteDisplays | filter: $ctrl.$query" md-item-text="display.metadata.displayName" md-search-text="$ctrl.$query" md-selected-item-change="$ctrl.$displayId = display.key" md-require-match="true" class="no-error-message"><md-item-template>{{display.metadata.displayName}}</md-item-template></md-autocomplete></div></div></div><site-product-registration registration="$ctrl.$registration" form="$ctrl.$form = $form"></site-product-registration><div layout="row"><div flex="flex"></div><md-button ui-sref="site.update({siteId: $ctrl.$siteId})">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid || !$ctrl.$displayId" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/site/add/add-site.route.html',
    '<site-add-action ng-if="$ctrl.CREATE" site="$ctrl.$site" then="$ctrl.$siteId = $data" catch="$ctrl.CREATE = false"></site-add-action><wc-ui-redirect ng-if="$ctrl.$siteId" wc-ui-redirect-sref="site.list"></wc-ui-redirect><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="site.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Site</div><h2>New site</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the site and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$site = {}" class="margin padding-half md-whiteframe-2dp container"><site-detail site="$ctrl.$site" check-address="true" form="$ctrl.$form = $form"></site-detail><div layout="row"><div flex="flex"></div><md-button ui-sref="site.list">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/review/update/update-review.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$reviewId=$data.reviewId;\n' +
    '    $ctrl.$paramsReady = true;"></wc-ui-params><wc-ui-redirect ng-if="!$ctrl.$reviewId &amp;&amp; $ctrl.$paramsReady" wc-ui-redirect-sref="product.list"></wc-ui-redirect><fd-ref ng-if="$ctrl.$reviewId" fd-ref-path="reviews/{{$ctrl.$reviewId}}" then="\n' +
    '  $ctrl.$data = $data;\n' +
    '    $ctrl.$review = $data.review;\n' +
    '    $ctrl.$timestamp = $data.timestamp;\n' +
    '    $ctrl.$productId = $data.productId;\n' +
    '    $ctrl.$siteId = $data.siteId;\n' +
    '    $ctrl.$review.siteId = $data.siteId"></fd-ref><fd-ref ng-if="$ctrl.$productId" fd-ref-path="products/{{$ctrl.$productId}}/metadata" then="$ctrl.$product = $data"></fd-ref><review-add-action ng-if="$ctrl.CREATE" review="$ctrl.$review" product-id="$ctrl.$productId" then="$ctrl.CREATE = false; $ctrl.PRODUCT = true" catch="$ctrl.CREATE = false"></review-add-action><site-update-product-action ng-if="$ctrl.PRODUCT" product-id="$ctrl.$productId" site-id="$ctrl.$review.siteId" gallery="$ctrl.$gallery" then="$ctrl.PRODUCT = false; $ctrl.$back()" catch="$ctrl.PRODUCT = false"></site-update-product-action><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-if="$ctrl.$productId" ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"><div class="md-body-1">Product: {{$ctrl.$product.displayName}}</div><h2>Review from {{$ctrl.$timestamp | date}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the new review and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$review = {}" class="margin padding-half md-whiteframe-2dp container"><review-detail ng-if="$ctrl.$review.siteId" review="$ctrl.$review" product-id="$ctrl.$productId" form="$ctrl.$form = $form"></review-detail><div class="padding-half"><div ng-if="$ctrl.$photoFile" layout="row" layout-align="start center" class="md-body-2 padding-v-half"><b>IMAGES</b><div flex="flex"></div></div><div ng-init="$ctrl.$gallery = $ctrl.$gallery || []" layout="row" layout-align="center" class="margin-quarter"><div flex="50"><div ng-repeat="image in $ctrl.$gallery" ng-style="{ backgroundImage: \'url(\'+image+\')\' }" class="background-image ratio-4-3 margin-quarter"></div></div></div></div><div layout="row"><div flex="flex"></div><md-button ng-disabled="true">READ ONLY</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/review/add/add-review.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$siteId=$data.siteId;\n' +
    '    $ctrl.$vendorId=$data.vendorId;\n' +
    '    $ctrl.$productId=$data.productId;\n' +
    '    $ctrl.$paramsReady = true;"></wc-ui-params><wc-ui-params then="$ctrl.$productId=$data.productId; $ctrl.$paramsReady = true;"></wc-ui-params><wc-ui-redirect ng-if="!$ctrl.$productId &amp;&amp; $ctrl.$paramsReady" wc-ui-redirect-sref="product.list"></wc-ui-redirect><fd-ref ng-if="$ctrl.$productId" fd-ref-path="products/{{$ctrl.$productId}}/metadata" then="$ctrl.$product = $data"></fd-ref><review-add-action ng-if="$ctrl.CREATE" review="$ctrl.$review" gallery="$ctrl.$gallery" product-id="$ctrl.$productId" then="$ctrl.CREATE = false; $ctrl.PRODUCT = true" catch="$ctrl.CREATE = false"></review-add-action><site-update-product-action ng-if="$ctrl.PRODUCT" product-id="$ctrl.$productId" site-id="$ctrl.$review.siteId" gallery="$ctrl.$gallery" then="$ctrl.PRODUCT = false; $ctrl.$back()" catch="$ctrl.PRODUCT = false"></site-update-product-action><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-if="$ctrl.$productId" ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Product: {{$ctrl.$product.displayName}}</div><h2>New review</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the new review and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$review = {}" class="margin padding-half md-whiteframe-2dp container"><review-detail review="$ctrl.$review" product-id="$ctrl.$productId" form="$ctrl.$form = $form"></review-detail><div class="padding-half"><div layout="row" layout-align="start center" class="md-body-2 padding-v-half"><b>IMAGES</b><div flex="flex"></div><md-button class="md-icon-button"><md-icon>add_a_photo</md-icon><wc-upload wc-upload-dimensions="{\n' +
    '              width: 800,\n' +
    '              height: 600\n' +
    '            }" then="$ctrl.$photoFile = $file"><then><fd-upload ng-if="$ctrl.$photoFile" fd-upload-file="$ctrl.$photoFile" before="$ctrl.percentage = $progress" then="$ctrl.$gallery.push($data.url)"><before><wc-dialog wc-dialog-progress="{{$ctrl.percentage}}" wc-dialog-labels="{\n' +
    '                      title: \'Uploading (\' + $ctrl.percentage + \'%)\',\n' +
    '                      body: \'Please wait until image is fully uploaded.\'\n' +
    '                    }"></wc-dialog></before><catch><wc-toast wc-toast-message="Error uploading image"></wc-toast></catch></fd-upload></then></wc-upload></md-button></div><div ng-init="$ctrl.$gallery = $ctrl.$gallery || []" layout="row" layout-align="center" class="margin-quarter"><div flex="50"><div ng-repeat="image in $ctrl.$gallery" ng-style="{ backgroundImage: \'url(\'+image+\')\' }" class="background-image ratio-4-3 margin-quarter"></div></div></div></div><div layout="row"><div flex="flex"></div><md-button ng-click="$ctrl.$back()">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/update/update-product.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$productId=$data.productId;\n' +
    '    $ctrl.$loadSites();\n' +
    '    $ctrl.$vendorId=$data.vendorId;\n' +
    '    $ctrl.$siteId=$data.siteId;\n' +
    '    $ctrl.$approval = $data.approval;\n' +
    '    $ctrl.$selectedTabs = $ctrl.$selectedTabs || $ctrl.parseInt($data.selectedTab)"></wc-ui-params><fd-ref ng-if="$ctrl.$productId" fd-ref-path="products/{{$ctrl.$productId}}" then="$ctrl.$product = $data.metadataApproval || $data.metadata || {}"></fd-ref><fd-ref ng-if="$ctrl.$productId &amp;&amp; $ctrl.$approval" fd-ref-path="products/{{$ctrl.$productId}}/metadataApproval" then="$ctrl.$productApproval = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><fd-ref ng-if="$ctrl.$productId" fd-ref-path="products/{{$ctrl.$productId}}/sites" then="$ctrl.sitesIndex = $data"></fd-ref><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$isVendor = !!$data.vendors"></fd-user><fd-auth then="$ctrl.$userId = $data.uid"></fd-auth><div layout="column" class="absolute-fill"><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column" class="md-truncate"><div class="md-body-1">Product</div><h2 ng-hide="$ctrl.$productApproval">{{$ctrl.$product.displayName}}</h2><h2 ng-show="$ctrl.$productApproval">{{$ctrl.$productApproval.displayName}}</h2></div><div flex="flex"></div><div layout="row" layout-align="start center" ng-if="$ctrl.base === \'paul\'"><md-progress-circular md-mode="determinate" md-diameter="30" value="{{$ctrl.$progressPercentage}}" class="md-accent"></md-progress-circular><div class="md-body-1 margin-h-half">{{$ctrl.$totalReviews}} of {{$ctrl.$totalSites}} sites reviewed</div></div><md-button ng-if="$ctrl.$isAdmin" ng-href="https://us-central1-drip-1e853.cloudfunctions.net/siteXls?productId={{$ctrl.$productId}}&amp;userId={{$ctrl.$userId}}" layout="row" layout-align="start center"><md-icon>view_list</md-icon><div class="padding-h-quarter">Download sites</div></md-button><md-button ng-click="$ctrl.$info = true" ng-hide="$ctrl.$product.pendingApproval &amp;&amp; $ctrl.$isAdmin" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="This view lets you update the product info, products and sales"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div ng-if="$ctrl.$productApproval" layout="row" layout-align="center" class="margin md-whiteframe-2dp padding-half"><div flex-gt-sm="50" flex="100"><div class="md-subhead padding-h-half"><b>New data</b></div><product-detail approval-id="$ctrl.$approval" product="$ctrl.$productApproval" form="$ctrl.$form = $form"></product-detail></div><div flex-gt-sm="50" flex="100"> <div class="md-subhead padding-h-half"><b>Previous data</b></div><product-detail approval-id="$ctrl.$approval" product="$ctrl.$product" form="$ctrl.$form = $form"></product-detail></div></div><md-tabs flex="flex" ng-if="!$ctrl.$productApproval &amp;&amp; $ctrl.$product" md-selected="$ctrl.$selectedTabs" md-enable-disconnect="true" class="md-primary md-hue-2"><md-tab md-on-select="$ctrl.$selectTab(0)" label="reviews"><product-reviews product-id="$ctrl.$productId"></product-reviews></md-tab><md-tab label="sites" md-on-select="$ctrl.$selectTab(1)"><product-sites product-id="$ctrl.$productId"></product-sites></md-tab><md-tab md-on-select="$ctrl.$selectTab(2)" ng-if="$ctrl.$isVendor || $ctrl.$isAdmin" label="report"><product-reports product-id="$ctrl.$productId"></product-reports></md-tab><md-tab md-on-select="$ctrl.$selectTab(3)" label="PROFILE" ng-if="$ctrl.$isRep"><product-metadata product-id="$ctrl.$productId"></product-metadata></md-tab></md-tabs></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/list/list-product.route.html',
    '<fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$teamId = $data.teamId;\n' +
    '  $ctrl.$userProducts = $data.products;\n' +
    '  $ctrl.$userVendorId = $data.vendorId;\n' +
    '  $ctrl.$userVendors = $data.vendors;"><then><fd-ref fd-ref-path="products" fd-ref-array="rich" then="$ctrl.$products = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref></then></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Products</h2><div flex="flex"></div><md-button ng-hide="$ctrl.$isRep" href="https://us-central1-drip-1e853.cloudfunctions.net/productXls" layout="row" layout-align="start center"><md-icon>view_list</md-icon><div class="padding-h-quarter">Download list</div></md-button></div></md-toolbar><div ng-init="$ctrl.$approvalQueue = []" layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a product" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- VENDORS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Product name</span></th><th md-column="md-column"><span>Vendor</span></th><th md-column="md-column" ng-if="$ctrl.$isAdmin"><span>ProductId</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-show="product.metadata" ng-class="{ opacity5: product.metadata.pendingApproval }" ng-repeat="product in $ctrl.$filterProducts($ctrl.$products, $ctrl.$teamId, $ctrl.$userProducts, $ctrl.$userVendorId, $ctrl.$userVendors, $ctrl.$isAdmin, $ctrl.$isSubadmin) | filter: $ctrl.$query"><td md-cell="md-cell"><a ui-sref="product.update({productId: product.key})">{{product.metadata.displayName}}</a></td><td md-cell="md-cell"><fd-ref fd-ref-path="vendors/{{product.metadata.vendorId}}/metadata/displayName" then="product.vendorName = $data"><then><p>{{product.vendorName}}</p></then></fd-ref></td><td md-cell="md-cell" ng-show="$ctrl.$isAdmin">{{product.key}}</td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$filterProducts($ctrl.$products, $ctrl.$teamId, $ctrl.$userProducts, $ctrl.$userVendorId, $ctrl.$userVendors, $ctrl.$isAdmin, $ctrl.$isSubadmin).length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a product from a vendor so it can be associated with that specific vendor</div><md-button ui-sref="vendor.list" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/product/add/add-product.route.html',
    '<wc-ui-params then="\n' +
    '  $ctrl.$vendorId=$data.vendorId;\n' +
    '  $ctrl.$siteId=$data.siteId;\n' +
    '  $ctrl.$paramsReady = true;"></wc-ui-params><wc-ui-redirect ng-if="!$ctrl.$vendorId &amp;&amp; !$ctrl.$siteId &amp;&amp; $ctrl.$paramsReady" wc-ui-redirect-sref="product.list"></wc-ui-redirect><wc-ui-redirect ng-if="$ctrl.REDIRECT &amp;&amp; !$ctrl.$siteId" wc-ui-redirect-sref="vendor.update" wc-ui-redirect-params="{ vendorId: $ctrl.$vendorId }"></wc-ui-redirect><wc-ui-redirect ng-if="$ctrl.REDIRECT &amp;&amp; $ctrl.$siteId" wc-ui-redirect-sref="site.addProduct" wc-ui-redirect-params="{ productId: $ctrl.REDIRECT, siteId: $ctrl.$siteId }"></wc-ui-redirect><fd-ref ng-if="$ctrl.$vendorId" fd-ref-path="vendors/{{$ctrl.$vendorId}}/metadata" then="$ctrl.$vendor = $data"></fd-ref><fd-ref ng-if="$ctrl.$siteId" fd-ref-path="sites/{{$ctrl.$siteId}}" then="$ctrl.$site = $data.metadataApproval || $data.metadata"></fd-ref><fd-user then="$ctrl.$teamId = $data.teamId"></fd-user><product-add-action ng-if="$ctrl.CREATE" vendor-id="$ctrl.$vendorId" team-id="$ctrl.$teamId" product="$ctrl.$product" then="$ctrl.REDIRECT = $data" catch="$ctrl.CREATE = false"></product-add-action><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.$back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div ng-show="$ctrl.$vendor &amp;&amp; !$ctrl.$site" class="md-body-1">Vendor: {{$ctrl.$vendor.displayName}}</div><div ng-show="$ctrl.$site" class="md-body-1">Site: {{$ctrl.$site.displayName}}</div><h2>New product</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info from the new product and then click on CREATE"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$product = {}" class="margin padding-half md-whiteframe-2dp container"><div ng-if="!$ctrl.$vendorId" class="padding-half"><div class="md-body-2"><b>VENDOR</b></div><div class="padding-quarter"></div><fd-ref fd-ref-path="vendors" fd-ref-array="rich" then="$ctrl.$vendors = $data; $ctrl.$autocompleteVendors = []"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><div ng-init="$ctrl.$autocompleteVendors.push(vendor)" ng-repeat="vendor in $ctrl.$vendors"></div></then></fd-ref><md-autocomplete md-floating-label="Search for a vendor" md-no-cache="true" md-search-text="$ctrl.$vendorQuery" md-items="vendor in $ctrl.$autocompleteVendors | filter: $ctrl.$vendorQuery" md-item-text="vendor.metadataApproval.displayName || vendor.metadata.displayName" md-selected-item-change="$ctrl.$vendorId = vendor.key" md-require-match="true" class="no-error-message"><md-item-template>{{vendor.metadataApproval.displayName || vendor.metadata.displayName}}</md-item-template></md-autocomplete></div><product-detail product="$ctrl.$product" form="$ctrl.$form = $form"></product-detail><div layout="row"><div flex="flex"></div><md-button ui-sref="vendor.update({vendorId: $ctrl.$vendorId})">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/category/update/update-category.route.html',
    '<wc-ui-params then="\n' +
    '    $ctrl.$categoryId=$data.categoryId;"></wc-ui-params><fd-ref ng-if="$ctrl.$categoryId" fd-ref-path="categories/{{$ctrl.$categoryId}}/metadata" then="$ctrl.$category = $data"></fd-ref><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ui-sref="category.list" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column" class="md-truncate"> <div class="md-body-1">Category</div><h2>{{$ctrl.$category.displayName}}</h2></div><div flex="flex"></div></div></md-toolbar><md-content><category-reviews category-id="$ctrl.$categoryId"></category-reviews></md-content><!--md-tabs.md-primary.md-hue-2(md-dynamic-height="true")\n' +
    'md-tab(label="reviews")\n' +
    '  category-reviews(\n' +
    '    category-id="$ctrl.$categoryId")\n' +
    'md-tab(label="metadata")\n' +
    '  category-metadata(\n' +
    '    category-id="$ctrl.$categoryId")-->');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/category/list/list-category.route.html',
    '<wc-ui-params then="\n' +
    '  $ctrl.$embedded = $data.embedded;">     </wc-ui-params><md-toolbar ng-if="!$ctrl.$embedded" class="md-hue-2"><div class="md-toolbar-tools"><h2>Categories</h2><div flex="flex"></div><md-button ng-click="" class="md-icon-button opacity5"><md-icon>help</md-icon></md-button></div></md-toolbar><fd-ref fd-ref-path="categories" fd-ref-array="rich" then="$ctrl.$categories = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><category-add-action ng-if="$ctrl.ADD" then="$ctrl.ADD = false" catch="$ctrl.ADD = false"></category-add-action><div layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar ng-if="!$ctrl.$embedded" md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a category" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-hide="$ctrl.$query" ng-click="$ctrl.ADD = true" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-hide="$ctrl.$query" ng-click="$ctrl.ADD = true" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- SITES--><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Category name</span></th><th md-column="md-column"><span>Category reviews</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-repeat="category in $ctrl.$categories | orderBy: \'metadata.displayName\' | filter: $ctrl.$query" ui-sref="category.update({categoryId: category.key})" class="pointer"><td md-cell="md-cell"><p>{{category.metadata.displayName}}</p></td><td md-cell="md-cell"><p>{{$ctrl.$count(category.reviews)}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$categories.length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a category to set a baseline to compare product reviews</div><md-button ng-click="$ctrl.ADD = true" class="md-raised md-primary"><span>GET STARTED</span></md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/update/update-display.route.html',
    '<wc-ui-params then="$ctrl.$displayId=$data.displayId"></wc-ui-params><fd-ref ng-if="$ctrl.$displayId" fd-ref-path="displays/{{$ctrl.$displayId}}" then="$ctrl.$display = $data"></fd-ref><fd-user then="\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$isAdmin = $data.isAdmin"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.back()" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Distributor</div><h2>{{$ctrl.$display.metadata.displayName}}</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="This view lets you update the distributor info"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><md-tabs ng-if="$ctrl.$isAdmin" md-dynamic-height="true" class="md-primary md-hue-2"><md-tab label="PROFILE"><display-metadata display-id="$ctrl.$displayId">    </display-metadata></md-tab></md-tabs>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/list/list-display.route.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"></fd-user><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Distributors</h2><div flex="flex"></div></div></md-toolbar><fd-ref fd-ref-path="suppliers" fd-ref-array="rich" then="$ctrl.$suppliers = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before></fd-ref><div layout="row" layout-align="center" class="margin-half"><div class="md-whiteframe-2dp container"><md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="Search for a supplier" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="supplier.add" hide-gt-xs="hide-gt-xs" class="md-icon-button"><md-icon>add</md-icon></md-button><md-button ng-if="$ctrl.$isAdmin" ng-hide="$ctrl.$query" ui-sref="supplier.add" hide-xs="hide-xs" class="md-primary md-raised"><div layout="row" layout-align="center center"><md-icon>add</md-icon>CREATE NEW</div></md-button></div></md-toolbar><md-divider></md-divider><md-table-container><!-- SUPPLIERS--><table md-table="md-table" ng-model="plop"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Distributor name</span></th><th md-column="md-column"><span>Contact name</span></th><th md-column="md-column"><span>Contact phone</span></th></tr></thead><tbody md-body="md-body"><tr md-row="md-row" ng-show="supplier.metadata.displayName" ng-repeat="supplier in $ctrl.$suppliers | filter: $ctrl.$query" ui-sref="supplier.update({supplierId: supplier.key})" class="pointer"><td md-cell="md-cell"><p>{{supplier.metadata.displayName}}</p></td><td md-cell="md-cell"><p>{{supplier.metadata.contactName}}</p></td><td md-cell="md-cell"><p>{{supplier.metadata.contactPhone}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!$ctrl.$suppliers.length" layout="column" layout-align="center center" class="margin padding"><div layout="column" layout-align="center center" class="container-half"><p></p><div class="md-title center">Add a distributor to track which distributors provide the different stores from a central place.</div><md-button ui-sref="supplier.add" class="md-raised md-primary">GET STARTED</md-button><p></p></div></div></md-table-container></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/display/add/add-display.route.html',
    '<wc-ui-params then="$ctrl.$vendorId = $data.vendorId"></wc-ui-params><display-add-action ng-if="$ctrl.CREATE" display="$ctrl.$display" vendor-id="$ctrl.$vendorId" then="$ctrl.CREATE = false; $ctrl.REDIRECT = true" catch="$ctrl.CREATE = false"></display-add-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-back="true"></wc-ui-redirect><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><md-button ng-click="$ctrl.REDIRECT = true" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><div layout="column"> <div class="md-body-1">Display</div><h2>New display</h2></div><div flex="flex"></div><md-button ng-click="$ctrl.$info = true" class="md-icon-button opacity5"><wc-toast ng-if="$ctrl.$info" ng-init="$ctrl.$info = false" wc-toast-message="Add the info for the display and then click the CREATE button"></wc-toast><md-icon>help</md-icon></md-button></div></md-toolbar><div layout="row" layout-align="center"><div ng-init="$ctrl.$display = {metadata: {}, products: {}}" class="margin padding-half md-whiteframe-2dp container"><display-detail display="$ctrl.$display" form="$ctrl.$form = $form"></display-detail><div layout="row"><div flex="flex"></div><md-button ng-click="$ctrl.REDIRECT = true">CANCEL</md-button><md-button ng-disabled="$ctrl.$form.$invalid" ng-click="$ctrl.CREATE = true" class="md-raised md-primary">CREATE</md-button></div></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/approval/list/list-approval.route.html',
    '<md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>Changes for approval</h2><div flex="flex"></div></div></md-toolbar><div layout="row" layout-align="center" class="margin-half"><div class="container"><approval-update-review></approval-update-review><p></p><approval-update-site></approval-update-site><p></p><approval-update-product></approval-update-product><p></p><approval-register-product-site></approval-register-product-site><p></p><approval-uploaded-sites></approval-uploaded-sites><p></p><approval-invalid-tier></approval-invalid-tier><p></p><approval-tier-updates></approval-tier-updates></div></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/_components/toolbar/toolbar.comp.html',
    '<fd-auth then="$ctrl.$auth = $data"></fd-auth><fd-user then="$ctrl.$user = $data"></fd-user><fd-user then="\n' +
    '  $ctrl.$isAdmin = $data.isAdmin;\n' +
    '  $ctrl.$isRep = $data.isRep;\n' +
    '  $ctrl.$vendorId = $data.vendorId;\n' +
    '  $ctrl.$repId = $data.repId;\n' +
    '  $ctrl.$repId &amp;&amp; $ctrl.$getUser($ctrl.$repId)"></fd-user><fd-ref ng-if="$ctrl.$isRep" fd-ref-path="approval" then="$ctrl.$approval = !!$data"></fd-ref><fd-ref ng-if="$ctrl.$isAdmin" fd-ref-path="importForApproval/sites" then="$ctrl.$sitesApproval = !!$data"></fd-ref><fd-ref ng-if="$ctrl.$isAdmin" fd-ref-path="invalidTiers" then="$ctrl.$invalidTiers = !!$data"></fd-ref><fd-ref ng-if="$ctrl.$isAdmin" fd-ref-path="tierUpdates" then="$ctrl.$tierUpdates = !!$data"></fd-ref><fd-ref ng-if="$ctrl.$vendorId" fd-ref-path="vendors/{{$ctrl.$vendorId}}/metadata/displayName" then="$ctrl.$vendorName = $data"></fd-ref><fd-ref ng-if="$ctrl.$vendorId" fd-ref-path="vendors/{{$ctrl.$vendorId}}/metadata/logoUrl" then="$ctrl.$logoUrl = $data"></fd-ref><approval-clear-action ng-if="$ctrl.CLEAR" then="$ctrl.CLEAR = false" catch="$ctrl.CLEAR = false"></approval-clear-action><user-password-action ng-if="$ctrl.PASSWORD" then="$ctrl.PASSWORD = false" catch="$ctrl.PASSWORD = false"></user-password-action><md-toolbar md-theme="grey-theme" class="md-whiteframe-6dp md-primary md-hue-1"><div class="md-toolbar-tools"><md-button hide-gt-sm="hide-gt-sm" ng-if="$ctrl.$auth" ng-click="$ctrl.$toggleSidenav(\'sidenav\');" class="md-icon-button"><md-icon>menu</md-icon></md-button><md-button layout="row" ui-sref="home"><img hide="hide" show-gt-sm="show-gt-sm" style="height: 32px" ng-src="images/icon-inverted{{$ctrl.base === \'paul\' ? \'-bw\' : \'\'}}.png"/><img hide-gt-sm="hide-gt-sm" ng-src="{{$ctrl.$logoUrl}}" style="height: 3rem;"/><div class="md-title padding-h-half">DRIP<span ng-if="$ctrl.$vendorName" style="text-transform: none">&nbsp;- {{$ctrl.$vendorName}}</span></div></md-button><div flex="flex"></div><img hide="hide" show-gt-sm="show-gt-sm" ng-src="{{$ctrl.$logoUrl}}" style="position: absolute;top: 0.5rem;left: calc(50% - 2rem);height: 3rem;"/><div flex="flex"></div><div>{{$ctrl.$user.displayName}}</div><md-button ng-if="$ctrl.$tierUpdates &amp;&amp; $ctrl.$isAdmin" ui-sref="approval" class="md-accent md-raised md-hue-2"><span>REVIEW CHANGES</span></md-button><md-button ng-if="$ctrl.$invalidTiers &amp;&amp; $ctrl.$isAdmin" ui-sref="approval" class="md-accent md-raised md-hue-2"><span>REVIEW CHANGES</span></md-button><md-button ng-if="$ctrl.$sitesApproval &amp;&amp; $ctrl.$isAdmin" ui-sref="approval" class="md-accent md-raised md-hue-2"><span>REVIEW UPLOADED SITES</span></md-button><md-button hide-gt-xs="hide-gt-xs" ng-if="$ctrl.$approval &amp;&amp; $ctrl.$isRep" ui-sref="approval" class="md-accent md-raised md-hue-2"><span>REVIEW CHANGES</span></md-button><md-button hide-xs="hide-xs" ng-if="$ctrl.$approval &amp;&amp; $ctrl.$isAdmin" ng-click="$ctrl.CLEAR = true" class="md-accent md-raised md-hue-2"><span>APPROVE EVERYTHING</span></md-button><md-menu ng-if="$ctrl.$repData" md-position-mode="target-right target"><md-button ng-click="$mdMenu.open($event)" class="md-icon-button"><md-icon md-menu-origin="md-menu-origin">help_outline</md-icon></md-button><md-menu-content width="3"><div class="padding"><div class="md-body-1 opacity5">MY REPRESENTATIVE</div><div class="md-title">{{$ctrl.$repData.displayName}}</div><a ng-href="mailto:{{$ctrl.$repData.email}}">{{$ctrl.$repData.email}}</a><br/><a ng-href="tel:{{$ctrl.$repData.phone}}">{{$ctrl.$repData.phone}}</a></div></md-menu-content></md-menu><md-menu ng-if="$ctrl.$auth" md-position-mode="target-right target"><md-button ng-click="$mdMenu.open($event)" class="md-icon-button"><md-icon md-menu-origin="md-menu-origin">more_vert</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button ng-click="$ctrl.PASSWORD = true"><div layout="row" flex="flex"><p flex="flex">Change password</p><md-icon style="margin: auto 3px auto 0;" md-menu-align-target="md-menu-align-target">vpn_key</md-icon></div></md-button></md-menu-item><md-menu-item><md-button ng-click="$ctrl.$logout()" ui-sref="login"><div layout="row" flex="flex"><p flex="flex">Logout</p><md-icon style="margin: auto 3px auto 0;" md-menu-align-target="md-menu-align-target">exit_to_app</md-icon></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/_components/table/table.comp.html',
    '<md-toolbar md-colors="::{background: \'grey-100\'}" class="md-table-toolbar"><div class="md-toolbar-tools"><md-icon>search</md-icon><input flex="flex" placeholder="{{$ctrl.searchPlaceholder}}" ng-model="$ctrl.$query"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>cancel</md-icon></md-button><div ng-transclude="toolbar" layout="row" layout-align="start center"></div></div></md-toolbar><md-divider></md-divider><md-table-container><table md-table="md-table"><thead md-head="md-head"><tr md-row="md-row"><th md-column="md-column"><span>Full Name</span></th><th md-column="md-column"><span>Email</span></th><th md-column="md-column"><span>Phone</span></th><th md-column="md-column"><span>Company</span></th><th md-column="md-column"><span>Role</span></th><th md-column="md-column"><span>UserId</span></th></tr></thead><tbody md-body="md-body"><tr ng-hide="user.REMOVE" ng-if="teamId === user.teamId" ng-class="{ opacity5: user.disabled }" ng-repeat="user in $ctrl.$users | filter: $ctrl.$query" md-row="md-row"><td md-cell="md-cell"><a ng-if="$ctrl.$embedded" target="_parent" ng-href="https://drip.webcat.page/user/{{user.key}}">{{user.displayName}}</a><a ng-if="!$ctrl.$embedded" ui-sref="user.update({userId: user.key})">{{user.displayName}}</a></td><td md-cell="md-cell"><p>{{user.email}}</p></td><td md-cell="md-cell"><p>{{user.phone}}</p></td><td md-cell="md-cell"><p>{{user.company}}</p></td><td md-cell="md-cell"><p>{{user.role}}</p></td><td md-cell="md-cell"><p>{{user.key}}</p></td></tr></tbody></table><!-- EMPTY STATE--><div ng-if="!team.users" layout="column" layout-align="center center" class="margin padding"><div ng-transclude="empty" layout="row" layout-align="start center"></div></div></md-table-container>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/_components/streetview/streetview.comp.html',
    '<fd-timeout fd-timeout-time="100"><then><md-button hide-gt-sm="hide-gt-sm" ng-class="{\n' +
    '        \'opacity25\': !$ctrl.$url\n' +
    '      }" ng-click="$event.stopPropagation(); $ctrl.$redirect()" ng-href="{{$ctrl.$url}}" ng-disabled="$ctrl.$loading" target="_blank" layout="row" class="md-icon-button"><i class="material-icons">directions_run</i></md-button><md-button hide="hide" show-gt-sm="show-gt-sm" ng-class="{\n' +
    '        \'opacity25\': !$ctrl.$url\n' +
    '      }" ng-click="$event.stopPropagation(); $ctrl.$redirect()" ng-href="{{$ctrl.$url}}" ng-disabled="$ctrl.$loading" target="_blank" layout="row"><i class="material-icons">directions_run</i><span ng-hide="$ctrl.$loading">EXPLORE</span><span ng-show="$ctrl.$loading">LOADING</span></md-button></then></fd-timeout>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/_components/sidenav/sidenav.comp.html',
    '<div layout="column" class="absolute-fill"><fd-user then="\n' +
    '    $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '    $ctrl.$isAdmin = $data.isAdmin;\n' +
    '    $ctrl.$isRep = $data.isRep;\n' +
    '    $ctrl.$vendors = $data.vendors;\n' +
    '    $ctrl.$teamId = $data.teamId"></fd-user><fd-ref ng-repeat="(vendorId, data) in $ctrl.$vendors" fd-ref-path="vendors/{{vendorId}}/metadata/displayName" then="$ctrl.$vendorNames[vendorId] = $data"></fd-ref><fd-ref ng-if="$ctrl.$teamId" fd-ref-path="teams/{{$ctrl.$teamId}}/metadata/displayName" then="$ctrl.$teamName = $data"></fd-ref><md-list flex="flex"><div ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin"><md-subheader>{{$ctrl.$isAdmin ? \'\' : $ctrl.$teamName}} ADMIN</md-subheader><md-list-item ng-click="$ctrl.$toggle()" ui-sref="user" ui-sref-active="active"><md-icon>recent_actors</md-icon><p>Users</p></md-list-item><md-list-item ng-if="$ctrl.$isAdmin" ng-click="$ctrl.$toggle()" ui-sref="category" ui-sref-active="active"><md-icon>view_comfy</md-icon><p>Categories</p></md-list-item><md-list-item ng-if="$ctrl.$isAdmin" ng-click="$ctrl.$toggle()" ui-sref="team" ui-sref-active="active"><md-icon>people</md-icon><p>Teams</p></md-list-item></div><md-subheader>MENU</md-subheader><md-list-item ng-click="$ctrl.$toggle()" ui-sref="home" ui-sref-active="active"><md-icon>home</md-icon><p>Home</p></md-list-item><md-list-item ng-repeat="(vendorId, vendorName) in $ctrl.$vendorNames" ng-click="$ctrl.$toggle()" ui-sref="vendor.update({vendorId: vendorId})" ui-sref-active="active"><md-icon>business</md-icon><p>{{vendorName}}</p></md-list-item><md-list-item ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin" ng-click="$ctrl.$toggle()" ui-sref="vendor" ui-sref-active="active"><md-icon>business</md-icon><p>Vendors</p></md-list-item><md-list-item ng-if="$ctrl.$isRep" ng-click="$ctrl.$toggle()" ui-sref="site" ui-sref-active="active"><md-icon>store</md-icon><p>Sites</p></md-list-item><md-list-item ng-if="$ctrl.$isRep" ng-click="$ctrl.$toggle()" ui-sref="product" ui-sref-active="active"><md-icon>widgets</md-icon><p>Products</p></md-list-item><md-list-item ng-if="$ctrl.$isAdmin" ng-click="$ctrl.$toggle()" ui-sref="supplier" ui-sref-active="active"><md-icon>local_shipping</md-icon><p>Distributors</p></md-list-item></md-list></div>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/vendor/update/update-vendor.action.html',
    '<fd-dispatcher fd-dispatcher-action="{\n' +
    '    type: \'VENDOR.UPDATE\',\n' +
    '    vendor: $ctrl.vendor,\n' +
    '    vendorId: $ctrl.vendorId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating vendor</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating vendor"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="{{$ctrl.vendor.displayName}} updated succesfully"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/vendor/remove/remove-vendor.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this vendor?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '    type: \'VENDOR.REMOVE\',\n' +
    '    vendorId: $ctrl.vendorId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Removing vendor</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting vendor"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Vendor deleted"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/vendor/add/add-vendor.action.html',
    '<fd-dispatcher fd-dispatcher-action="{\n' +
    '    type: \'VENDOR.ADD\',\n' +
    '    vendor: $ctrl.vendor,\n' +
    '    teamId: $ctrl.teamId\n' +
    '  }" then="$ctrl.vendorId = $data"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding vendor</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding vendor"></wc-toast></catch><then><wc-toast wc-toast-message="{{$ctrl.vendor.displayName}} added succesfully"></wc-toast><wc-ui-redirect wc-ui-redirect-sref="vendor.list"></wc-ui-redirect></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/user/update/update-user.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating user</div><div class="md-body-1">Please wait until the database is updated</div></div><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'USER.UPDATE\',\n' +
    '        userId: $ctrl.userId,\n' +
    '        user: $ctrl.user\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating user"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="User updated successfully">   </wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/user/remove/remove-user.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this user?\',\n' +
    '    body: \'This action can not be undone, proceed with caution\'\n' +
    '  }" catch="$ctrl.catch()"><then><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Deleting new user</div><div class="md-body-1">Please wait until the database is updated</div></div><fd-dispatcher fd-dispatcher-action="{\n' +
    '            type: \'USER.REMOVE\',\n' +
    '            userId: $ctrl.userId,\n' +
    '            teamId: $ctrl.teamId\n' +
    '          }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting user"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="User deleted successfully">   </wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog></then></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/user/password/password-user.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Change your password</div><div class="md-body-1">Passwords must be a minimum of 8 characters</div></div><form name="passwordForm" layout="column" class="padding-h"><md-input-container class="no-error-message"><label>Old password</label><input required="required" ng-model="$ctrl.old" type="password"/></md-input-container><md-input-container class="no-error-message"><label>New password</label><input required="required" ng-minlength="8" ng-model="$ctrl.new" type="password"/></md-input-container></form><div layout="row"><div flex="flex"></div><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-disabled="passwordForm.$invalid" ng-click="$ctrl.DISPATCH = true" class="md-primary">UPDATE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'USER.PASSWORD\',\n' +
    '        oldPassword: $ctrl.old,\n' +
    '        password: $ctrl.new\n' +
    '      }" catch="$ctrl.DISPATCH = false"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast wc-toast-message="Error updating password, verify your old password and try again"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Password updated successfully">   </wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/user/adminPassword/adminPassword-user.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Change a password</div><div class="md-body-1">Passwords must be a minimum of 8 characters</div></div><form name="passwordForm" layout="column" class="padding-h"><md-input-container class="no-error-message"><label>New password</label><input required="required" ng-minlength="8" ng-model="$ctrl.new"/></md-input-container></form><div layout="row"><div flex="flex"></div><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-disabled="passwordForm.$invalid" ng-click="$ctrl.DISPATCH = true" class="md-primary">UPDATE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'USER.ADMIN_PASSWORD\',\n' +
    '        userId: $ctrl.userId,\n' +
    '        password: $ctrl.new\n' +
    '      }" catch="$ctrl.DISPATCH = false"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast wc-toast-message="Error updating password, verify the info and try again"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Password updated successfully">   </wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/user/add/add-user.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding new user</div><div class="md-body-1">Please wait until the database is updated</div></div><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'USER.ADD\',\n' +
    '        email: $ctrl.credentials.email,\n' +
    '        password: $ctrl.credentials.password,\n' +
    '        displayName: $ctrl.user.displayName,\n' +
    '        role: $ctrl.user.role,\n' +
    '        vendorId: $ctrl.user.vendorId,\n' +
    '        teamId: $ctrl.teamId,\n' +
    '        phone: $ctrl.user.phone,\n' +
    '        company: $ctrl.user.company,\n' +
    '        disabled: $ctrl.user.disabled,\n' +
    '        products: $ctrl.user.products,\n' +
    '        displays: $ctrl.user.displays\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding user"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="User added successfully">   </wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/team/add/add-team.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.catch()"><wc-dialog-template><div class="padding"><div class="md-title">Add a team</div><div class="md-body-1">Enter the name of the team or company.</div></div><div layout="row" class="padding-h"><md-input-container flex="flex" class="no-error-message"><label>Team name</label><input required="required" ng-model="$ctrl.$displayName"/></md-input-container></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-disabled="!$ctrl.$displayName" ng-click="$ctrl.DISPATCH = true" class="md-primary">CREATE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'TEAM.ADD\',\n' +
    '        displayName: $ctrl.$displayName\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding team"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Team added succesfully"></wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/updateSuppliers/updateSuppliers-site.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SITE.UPDATE_SUPPLIERS\',\n' +
    '        suppliers: $ctrl.suppliers,\n' +
    '        siteId: $ctrl.siteId\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-dialog wc-dialog-alert="true" wc-dialog-labels="{\n' +
    '            title: \'There was an error adding the suppliers\',\n' +
    '            body: \'Please try again later.\'\n' +
    '          }" then="$ctrl.catch()"></wc-dialog></catch></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/updateProduct/updateProduct-site.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SITE.UPDATE_PRODUCT\',\n' +
    '        productId: $ctrl.productId,\n' +
    '        siteId: $ctrl.siteId,\n' +
    '        supplierId: $ctrl.supplierId,\n' +
    '        registration: $ctrl.registration,\n' +
    '        gallery: $ctrl.gallery,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating product registration"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Product registration updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/update/update-site.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SITE.UPDATE\',\n' +
    '        site: $ctrl.site,\n' +
    '        siteId: $ctrl.siteId,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating site</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating site"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="{{$ctrl.site.displayName}} updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/remove/remove-site.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this site?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '    type: \'SITE.REMOVE\',\n' +
    '    siteId: $ctrl.siteId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Removing site</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting site"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Site deleted"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/addProduct/addProduct-site.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SITE.ADD_PRODUCT\',\n' +
    '        productId: $ctrl.productId,\n' +
    '        products: $ctrl.products,\n' +
    '        siteId: $ctrl.siteId,\n' +
    '        registration: $ctrl.registration,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-dialog wc-dialog-alert="true" wc-dialog-labels="{\n' +
    '            title: \'There was an error adding the product\',\n' +
    '            body: \'Check that the product is not already registered in the site.\'\n' +
    '          }" then="$ctrl.catch()"></wc-dialog></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Product added succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/site/add/add-site.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin; $ctrl.$teamId = $data.teamId"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SITE.ADD\',\n' +
    '        site: $ctrl.site,\n' +
    '        teamId: $ctrl.$teamId,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }" then="$ctrl.siteId = $data"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding site</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding site"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then({$data: $ctrl.siteId})" wc-toast-message="{{$ctrl.site.displayName}} added succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/supplier/update/update-supplier.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SUPPLIER.UPDATE\',\n' +
    '        supplier: $ctrl.supplier,\n' +
    '        supplierId: $ctrl.supplierId,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating supplier</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating supplier"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="{{$ctrl.supplier.displayName}} updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/supplier/remove/remove-supplier.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this supplier?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '    type: \'SUPPLIER.REMOVE\',\n' +
    '    supplierId: $ctrl.supplierId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Removing supplier</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting supplier"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Supplier deleted"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/supplier/add/add-supplier.action.html',
    '<fd-user then="$ctrl.$isRep = $data.isRep"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'SUPPLIER.ADD\',\n' +
    '        supplier: $ctrl.supplier\n' +
    '      }" then="$ctrl.supplierId = $data"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding supplier</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding supplier"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then({$data: $ctrl.supplierId})" wc-toast-message="{{$ctrl.supplier.displayName}} added succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/review/remove/remove-review.action.html',
    '<wc-dialog wc-dialog-template="true" wc-dialog-modal="false" wc-dialog-fullscreen="false" catch="$ctrl.catch()"><wc-dialog-template><div class="padding"><div class="md-title">Are you sure you want to delete this review?</div><div class="md-body-1">This action can not be undone</div></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-click="$ctrl.DISPATCH = true" class="md-raised md-warn">DELETE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'REVIEW.REMOVE\',\n' +
    '        reviewId: $ctrl.reviewId\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Review deleted"></wc-toast></then><catch> <wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting review"></wc-toast></catch></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/review/add/add-review.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Are you sure the information is correct?\',\n' +
    '    body: \'A review can not be updated once it is created.\'\n' +
    '  }" catch="$ctrl.catch()"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'REVIEW.ADD\',\n' +
    '        review: $ctrl.review,\n' +
    '        gallery: $ctrl.gallery,\n' +
    '        siteId: $ctrl.review.siteId,\n' +
    '        productId: $ctrl.productId\n' +
    '      }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Making review</div><div class="md-body-1">Please wait until the database is updated.</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error creating review"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Review created succesfully"></wc-toast></then></fd-dispatcher></then></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/display/update/update-display.action.html',
    '<fd-user then="$ctrl.$isRep = $data.isRep"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'DISPLAY.UPDATE\',\n' +
    '        display: $ctrl.display,\n' +
    '        displayId: $ctrl.displayId,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating display</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating display"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="{{$ctrl.display.metadata.displayName}} updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/display/remove/remove-display.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this display?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '    type: \'DISPLAY.REMOVE\',\n' +
    '    displayId: $ctrl.displayId,\n' +
    '    vendorId: $ctrl.vendorId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Removing display</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting display"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="display deleted"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/display/add/add-display.action.html',
    '<fd-user then="$ctrl.$isRep = $data.isRep"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'DISPLAY.ADD\',\n' +
    '        display: $ctrl.display,\n' +
    '        vendorId: $ctrl.vendorId\n' +
    '      }" then="$ctrl.displayId = $data"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding display</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding display"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then({$data: $ctrl.displayId})" wc-toast-message="{{$ctrl.display.metadata.displayName}} added succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/product/uploadReviews/uploadReviews-product.action.html',
    '<fd-ref fd-ref-path="products/{{$ctrl.productId}}" then="$ctrl.$product = $data"></fd-ref><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.catch()"><wc-dialog-template style="max-width: 40rem" class="relative"><div ng-if="!$ctrl.$product || $ctrl.$progress" style="background: #fff" class="absolute-fill opacity5 z5"></div><div class="padding md-title">Upload reviews as an xls</div><div layout="row" layout-align="start center" class="padding"><div flex="flex" class="md-body-1"><p>To upload a review spreadsheet please download the current reviews and add the new reviews as new rows. The reviews will be stored in the order that you upload them, independently of their date.</p><p>Make sure to format all dates as text instead of date or number. Also, leave blank the reviewId field for all new reviews.</p></div><div class="padding-half"></div><md-button target="_blank" ng-href="https://us-central1-drip-1e853.cloudfunctions.net/reviewsXls?productId={{$ctrl.productId}}" class="md-raised"><md-icon>file_download</md-icon><span>DOWNLOAD REVIEWS</span></md-button></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button hide-xs="hide-xs" class="md-raised md-primary"><wc-upload then="$ctrl.$file = $file"><then><fd-upload ng-if="$ctrl.$file" fd-upload-file="$ctrl.$file" fd-upload-filename="\'reviewsData.xlsx\'" before="$ctrl.$progress = $progress" then="$ctrl.notifyImport($ctrl.$data); $ctrl.$file = null"><before></before><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></fd-upload></then><catch><wc-toast wc-toast-message="Error uploading file"></wc-toast></catch></wc-upload><div layout="row" layout-align="center center"><md-icon>file_upload</md-icon>UPLOAD (MAX 400 REVIEWS)</div></md-button></div><wc-progress ng-if="!$ctrl.$product || $ctrl.$progress" wc-progress-type="linear" class="z10"></wc-progress></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/product/update/update-product.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'PRODUCT.UPDATE\',\n' +
    '        productId: $ctrl.productId,\n' +
    '        product: $ctrl.product,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating product</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error updating product"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="{{$ctrl.product.displayName}} updated succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/product/remove/remove-product.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this product?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '    type: \'PRODUCT.REMOVE\',\n' +
    '    productId: $ctrl.productId\n' +
    '  }"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Removing product</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting product"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Product deleted"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/product/add/add-product.action.html',
    '<fd-user then="$ctrl.$isAdmin = $data.isAdmin"><then><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'PRODUCT.ADD\',\n' +
    '        vendorId: $ctrl.vendorId,\n' +
    '        teamId: $ctrl.teamId,\n' +
    '        product: $ctrl.product,\n' +
    '        isAdmin: $ctrl.$isAdmin\n' +
    '      }" then="$ctrl.productId = $data"><before><wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Adding product to vendor</div><div class="md-body-1">Please wait until the database is updated</div></div><wc-progress wc-progress-type="linear"></wc-progress></wc-dialog-template></wc-dialog></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding product"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then({ $data: $ctrl.productId })" wc-toast-message="{{$ctrl.product.displayName}} added succesfully"></wc-toast></then></fd-dispatcher></then></fd-user>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/category/removeReview/removeReview-category.action.html',
    '<wc-dialog wc-dialog-confirm="true" wc-dialog-labels="{\n' +
    '    title: \'Do you want to delete this review?\',\n' +
    '    body: \'This action can not be undone\'\n' +
    '  }" then="$ctrl.DISPATCH = true" catch="$ctrl.catch()"></wc-dialog><wc-dialog ng-if="$ctrl.DISPATCH" wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false"><wc-dialog-template><div class="padding"><div class="md-title">Updating database</div><div class="md-body-1">Please wait until the data is updated.</div></div><fd-dispatcher fd-dispatcher-action="{\n' +
    '        type: \'CATEGORY.REMOVE_REVIEW\',\n' +
    '        reviewId: $ctrl.reviewId,\n' +
    '        categoryId: $ctrl.categoryId\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error deleting review"></wc-toast></catch><then><vwc-toast ng-init="$ctrl.then()" wc-toast-message="Review deleted succesfully"></vwc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/category/addReview/addReview-category.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.catch()"><wc-dialog-template><div class="padding"><div class="md-title">Add a category</div><div class="md-body-1">Enter the number of average sales of this category</div></div><form name="reviewForm" layout="column" layout-align="start stretch" class="padding-h"><md-input-container class="no-error-message"><label>Review date</label><md-datepicker ng-model="$ctrl.creationDate" ng-change="$ctrl.$timestamp = $ctrl.creationDate.getTime()"></md-datepicker></md-input-container><md-input-container class="no-error-message"><label>Sales amount</label><input type="number" required="required" ng-model="$ctrl.$amount"/></md-input-container></form><div layout="row" layout-align="end"><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-disabled="reviewForm.$invalid" ng-click="$ctrl.DISPATCH = true" class="md-primary">CREATE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'CATEGORY.ADD_REVIEW\',\n' +
    '        categoryId: $ctrl.categoryId,\n' +
    '        amount: $ctrl.$amount,\n' +
    '        timestamp: $ctrl.$timestamp\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding review"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Review added succesfully"></wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/category/add/add-category.action.html',
    '<wc-dialog wc-dialog-template="wc-dialog-template" wc-dialog-fullscreen="false" wc-dialog-modal="false" catch="$ctrl.catch()"><wc-dialog-template><div class="padding"><div class="md-title">Add a category</div><div class="md-body-1">Enter a name that is easy to understand.</div></div><div layout="row" class="padding-h"><md-input-container flex="flex" class="no-error-message"><label>Category name</label><input required="required" ng-model="$ctrl.$displayName"/></md-input-container></div><div layout="row" layout-align="end"><md-button ng-click="$ctrl.catch()">CANCEL</md-button><md-button ng-disabled="!$ctrl.$displayName" ng-click="$ctrl.DISPATCH = true" class="md-primary">CREATE</md-button></div><fd-dispatcher ng-if="$ctrl.DISPATCH" fd-dispatcher-action="{\n' +
    '        type: \'CATEGORY.ADD\',\n' +
    '        displayName: $ctrl.$displayName\n' +
    '      }"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error adding category"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Category added succesfully"></wc-toast></then></fd-dispatcher></wc-dialog-template></wc-dialog>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/auth/login/login-auth.action.html',
    '<fd-login fd-login-provider="email" fd-login-credentials="$ctrl.credentials"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><fd-user then="\n' +
    '      $ctrl.$displayName = $data.displayName;\n' +
    '      $ctrl.$vendorId = $data.vendorId"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><fd-ref fd-ref-path="vendors/{{$ctrl.$vendorId}}/metadata/displayName" then="$ctrl.$vendorName = $data"><before><wc-progress wc-progress-type="linear"></wc-progress></before><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Welcome {{$ctrl.$vendorName}}"></wc-toast></then></fd-ref><wc-toast ng-if="!$ctrl.$vendorId" ng-init="$ctrl.then()" wc-toast-message="Welcome {{$ctrl.$displayName}}"></wc-toast></then></fd-user></then><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error logging in, verify your credentials and try again."></wc-toast></catch></fd-login>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/approval/deny/deny-approval.action.html',
    '<fd-dispatcher fd-dispatcher-action="{\n' +
    '    type: \'APPROVAL.DENY\',\n' +
    '    approvalType: $ctrl.type,\n' +
    '    batch: $ctrl.batch\n' +
    '  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error denying changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Changes denied"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/approval/clear/clear-approval.action.html',
    '<fd-dispatcher fd-dispatcher-action="{\n' +
    '    type: \'APPROVAL.CLEAR\'\n' +
    '  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error approving all changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="ALL changes have been approved"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('actions/approval/approve/approve-approval.action.html',
    '<fd-dispatcher fd-dispatcher-action="{\n' +
    '    type: \'APPROVAL.APPROVE\',\n' +
    '    approvalType: $ctrl.type,\n' +
    '    batch: $ctrl.batch\n' +
    '  }"><catch><wc-toast ng-init="$ctrl.catch()" wc-toast-message="Error approving changes"></wc-toast></catch><then><wc-toast ng-init="$ctrl.then()" wc-toast-message="Changes approved"></wc-toast></then></fd-dispatcher>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/login/login.route.html',
    '<md-content layout="column" class="absolute-fill"><md-toolbar class="md-hue-2"></md-toolbar><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>LOGIN</h2></div></md-toolbar><form name="loginForm" layout="column" layout-align="center center" class="margin"><div md-colors="{background: \'grey-A100\'}" class="md-whiteframe-2dp container-third"><div layout="column" layout-align="start stretch" class="padding"> <div class="md-body-2 padding-v-half"><b>Welcome to DRIP!</b></div><md-input-container class="no-error-message"><label>Email</label><input required="required" ng-blur="blurred = true" ng-model="$ctrl.credentials.email"/></md-input-container><md-input-container class="no-error-message"><label>Password</label><input required="required" type="password" ng-model="$ctrl.credentials.password"/></md-input-container></div><div layout="row" layout-align="end"><md-button type="submit" ng-disabled="loginForm.$invalid" ng-click="$ctrl.LOGIN = true" class="md-hue-1 md-primary">LOGIN</md-button></div><auth-login-action ng-if="$ctrl.LOGIN" credentials="$ctrl.credentials" then="$ctrl.LOGIN = false; $ctrl.REDIRECT = true" catch="$ctrl.LOGIN = false"></auth-login-action><wc-ui-redirect ng-if="$ctrl.REDIRECT" wc-ui-redirect-sref="home"></wc-ui-redirect></div></form></md-content>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/home/home.route.html',
    '<fd-auth then="$ctrl.$auth = $data"><catch><wc-ui-redirect wc-ui-redirect-sref="login"></wc-ui-redirect></catch></fd-auth><md-content layout="column" class="absolute-fill"><md-toolbar class="md-hue-2"></md-toolbar><md-toolbar class="md-hue-2"><div class="md-toolbar-tools"><h2>HOME</h2></div></md-toolbar><div layout="column" layout-align="center center" class="margin"><div md-colors="{background: \'grey-A100\'}" class="md-whiteframe-2dp container-third"><div layout="column" layout-align="start stretch" class="padding"> <div class="md-body-2 padding-v-half"><b>Welcome to DRIP</b></div></div><fd-user then="\n' +
    '        $ctrl.$isSubadmin = $data.isSubadmin;\n' +
    '        $ctrl.$isAdmin = $data.isAdmin;\n' +
    '        $ctrl.$isRep = $data.isRep;\n' +
    '        $ctrl.$vendors = $data.vendors"></fd-user><fd-ref ng-if="$ctrl.$vendors" ng-repeat="(vendorId, data) in $ctrl.$vendors" fd-ref-path="vendors/{{vendorId}}/metadata/displayName" then="$ctrl.$vendorNames[vendorId] = $data"></fd-ref><md-list flex="flex"><div ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin"><md-list-item ng-click="$ctrl.$toggle()" ui-sref="user" ui-sref-active="active"><md-icon>recent_actors</md-icon><p>Users</p></md-list-item><md-list-item ng-if="$ctrl.$isAdmin" ng-click="$ctrl.$toggle()" ui-sref="category" ui-sref-active="active"><md-icon>view_comfy</md-icon><p>Categories</p></md-list-item></div><md-list-item ng-if="$ctrl.$vendors" ng-repeat="(vendorId, vendorName) in $ctrl.$vendorNames" ng-click="$ctrl.$toggle()" ui-sref="vendor.update({vendorId: vendorId})" ui-sref-active="active" class="md-2-line"><md-icon>business</md-icon><div class="md-list-item-text"><h4>{{vendorName}}</h4><p>Vendor profile</p></div></md-list-item><md-list-item ng-if="$ctrl.$isAdmin || $ctrl.$isSubadmin" ng-click="$ctrl.$toggle()" ui-sref="vendor" ui-sref-active="active"><md-icon>business</md-icon><p>Vendors</p></md-list-item><md-list-item ng-if="$ctrl.$isRep" ng-click="$ctrl.$toggle()" ui-sref="site" ui-sref-active="active"><md-icon>store</md-icon><p>Sites</p></md-list-item><md-list-item ng-if="$ctrl.$isRep" ng-click="$ctrl.$toggle()" ui-sref="product" ui-sref-active="active"><md-icon>widgets</md-icon><p>Products</p></md-list-item></md-list></div></div></md-content>');
}]);

angular.module('drip').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/root.comp.html',
    '<fd-user then="$ctrl.$auth = $data" catch="$ctrl.$auth = null"></fd-user><wc-layout ng-class="$ctrl.base" wc-open="$ctrl.$auth.displayName &amp;&amp; !$ctrl.$embedded" wc-sidenav-id="\'sidenav\'"><toolbar><toolbar-el ng-if="!$ctrl.$embedded"></toolbar-el></toolbar><sidenav ng-if="!$ctrl.$embedded"><fd-auth><then><sidenav-el></sidenav-el></then></fd-auth></sidenav><content><ui-view></ui-view></content></wc-layout>');
}]);

'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('vendor.metadata', []).component('vendorMetadata', {
    controller: Controller,
    templateUrl: 'root/vendor/_components/metadata/metadata-vendor.comp.html',
    bindings: {
      vendorId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.$firedux = $firedux;
    }

    _createClass(Controller, [{
      key: '$size',
      value: function $size(obj) {
        return this._(obj).size();
      }
    }, {
      key: '$countSites',
      value: function $countSites(sites, productId) {
        var _this = this;

        var _ = this._;

        return Promise.all(_.map(sites, function (site, siteId) {
          return _this.$firedux.ref('sites').child(siteId).child('metadata/displayName').once('value').then(function (s) {
            return s.val();
          });
        })).then(_.compact).then(_.size).then(function (size) {
          _this.$productList[productId].sites = size;
          _this.$firedux.$apply();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('vendor.products', []).component('vendorProducts', {
    controller: Controller,
    templateUrl: 'root/vendor/_components/products/products-vendor.comp.html',
    bindings: {
      vendorId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$size',
      value: function $size(obj) {
        return this._(obj).size();
      }
    }]);

    return Controller;
  })();

  angular.module('vendor.displays', []).component('vendorDisplays', {
    controller: Controller,
    templateUrl: 'root/vendor/_components/displays/displays-vendor.comp.html',
    bindings: {
      vendorId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('vendor.detail', []).component('vendorDetail', {
    controller: Controller,
    templateUrl: 'root/vendor/_components/detail/detail-vendor.comp.html',
    bindings: {
      form: '&',
      vendor: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this._ = $window._;
      this.$window = $window;
    }

    _createClass(Controller, [{
      key: '$onChanges',
      value: function $onChanges() {
        var _ = this._;

        if (_.size(this.productsArray) !== _.size((this.user || {}).products)) {
          this.productsArray = _((this.user || {}).products).chain().map(function (v, k) {
            return [k, v];
          }).sortBy(function (i) {
            return i[1];
          }).map(function (i) {
            return i[0];
          }).value();
        }
      }
    }, {
      key: '$updateOrder',
      value: function $updateOrder() {
        var _this = this;

        var _ = this._;

        this.$window.setTimeout(function () {
          _this.$firedux.ref('users').child(_this.userId).child('products').set(_.object(_this.productsArray, _.map(_this.productsArray, function (v, i) {
            return i;
          })));
        }, 500);
      }
    }, {
      key: '$addProductsFromDisplay',
      value: function $addProductsFromDisplay(display) {
        var _this2 = this;

        var _ = this._;

        _.each((display || {}).products, function (item, productId) {
          if (!_this2.user.products) {
            _this2.user.products = {};
          }
          _this2.user.products[productId] = true;
        });
      }
    }, {
      key: '$setVendor',
      value: function $setVendor(vendor) {
        if (!this.user.vendors) {
          this.user.vendors = {};
        }
        if (vendor) {
          this.user.vendors[vendor.key] = true;
        }
        this.selectedVendor = '';
      }
    }]);

    return Controller;
  })();

  angular.module('user.detail', []).component('userDetail', {
    controller: Controller,
    templateUrl: 'root/user/_components/detail/detail-user.comp.html',
    bindings: {
      form: '&',
      user: '<',
      userId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$size',
      value: function $size(obj) {
        return this._(obj).size();
      }
    }]);

    return Controller;
  })();

  angular.module('supplier.products', []).component('supplierProducts', {
    controller: Controller,
    templateUrl: 'root/supplier/_components/products/products-supplier.comp.html',
    bindings: {
      supplierId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('supplier.detail', []).component('supplierDetail', {
    controller: Controller,
    templateUrl: 'root/supplier/_components/detail/detail-supplier.comp.html',
    bindings: {
      form: '&',
      supplier: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('supplier.metadata', []).component('supplierMetadata', {
    controller: Controller,
    templateUrl: 'root/supplier/_components/metadata/metadata-supplier.comp.html',
    bindings: {
      supplierId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $mdMedia, $scope) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      $scope.$watch(function () {
        return $mdMedia('lg');
      }, function (isLarge) {
        $scope.isLarge = isLarge;
      });
    }

    _createClass(Controller, [{
      key: '$delete',
      value: function $delete(itemId, object) {
        delete object[itemId];
      }
    }, {
      key: '$size',
      value: function $size(obj) {
        var _ = this._;
        return _(obj).size();
      }
    }, {
      key: 'updateSuppliers',
      value: function updateSuppliers(suppliers) {
        return this._.object(suppliers, this._(suppliers).map(function () {
          return true;
        }));
      }
    }, {
      key: 'addSupplier',
      value: function addSupplier(newSupplierId, suppliers) {
        var _ = this._;
        return _(suppliers).chain().keys().union([newSupplierId]).reduce(function (memo, supplierId) {
          memo[supplierId] = true;
          return memo;
        }, {}).value();
      }
    }, {
      key: 'removeSupplier',
      value: function removeSupplier(oldSupplierId, suppliers) {
        var _ = this._;
        return _(suppliers).chain().keys().difference([oldSupplierId]).reduce(function (memo, supplierId) {
          memo[supplierId] = true;
          return memo;
        }, {}).value();
      }
    }]);

    return Controller;
  })();

  angular.module('site.suppliers', []).component('siteSuppliers', {
    controller: Controller,
    templateUrl: 'root/site/_components/suppliers/suppliers-site.comp.html',
    bindings: {
      siteId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.$firedux = $firedux;
      this.$reviewLengths = {};
    }

    _createClass(Controller, [{
      key: '$delete',
      value: function $delete(itemId, object) {
        delete object[itemId];
      }
    }, {
      key: '$size',
      value: function $size(obj) {
        var _ = this._;
        return _(obj).size();
      }
    }, {
      key: '$sort',
      value: function $sort(list, sort) {
        var _ = this._;
        return _(list).chain().map(function (item, $id) {
          return Object.assign(item, { $id: $id });
        }).sort(function (item) {
          return item[sort];
        }).value().reverse();
      }
    }, {
      key: '$countReviews',
      value: function $countReviews(obj, productId, siteId) {
        var _this = this;

        var _ = this._;
        Promise.all(_.map(_.keys(obj), function (reviewId) {
          return _this.$firedux.ref('reviews/' + reviewId).once('value').then(function (s) {
            return s.val();
          });
        })).then(function (reviews) {
          return _.filter(reviews, function (review) {
            return review.siteId === siteId;
          });
        }).then(function (reviews) {
          _this.$reviewLengths[productId] = reviews.length;
          _this.$firedux.$apply();
        });
        return 2;
      }
    }]);

    return Controller;
  })();

  angular.module('site.products', []).component('siteProducts', {
    controller: Controller,
    templateUrl: 'root/site/_components/products/products-site.comp.html',
    bindings: {
      siteId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller() {
      _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
      key: 'newDate',
      value: function newDate() {
        var date = arguments.length <= 0 || arguments[0] === undefined ? new Date() : arguments[0];

        return new Date(date);
      }
    }]);

    return Controller;
  })();

  angular.module('site.productRegistration', []).component('siteProductRegistration', {
    controller: Controller,
    templateUrl: 'root/site/_components/productRegistration/productRegistration-site.comp.html',
    bindings: {
      siteId: '<',
      registration: '<',
      isApproval: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux, $window) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this.$window = $window;
    }

    _createClass(Controller, [{
      key: 'newDate',
      value: function newDate() {
        var date = arguments.length <= 0 || arguments[0] === undefined ? new Date() : arguments[0];

        return new Date(date);
      }
    }, {
      key: '$deleteRegistration',
      value: function $deleteRegistration() {
        var _this = this;

        var siteId = this.siteId;
        var productId = this.productId;

        Promise.all([this.$firedux.ref('sites').child(siteId).child('products').child(productId).remove(), this.$firedux.ref('products').child(productId).child('sites').child(siteId).remove()]).then(function () {
          _this.$window.history.back();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('site.productMetadata', []).component('siteProductMetadata', {
    controller: Controller,
    templateUrl: 'root/site/_components/productMetadata/productMetadata-site.comp.html',
    bindings: {
      siteId: '<',
      productId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);

    this.$states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' + 'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' + 'WY').split(' ');
  };

  angular.module('site.metadata', []).component('siteMetadata', {
    controller: Controller,
    templateUrl: 'root/site/_components/metadata/metadata-site.comp.html',
    bindings: {
      siteId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this.$states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' + 'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' + 'WY').split(' ');
      this._ = $window._;
      this.$window = $window;
      this.$firedux = $firedux;
    }

    _createClass(Controller, [{
      key: '$invert',
      value: function $invert(array) {
        return this._(array).chain().invert().mapObject(function () {
          return true;
        }).value();
      }
    }, {
      key: 'checkAddress',
      value: function checkAddress(query) {
        return function (object) {
          return angular.isObject(object) && angular.isObject(object.address) && object.address.address1.indexOf(query) > -1;
        };
      }
    }, {
      key: '$updateTier',
      value: function $updateTier(newTier, site, siteId, userId, isAdmin) {
        return Promise.all([this.$firedux.ref('sites').child(siteId).child('metadata/tier').set(newTier), isAdmin ? Promise.resolve() : this.$firedux.ref('tierUpdates').push({
          timestamp: Date.now(),
          siteId: siteId,
          userId: userId,
          oldTier: site.tier,
          newTier: newTier
        })]);
      }
    }, {
      key: '$claimSite',
      value: function $claimSite(siteId, userId, teamId) {
        var _this = this;

        return Promise.all([this.$firedux.ref('sites').child(siteId).child('metadata/users').child(userId).set(userId), this.$firedux.ref('sites').child(siteId).child('metadata/teams').child(teamId).set(teamId)]).then(function () {
          _this.$window.history.back();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('site.detail', []).component('siteDetail', {
    controller: Controller,
    templateUrl: 'root/site/_components/detail/detail-site.comp.html',
    bindings: {
      site: '<',
      approvalId: '<',
      checkAddress: '<',
      isDisabled: '<',
      form: '&'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.$firedux = $firedux;
      this.$autocompleteSites = [];
    }

    _createClass(Controller, [{
      key: '$onInit',
      value: function $onInit() {
        if (this.review) {
          this.review.date = this.review.date || Date.now();
          this.review.images = this.review.images || [];
        }
      }
    }, {
      key: 'newDate',
      value: function newDate() {
        var date = arguments.length <= 0 || arguments[0] === undefined ? Date.now() : arguments[0];

        return new Date(date);
      }
    }, {
      key: '$addImage',
      value: function $addImage(url) {
        this.review.images.push(url);
      }
    }, {
      key: '$getSites',
      value: function $getSites(sites) {
        var _this = this;

        var _ = this._;
        var siteIds = _.keys(sites);
        var promises = _.map(siteIds, function (siteId) {
          return _this.$firedux.ref('sites/' + siteId + '/metadata').once('value').then(function (s) {
            return Object.assign(s.val() || {}, { key: siteId });
          });
        });
        Promise.all(promises).then(function (results) {
          var autocompleteSites = [];
          _.each(results, function (site) {
            if (_this.$isRep || site.userId === _this.$userId) {
              autocompleteSites.push(site);
            }
          });
          _this.$autocompleteSites = autocompleteSites;
          _this.$sites = _.object(_.map(results, 'key'), results);
          _this.$firedux.$apply();
        });
      }

      // $filterSites(list, query) {
      //   return this._.filter(list, {
      //     displayName: query
      //   });
      // }
    }]);

    return Controller;
  })();

  angular.module('review.detail', []).component('reviewDetail', {
    controller: Controller,
    templateUrl: 'root/review/_components/detail/detail-review.comp.html',
    bindings: {
      form: '&',
      review: '<',
      productId: '<'
    }
  });
})();
'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $state, $stateParams, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.$state = $state;
      this.$firedux = $firedux;
      this.$stateParams = $stateParams;
      this.$sites = {};
    }

    _createClass(Controller, [{
      key: '$toArray',
      value: function $toArray(obj) {
        return this._(obj).toArray();
      }
    }, {
      key: '$updateSearch',
      value: function $updateSearch(query) {
        this.$state.transitionTo('product.update', Object.assign(this.$stateParams, {
          query: query
        }, {
          reload: false,
          notify: false,
          location: 'replace'
        }));
      }
    }, {
      key: '$go',
      value: function $go(site) {
        this.$state.go('site.update', { siteId: site.key, productId: this.productId });
      }
    }, {
      key: '$loadSites',
      value: function $loadSites() {
        var _this = this;

        var _ = this._;

        this.$firedux.ref('products/' + this.productId + '/sites').on('value', function (snapshot) {
          var siteIds = _.keys(snapshot.val());
          Promise.all(_.map(siteIds, function (siteId) {
            if (_this.$isRep) {
              return _this.$firedux.ref('sites/' + siteId).once('value').then(function (snap) {
                return [siteId, Object.assign({ key: siteId }, snap.child('metadataApproval').val() || snap.child('metadata').val() || {}), snap.child('products').child(_this.productId).child('registration/userId').val()];
              });
            } else if (_this.$isVendor) {
              return _this.$firedux.ref('sites/' + siteId + '/metadata').once('value').then(function (snap) {
                return [siteId, Object.assign({ key: siteId }, snap.val() || {})];
              });
            }
          })).then(function (sites) {
            var sitesWithName = _.filter(sites, function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2);

              var displayName = _ref2[1].displayName;
              return displayName;
            });
            return _.filter(sitesWithName, function (_ref3) {
              var _ref32 = _slicedToArray(_ref3, 3);

              var _ref32$1 = _ref32[1];
              var teamId = _ref32$1.teamId;
              var teams = _ref32$1.teams;
              var registrationUserId = _ref32[2];

              var isAdmin = _this.$isAdmin,
                  isVendor = _this.$isVendor,
                  isSubadmin = _this.$isSubadmin ? _.includes(_.keys(teams), _this.$teamId) || teamId === _this.$teamId : false,
                  isRep = registrationUserId === _this.$userId;
              return isAdmin || isVendor || isSubadmin || isRep;
            });
          }).then(_.object).then(function (data) {
            _this.$sites = data;
            _this.$totalSites = _this._.size(data);
            _this.$firedux.$apply();
          });
        });
      }
    }]);

    return Controller;
  })();

  angular.module('product.sites', []).component('productSites', {
    controller: Controller,
    templateUrl: 'root/product/_components/sites/sites-product.comp.html',
    bindings: {
      productId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('product.reviews', []).component('productReviews', {
    controller: Controller,
    templateUrl: 'root/product/_components/reviews/reviews-product.comp.html',
    bindings: {
      form: '&',
      productId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.moment = $window.moment;
      this.reviews = {};
    }

    _createClass(Controller, [{
      key: '$addReview',
      value: function $addReview(review, key, productPrice) {
        this.reviews[key] = review;
        this.chart = this.$getChartData(this.reviews, productPrice);
      }
    }, {
      key: '$getChartData',
      value: function $getChartData(reviews) {
        var _ = this._;
        var moment = this.moment;

        var reviewArray = _(reviews).chain().toArray().sortBy(function (_ref) {
          var date = _ref.review.date;
          return date;
        }).value(),
            cumulative = 0,
            amountArray = _(reviewArray).chain().pluck('review').map(function (review) {
          var amount = review.amount;
          cumulative += amount;
          return cumulative;
        }).value(),
            labelArray = _(reviewArray).chain().pluck('review').pluck('date').value();
        return {
          data: _(amountArray).map(function (item, index) {
            return {
              y: item,
              x: index
            };
          }),
          options: {
            tooltips: {
              enabled: false
            },
            scales: {
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Units'
                },
                ticks: {
                  beginAtZero: true,
                  callback: function callback(value) {
                    return value;
                  }
                }
              }],
              xAxes: [{
                type: 'linear',
                scaleLabel: {
                  display: true,
                  labelString: 'Date'
                },
                ticks: {
                  callback: function callback(value) {
                    return moment(labelArray[value]).format('MMM DD, YYYY');
                  }
                }
              }]
            }
          }
        };
      }
    }, {
      key: 'getDateString',
      value: function getDateString(date) {
        date = new Date(date);
        return date.toLocaleDateString('en-US', {
          hour12: true,
          month: 'short',
          day: '2-digit'
        });
      }
    }]);

    return Controller;
  })();

  angular.module('product.reports', []).component('productReports', {
    controller: Controller,
    templateUrl: 'root/product/_components/reports/reports-product.comp.html',
    bindings: {
      form: '&',
      productId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('product.metadata', []).component('productMetadata', {
    controller: Controller,
    templateUrl: 'root/product/_components/metadata/metadata-product.comp.html',
    bindings: {
      form: '&',
      productId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$invert',
      value: function $invert(array) {
        return this._(array).chain().invert().mapObject(function () {
          return true;
        }).value();
      }
    }]);

    return Controller;
  })();

  angular.module('product.detail', []).component('productDetail', {
    controller: Controller,
    templateUrl: 'root/product/_components/detail/detail-product.comp.html',
    bindings: {
      form: '&',
      approvalId: '<',
      product: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$size',
      value: function $size(obj) {
        return this._(obj).size();
      }
    }]);

    return Controller;
  })();

  angular.module('display.products', []).component('displayProducts', {
    controller: Controller,
    templateUrl: 'root/display/_components/products/products-display.comp.html',
    bindings: {
      displayId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('display.metadata', []).component('displayMetadata', {
    controller: Controller,
    templateUrl: 'root/display/_components/metadata/metadata-display.comp.html',
    bindings: {
      displayId: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('display.detail', []).component('displayDetail', {
    controller: Controller,
    templateUrl: 'root/display/_components/detail/detail-display.comp.html',
    bindings: {
      form: '&',
      display: '<'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('category.reviews', []).component('categoryReviews', {
    controller: Controller,
    templateUrl: 'root/category/_components/reviews/reviews-category.comp.html',
    bindings: {
      form: '&',
      categoryId: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.firebase = $window.firebase;
      this.$firedux = $firedux;
      this.$apply = function () {
        return $firedux.$apply();
      };
    }

    _createClass(Controller, [{
      key: 'processUrls',
      value: function processUrls(approvals) {
        var _this = this;

        var _ = this._;
        var firebase = this.firebase;
        var $apply = this.$apply;

        this.$urls = {};
        _.each(approvals, function (date, userId) {
          return firebase.storage().ref('/uploadRequests/' + userId + '/sitesData.xlsx').getDownloadURL().then(function (url) {
            _this.$urls[userId] = url;
          }).then($apply);
        });
      }
    }, {
      key: 'notifyImport',
      value: function notifyImport(userId) {
        var _this2 = this;

        return this.$firedux.ref('import/sites').set({
          userId: userId
        }).then(function () {
          return _this2.$firedux.ref('/importForApproval/sites/' + userId).remove();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('approval.uploadedSites', []).component('approvalUploadedSites', {
    controller: Controller,
    templateUrl: 'root/approval/_components/uploadedSites/uploadedSites-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('approval.updateSite', []).component('approvalUpdateSite', {
    controller: Controller,
    templateUrl: 'root/approval/_components/updateSite/updateSite-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('approval.updateReview', []).component('approvalUpdateReview', {
    controller: Controller,
    templateUrl: 'root/approval/_components/updateReview/updateReview-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('approval.updateProduct', []).component('approvalUpdateProduct', {
    controller: Controller,
    templateUrl: 'root/approval/_components/updateProduct/updateProduct-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.firebase = $window.firebase;
      this.$firedux = $firedux;
      this.$apply = function () {
        return $firedux.$apply();
      };
    }

    _createClass(Controller, [{
      key: '$getTiers',
      value: function $getTiers(tiers) {
        return this._(tiers).chain().pairs().filter('1').map('0').value().join(', ');
      }
    }, {
      key: '$approve',
      value: function $approve(itemId) {
        return this.$firedux.ref('tierUpdates').child(itemId).set(null);
      }
    }, {
      key: '$reject',
      value: function $reject(itemId, item) {
        var siteId = item.siteId;
        var oldTier = item.oldTier;

        return Promise.all([this.$approve(itemId), this.$firedux.ref('sites').child(siteId).child('metadata/tier').set(oldTier)]);
      }
    }]);

    return Controller;
  })();

  angular.module('approval.tierUpdates', []).component('approvalTierUpdates', {
    controller: Controller,
    templateUrl: 'root/approval/_components/tierUpdates/tierUpdates-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('approval.registerProductSite', []).component('approvalRegisterProductSite', {
    controller: Controller,
    templateUrl: 'root/approval/_components/registerProductSite/registerProductSite-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this._ = $window._;
      this.firebase = $window.firebase;
      this.$firedux = $firedux;
      this.$apply = function () {
        return $firedux.$apply();
      };
    }

    _createClass(Controller, [{
      key: '$getTiers',
      value: function $getTiers(tiers) {
        return this._(tiers).chain().pairs().filter('1').map('0').value().join(', ');
      }
    }, {
      key: '$approve',
      value: function $approve(itemId) {
        return this.$firedux.ref('invalidTiers').child(itemId).set(null);
      }
    }, {
      key: '$reject',
      value: function $reject(itemId, item) {
        var siteId = item.siteId;
        var productId = item.productId;

        return Promise.all([this.$approve(itemId), this.$firedux.ref('sites').child(siteId).child('products').child(productId).set(null), this.$firedux.ref('products').child(productId).child('sites').child(siteId).set(null)]);
      }
    }]);

    return Controller;
  })();

  angular.module('approval.invalidTier', []).component('approvalInvalidTier', {
    controller: Controller,
    templateUrl: 'root/approval/_components/invalidTier/invalidTier-approval.comp.html',
    bindings: {}
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('site.add', []).component('siteAdd', {
    controller: Controller,
    templateUrl: 'root/site/add/add-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.add', {
      abstract: false,
      url: '/add',
      template: '<site-add/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('actions', ['ng-webcat']);
  angular.module('reducers', ['ng-webcat']);
  angular.module('app.firedux', ['actions', 'reducers', 'ng-webcat']).run(run);
  function run($firedux, $window) {
    $firedux.init({
      config: {
        apiKey: 'AIzaSyBQPkd0URUW2VeUokuCch0OtUmUw4P3Izc',
        authDomain: 'drip-1e853.firebaseapp.com',
        databaseURL: 'https://drip-1e853.firebaseio.com',
        projectId: 'drip-1e853',
        storageBucket: 'drip-1e853.appspot.com'
      },
      base: $window.base
    });
  }
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.approvalType) && angular.isArray(action.batch)) {
      returnable = true;
    }
    return returnable;
  }
  function getRequests(batch) {
    var requests = {};
    angular.forEach(batch, function (item) {
      requests[item] = false;
    });
    return requests;
  }
  function _reducer(action, $firedux) {
    var updatedRequests = getRequests(action.batch);
    return $firedux.ref('approval').child(action.approvalType).update(updatedRequests);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'APPROVAL.DENY',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('approvalDenyAction', {
    controller: Controller,
    templateUrl: 'actions/approval/deny/deny-approval.action.html',
    bindings: {
      type: '@',
      batch: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('vendor.update', []).component('vendorUpdate', {
    controller: Controller,
    templateUrl: 'root/vendor/update/update-vendor.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('vendor.update', {
      abstract: false,
      url: '/update',
      template: '<vendor-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        return this._.size(obj);
      }
    }, {
      key: '$getFilteredVendors',
      value: function $getFilteredVendors(vendors, teamVendors, isAdmin) {
        return isAdmin ? vendors : this._.filter(vendors, function (vendor) {
          return (teamVendors || {})[vendor.key];
        });
      }
    }]);

    return Controller;
  })();

  angular.module('vendor.list', []).component('vendorList', {
    controller: Controller,
    templateUrl: 'root/vendor/list/list-vendor.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('vendor.list', {
      abstract: false,
      url: '/list',
      template: '<vendor-list/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('vendor.add', []).component('vendorAdd', {
    controller: Controller,
    templateUrl: 'root/vendor/add/add-vendor.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('vendor.add', {
      abstract: false,
      url: '/add',
      template: '<vendor-add/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $http) {
      _classCallCheck(this, Controller);

      this.$window = $window;
      this.$http = $http;
    }

    _createClass(Controller, [{
      key: '$impersonate',
      value: function $impersonate(uid) {
        var _this = this;

        this.$window.firebase.auth().currentUser.getToken().then(function (token) {
          return _this.$http.get('https://us-central1-drip-1e853.cloudfunctions.net/godLogin?uid=' + uid, {
            headers: {
              Authorization: 'Bearer ' + token
            }
          });
        }).then(function (_ref) {
          var data = _ref.data;
          return _this.$window.firebase.auth().signInWithCustomToken(data).then(function () {
            return _this.$window.location.replace('/');
          });
        });
      }
    }]);

    return Controller;
  })();

  angular.module('user.update', []).component('userUpdate', {
    controller: Controller,
    templateUrl: 'root/user/update/update-user.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('user.update', {
      abstract: false,
      url: '/update/:userId?embedded',
      template: '<user-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux, $window) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$getUsers',
      value: function $getUsers(user) {
        var _this = this;

        var _ = this._;
        var $firedux = this.$firedux;

        if (user.isAdmin) {
          $firedux.ref('users').once('value').then(function (s) {
            return s.val();
          }).then(function (users) {
            return _(users).chain().map(function (u, userId) {
              return Object.assign(u, { key: userId });
            }).sortBy('timestamp').value().reverse();
          }).then(function (data) {
            _this.$users = data;
            $firedux.$apply();
          });
        } else if (user.isSubadmin && user.teamId) {
          $firedux.ref('teams').child(user.teamId).child('users').once('value').then(function (s) {
            return s.val();
          }).then(function (teamUsers) {
            return Promise.all(_.map(teamUsers, function (u, userId) {
              return $firedux.ref('users').child(userId).once('value').then(function (s) {
                return Object.assign({ key: userId }, s.val());
              });
            }));
          }).then(function (data) {
            _this.$users = data;
            $firedux.$apply();
          });
        }
      }
    }]);

    return Controller;
  })();

  angular.module('user.list', []).component('userList', {
    controller: Controller,
    templateUrl: 'root/user/list/list-user.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('user.list', {
      abstract: false,
      url: '/list?embedded',
      template: '<user-list/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('user.add', []).component('userAdd', {
    controller: Controller,
    templateUrl: 'root/user/add/add-user.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('user.add', {
      abstract: false,
      url: '/add?teamId',
      template: '<user-add/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux, $window) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$save',
      value: function $save(teamVendors, teamId) {
        var _ = this._;
        var $firedux = this.$firedux;

        $firedux.ref('teams').child(teamId).child('vendors').set(_.mapObject(teamVendors, function (i) {
          return i || null;
        }));
      }
    }]);

    return Controller;
  })();

  angular.module('team.update', []).component('teamUpdate', {
    controller: Controller,
    templateUrl: 'root/team/update/update-team.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('team.update', {
      abstract: false,
      url: '/update?teamId',
      template: '<team-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        return this._(obj).size();
      }
    }]);

    return Controller;
  })();

  angular.module('team.list', []).component('teamList', {
    controller: Controller,
    templateUrl: 'root/team/list/list-team.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('team.list', {
      abstract: false,
      url: '/list',
      template: '<team-list/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $state, $stateParams) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
      this.$state = $state;
      this.$stateParams = $stateParams;
    }

    _createClass(Controller, [{
      key: 'back',
      value: function back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('supplier.update', []).component('supplierUpdate', {
    controller: Controller,
    templateUrl: 'root/supplier/update/update-supplier.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('supplier.update', {
      abstract: false,
      url: '/update',
      template: '<supplier-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller() {
      _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        var total = 0;
        angular.forEach(obj, function () {
          total++;
        });
        return total;
      }
    }]);

    return Controller;
  })();

  angular.module('supplier.list', []).component('supplierList', {
    controller: Controller,
    templateUrl: 'root/supplier/list/list-supplier.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('supplier.list', {
      abstract: false,
      url: '/list',
      template: '<supplier-list/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('supplier.add', []).component('supplierAdd', {
    controller: Controller,
    templateUrl: 'root/supplier/add/add-supplier.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('supplier.add', {
      abstract: false,
      url: '/add?redirectBack',
      template: '<supplier-add/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('site.updateProduct', []).component('siteUpdateProduct', {
    controller: Controller,
    templateUrl: 'root/site/updateProduct/updateProduct-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.updateProduct', {
      abstract: false,
      url: '/updateProduct?productId&approval',
      template: '<site-update-product/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('site.update', []).component('siteUpdate', {
    controller: Controller,
    templateUrl: 'root/site/update/update-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.update', {
      abstract: false,
      url: '/update?approval&productId',
      template: '<site-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux, $sce, $http) {
      _classCallCheck(this, Controller);

      this.$window = $window;
      this.$firedux = $firedux;
      this.$sce = $sce;
      this.$http = $http;
    }

    _createClass(Controller, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        if (this.$window.firebase.auth().currentUser) {
          this.buildUrl(this.$window.firebase.auth().currentUser);
        } else {
          (function () {
            var unsubscribe = _this.$window.firebase.auth().onAuthStateChanged(function (currentUser) {
              if (currentUser) {
                unsubscribe();
                _this.buildUrl(currentUser);
              }
            });
          })();
        }
      }
    }, {
      key: 'buildUrl',
      value: function buildUrl(currentUser) {
        var _this2 = this;

        var uid = currentUser.uid;
        currentUser.getToken().then(function (t) {
          return _this2.$http.get('https://us-central1-drip-1e853.cloudfunctions.net/godLogin?uid=' + uid, {
            headers: {
              Authorization: 'Bearer ' + t
            }
          });
        }).then(function (_ref) {
          var token = _ref.data;

          _this2.url = _this2.$sce.trustAsResourceUrl('https://drip.igniteit.io/siteWizard?token=' + token);
          _this2.$firedux.$apply();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('site.register', []).component('siteRegister', {
    controller: Controller,
    templateUrl: 'root/site/register/register-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.register', {
      abstract: false,
      url: '/register',
      template: '<site-register/>'
    });
  });
})();
'use strict';

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux, $state, $window) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this.$state = $state;
      this.$window = $window;
      this.$query = this.$window.currentQuery || '';
      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.$position = [];
        if (this.$window.navigator.geolocation) {
          var receivePosition = function receivePosition(position) {
            _this.$position = [position.coords.latitude, position.coords.longitude, position.coords.accuracy];
            _this.$sites = _this.$processSites(_this.$sites);
            _this.$firedux.$apply();
          };
          this.$window.navigator.geolocation.watchPosition(receivePosition);
          this.$window.navigator.geolocation.getCurrentPosition(receivePosition);
        }
      }
    }, {
      key: '$goToSite',
      value: function $goToSite(siteId) {
        this.$window.currentQuery = this.$query;
        this.$state.go('site.update', { siteId: siteId });
      }
    }, {
      key: '$count',
      value: function $count(obj) {
        return this._.size(obj);
      }
    }, {
      key: '$filterSites',
      value: function $filterSites(sites, teamId, isAdmin, isSubadmin, userId) {
        var filteredSites = this._.filter(sites, function (site) {
          return isSubadmin ? site.metadata.teamId === teamId || (site.metadata.teams || {})[teamId] : site.metadata.userId === userId || (site.metadata.users || {})[userId];
        });
        var returnable = isAdmin ? sites || [] : filteredSites,
            result = undefined;
        this.$totalSites = returnable.length;
        result = this.$sort(returnable, this.$currentSorting || 'metadata.displayName');
        return this.$shouldReverse ? result.reverse() : result;
      }
    }, {
      key: 'notifyImport',
      value: function notifyImport(userId, isAdmin) {
        return this.$firedux.ref(isAdmin ? 'import/sites' : 'importForApproval/sites/' + userId).set(Date.now());
      }
    }, {
      key: 'cancelImport',
      value: function cancelImport(userId) {
        return this.$firedux.ref('importForApproval/sites/' + userId).remove();
      }
    }, {
      key: 'siteFilter',
      value: function siteFilter(query) {
        function hasText(text) {
          return ('' + text).toLowerCase().indexOf(query.toLowerCase()) > -1;
        }
        return function (item) {
          var metadata = item.metadataApproval || item.metadata || {},
              address = metadata.address || {};
          return !query || hasText(metadata.displayName) || hasText(metadata.contactName) || hasText(metadata.contactPhone) || hasText(address.address1) || hasText(address.address2) || hasText(address.city);
        };
      }
    }, {
      key: '$sort',
      value: function $sort(list, val) {
        var _this2 = this;

        var _ = this._;

        return _.sortBy(list, function (data) {
          return ('' + _this2.$get(data, val)).replace(' ', '');
        });
      }
    }, {
      key: '$get',
      value: function $get(data, val) {
        var _ = this._;

        var path = (val || '').split('.');
        return _.reduce(path, function (memo, child) {
          return _.isObject(memo) && child ? memo[child] : memo;
        }, data);
      }
    }, {
      key: '$processSites',
      value: function $processSites(sites) {
        var _this3 = this;

        var _ = this._;

        return _.compact(_.map(sites.reverse(), function (site) {
          if (site && site.metadata) {
            site.metadata.distance = site.metadata.location ? _this3.$distance([site.metadata.location.lat, site.metadata.location.lng], _this3.$position) + 'mi' : 'z';
          }
          return site;
        }));
      }
    }, {
      key: '$distance',
      value: function $distance(_ref, _ref3) {
        var _ref2 = _slicedToArray(_ref, 2);

        var lat1 = _ref2[0];
        var lon1 = _ref2[1];

        var _ref32 = _slicedToArray(_ref3, 2);

        var lat2 = _ref32[0];
        var lon2 = _ref32[1];

        var R = 6371,
            dLat = (lat2 - lat1) * Math.PI / 180,
            dLon = (lon2 - lon1) * Math.PI / 180,
            a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2),
            c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
            d = R * c;
        return lat2 && lon2 ? Math.round(10 * d / 1.609) / 10 : '--';
      }
    }]);

    return Controller;
  })();

  angular.module('site.list', []).component('siteList', {
    controller: Controller,
    templateUrl: 'root/site/list/list-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.list', {
      abstract: false,
      url: '/list',
      template: '<site-list/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($sce, $window, $http, $firedux) {
      _classCallCheck(this, Controller);

      this.$sce = $sce;
      this.$http = $http;
      this.$window = $window;
      this.$firedux = $firedux;
    }

    _createClass(Controller, [{
      key: '$buildUrl',
      value: function $buildUrl(url) {
        var _this = this;

        if (this.$window.firebase.auth().currentUser) {
          this.buildUrl(this.$window.firebase.auth().currentUser, url);
        } else {
          (function () {
            var unsubscribe = _this.$window.firebase.auth().onAuthStateChanged(function (currentUser) {
              if (currentUser) {
                unsubscribe();
                _this.buildUrl(currentUser, url);
              }
            });
          })();
        }
      }
    }, {
      key: 'buildUrl',
      value: function buildUrl(currentUser, url) {
        var _this2 = this;

        var uid = currentUser.uid;
        currentUser.getToken().then(function (t) {
          return _this2.$http.get('https://us-central1-drip-1e853.cloudfunctions.net/godLogin?uid=' + uid, {
            headers: {
              Authorization: 'Bearer ' + t
            }
          });
        }).then(function (_ref) {
          var token = _ref.data;

          _this2.$url = _this2.$sce.trustAsResourceUrl(url + '?token=' + token);
          _this2.$firedux.$apply();
        });
      }
    }, {
      key: '$trust',
      value: function $trust(url) {
        return this.$sce.trustAsResourceUrl(url);
      }
    }, {
      key: '$back',
      value: function $back() {
        this.$window.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('site.addProducts', []).component('siteAddProducts', {
    controller: Controller,
    templateUrl: 'root/site/addProducts/addProducts-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.addProducts', {
      abstract: false,
      url: '/addProducts/:siteId',
      template: '<site-add-products/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $firedux) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
      this.$firedux = $firedux;
      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }, {
      key: 'validateTiers',
      value: function validateTiers(siteTier, productTiers) {
        return siteTier && productTiers ? productTiers[siteTier] : true;
      }
    }, {
      key: '$filterProducts',
      value: function $filterProducts(products, teamId, isAdmin, isRep) {
        return isAdmin || isRep ? products : this._.filter(products, function (product) {
          return product.metadata.teamId === teamId;
        });
      }
    }, {
      key: '$sendRequest',
      value: function $sendRequest(_ref) {
        var siteId = _ref.siteId;
        var productId = _ref.productId;
        var userId = _ref.userId;

        this.$firedux.ref('/invalidTiers').push({
          siteId: siteId,
          productId: productId,
          userId: userId,
          timestamp: Date.now()
        });
      }
    }]);

    return Controller;
  })();

  angular.module('site.addProduct', []).component('siteAddProduct', {
    controller: Controller,
    templateUrl: 'root/site/addProduct/addProduct-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.addProduct', {
      abstract: false,
      url: '/addProduct?productId',
      template: '<site-add-product/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('site.addDisplay', []).component('siteAddDisplay', {
    controller: Controller,
    templateUrl: 'root/site/addDisplay/addDisplay-site.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('site.addDisplay', {
      abstract: false,
      url: '/addDisplay?displayId',
      template: '<site-add-display/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('review.update', []).component('reviewUpdate', {
    controller: Controller,
    templateUrl: 'root/review/update/update-review.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('review.update', {
      abstract: false,
      url: '/update?reviewId',
      template: '<review-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('review.add', []).component('reviewAdd', {
    controller: Controller,
    templateUrl: 'root/review/add/add-review.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('review.add', {
      abstract: false,
      url: '/add?productId&vendorId&siteId',
      template: '<review-add/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $state, $firedux, $stateParams) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
      this.$state = $state;
      this.$firedux = $firedux;
      this.$stateParams = $stateParams;
      this._ = $window._;
      this.base = $window.base;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }, {
      key: '$loadSites',
      value: function $loadSites() {
        var _this = this;

        this.$firedux.ref('products/' + this.$productId).on('value', function (snapshot) {
          _this.$totalSites = _this._(snapshot.child('sites').val()).size();
          _this.$totalReviews = _this._(snapshot.child('reviews').val()).size();
          _this.$progressPercentage = Math.floor(100 * _this.$totalReviews / _this.$totalSites);
          _this.$firedux.$apply();
        });
      }
    }, {
      key: '$selectTab',
      value: function $selectTab(selectedTab) {
        this.$state.transitionTo(this.$state.current, Object.assign(this.$stateParams, {
          selectedTab: selectedTab
        }), {
          reload: false,
          notify: false,
          location: 'replace'
        });
      }
    }, {
      key: 'parseInt',
      value: (function (_parseInt) {
        function parseInt() {
          return _parseInt.apply(this, arguments);
        }

        parseInt.toString = function () {
          return _parseInt.toString();
        };

        return parseInt;
      })(function () {
        var num = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

        return parseInt(num, 10);
      })
    }]);

    return Controller;
  })();

  angular.module('product.update', []).component('productUpdate', {
    controller: Controller,
    templateUrl: 'root/product/update/update-product.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('product.update', {
      abstract: false,
      url: '/?vendorId&productId&siteId&approval&selectedTab&query',
      template: '<product-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        var _ = this._;

        return _.size(obj);
      }
    }, {
      key: '$filterProducts',
      value: function $filterProducts(products, teamId) {
        var userProducts = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
        var userVendorId = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
        var userVendors = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
        var isAdmin = arguments.length <= 5 || arguments[5] === undefined ? false : arguments[5];
        var isSubadmin = arguments.length <= 6 || arguments[6] === undefined ? false : arguments[6];
        var _ = this._;

        return isAdmin ? products : _.filter(products, function (product) {
          return product && product.metadata && _.some([admin(), subadmin(product), rep(product), vendor(product)]);
        });
        function admin() {
          return isAdmin;
        }
        function subadmin(product) {
          return isSubadmin && teamId === product.metadata.teamId;
        }
        function rep(product) {
          return userProducts[product.key];
        }
        function vendor(product) {
          return userVendorId === product.metadata.vendorId || userVendors[product.metadata.vendorId];
        }
      }
    }]);

    return Controller;
  })();

  angular.module('product.list', []).component('productList', {
    controller: Controller,
    templateUrl: 'root/product/list/list-product.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('product.list', {
      abstract: false,
      url: '/list',
      template: '<product-list/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
    }

    _createClass(Controller, [{
      key: '$back',
      value: function $back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('product.add', []).component('productAdd', {
    controller: Controller,
    templateUrl: 'root/product/add/add-product.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('product.add', {
      abstract: false,
      url: '/add?vendorId&siteId',
      template: '<product-add/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $state, $stateParams) {
      _classCallCheck(this, Controller);

      this.history = $window.history;
      this.$state = $state;
      this.$stateParams = $stateParams;
    }

    _createClass(Controller, [{
      key: 'back',
      value: function back() {
        this.history.back();
      }
    }]);

    return Controller;
  })();

  angular.module('display.update', []).component('displayUpdate', {
    controller: Controller,
    templateUrl: 'root/display/update/update-display.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('display.update', {
      abstract: false,
      url: '/update',
      template: '<display-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller() {
      _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        var total = 0;
        angular.forEach(obj, function () {
          total++;
        });
        return total;
      }
    }]);

    return Controller;
  })();

  angular.module('display.list', []).component('displayList', {
    controller: Controller,
    templateUrl: 'root/display/list/list-display.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('display.list', {
      abstract: false,
      url: '/list',
      template: '<display-list/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('display.add', []).component('displayAdd', {
    controller: Controller,
    templateUrl: 'root/display/add/add-display.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('display.add', {
      abstract: false,
      url: '/add?vendorId',
      template: '<display-add/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('category.update', []).component('categoryUpdate', {
    controller: Controller,
    templateUrl: 'root/category/update/update-category.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('category.update', {
      abstract: false,
      url: '/update?categoryId',
      template: '<category-update/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window) {
      _classCallCheck(this, Controller);

      this._ = $window._;
    }

    _createClass(Controller, [{
      key: '$count',
      value: function $count(obj) {
        return this._(obj).size();
      }
    }]);

    return Controller;
  })();

  angular.module('category.list', []).component('categoryList', {
    controller: Controller,
    templateUrl: 'root/category/list/list-category.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('category.list', {
      abstract: false,
      url: '/list?embedded',
      template: '<category-list/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('approval.list', []).component('approvalList', {
    controller: Controller,
    templateUrl: 'root/approval/list/list-approval.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('approval.list', {
      abstract: false,
      url: '/list',
      template: '<approval-list/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux, $mdSidenav, $window, $http) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
      this.$mdSidenav = $mdSidenav;
      this.base = $window.base;
      this.$http = $http;
    }

    _createClass(Controller, [{
      key: '$toggleSidenav',
      value: function $toggleSidenav(sidenavId) {
        this.$mdSidenav(sidenavId).toggle();
      }
    }, {
      key: '$getUser',
      value: function $getUser(userId) {
        var _this = this;

        this.$http.get('https://us-central1-drip-1e853.cloudfunctions.net/getUserData?userId=' + userId + '&base=' + this.base).then(function (_ref) {
          var data = _ref.data;

          _this.$repData = data;
        });
      }
    }, {
      key: '$logout',
      value: function $logout() {
        this.$firedux.logout();
      }
    }]);

    return Controller;
  })();

  angular.module('toolbar', []).component('toolbarEl', {
    controller: Controller,
    templateUrl: 'root/_components/toolbar/toolbar.comp.html'
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller() {
      _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
      key: '$onChanges',
      value: function $onChanges() {}
    }]);

    return Controller;
  })();

  angular.module('table', []).component('tableEl', {
    controller: Controller,
    templateUrl: 'root/_components/table/table.comp.html',
    transclude: {
      toolbar: '?tableToolbar',
      empty: '?tableEmpty'
    },
    bindings: {
      searchPlaceholder: '@',
      data: '<',
      labels: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($window, $document, $timeout) {
      _classCallCheck(this, Controller);

      this.maps = $window.google.maps;
      this.$document = $document[0];
      this.$timeout = $timeout;
      this.$window = $window;
    }

    _createClass(Controller, [{
      key: 'getRedirectUrl',
      value: function getRedirectUrl() {
        var _this = this;

        this.geocode(this.formatAddress(this.address)).then(function (formattedAddress) {
          _this.$timeout(function () {
            _this.$url = 'https://www.google.com/maps/place/?@?api=1&q=' + formattedAddress;
            _this.$loading = false;
          }, 100);
        });
      }
    }, {
      key: 'formatAddress',
      value: function formatAddress(address) {
        if (angular.isObject(address)) {
          return address.address1 + ', ' + address.city + ', ' + address.state + ' ' + address.zip;
        }
      }
    }, {
      key: 'geocode',
      value: function geocode(address) {
        var geocoder = new this.maps.Geocoder();
        return new Promise(function (resolve, reject) {
          geocoder.geocode({ address: address }, function (results, status) {
            if (status === 'OK') {
              var fa = 'formatted_address';
              resolve(results[0][fa]);
            } else {
              reject(status);
            }
          });
        });
      }
    }, {
      key: '$redirect',
      value: function $redirect() {
        if (!this.$url) {
          this.getRedirectUrl();
          this.$loading = true;
        }
      }
    }]);

    return Controller;
  })();

  angular.module('streetview', []).component('streetviewEl', {
    controller: Controller,
    templateUrl: 'root/_components/streetview/streetview.comp.html',
    bindings: {
      address: '<'
    }
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($mdSidenav) {
      _classCallCheck(this, Controller);

      this.$mdSidenav = $mdSidenav;
    }

    _createClass(Controller, [{
      key: '$toggle',
      value: function $toggle() {
        this.$mdSidenav('sidenav').toggle();
      }
    }]);

    return Controller;
  })();

  angular.module('sidenav', []).component('sidenavEl', {
    controller: Controller,
    templateUrl: 'root/_components/sidenav/sidenav.comp.html'
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.vendorId) && angular.isObject(action.vendor) && angular.isString(action.vendor.displayName) && angular.isString(action.vendor.contactName) && angular.isString(action.vendor.contactPhone) && angular.isString(action.vendor.contactEmail)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('vendors').child(action.vendorId).child('metadata').update({
      displayName: action.vendor.displayName,
      contactName: action.vendor.contactName,
      contactPhone: action.vendor.contactPhone,
      contactEmail: action.vendor.contactEmail,
      notes: action.vendor.notes || null,
      logoUrl: action.vendor.logoUrl || null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'VENDOR.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('vendorUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/vendor/update/update-vendor.action.html',
    bindings: {
      vendor: '<',
      vendorId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.vendorId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('vendors').child(action.vendorId).remove();
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'VENDOR.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('vendorRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/vendor/remove/remove-vendor.action.html',
    bindings: {
      vendorId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isObject(action.vendor) && angular.isString(action.vendor.displayName) && angular.isString(action.vendor.contactName) && angular.isString(action.vendor.contactPhone) && angular.isString(action.vendor.contactEmail)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return Promise.all([$firedux.ref('vendors').child(uid).child('metadata').set({
      displayName: action.vendor.displayName,
      contactName: action.vendor.contactName,
      contactPhone: action.vendor.contactPhone,
      contactEmail: action.vendor.contactEmail,
      notes: action.vendor.notes || null,
      logoUrl: action.vendor.logoUrl || null
    }), $firedux.ref('teams').child(action.teamId).child('vendors').child(uid).set(true)]).then(function () {
      return uid;
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'VENDOR.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('vendorAddAction', {
    controller: Controller,
    templateUrl: 'actions/vendor/add/add-vendor.action.html',
    bindings: {
      vendor: '<',
      teamId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.userId) && angular.isObject(action.user) && angular.isString(action.user.displayName) && angular.isString(action.user.role) && angular.isString(action.user.phone)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux, _) {
    return $firedux.ref('users').child(action.userId).update({
      displayName: action.user.displayName,
      role: action.user.role,
      phone: action.user.phone,
      disabled: !!action.user.disabled,
      company: action.user.company || null,
      vendorId: angular.isString(action.user.vendorId) ? action.user.vendorId : null,
      vendors: action.user.vendors || null,
      repId: angular.isString(action.user.repId) ? action.user.repId : null,
      products: _.object(_.map(_.keys(action.user.products), function (p, i) {
        return [p, i];
      })),
      displays: action.user.displays || null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux, $window) {
    $firedux.reducer({
      trigger: 'USER.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux, $window._) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('userUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/user/update/update-user.action.html',
    bindings: {
      userId: '<',
      user: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.userId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return Promise.all([action.teamId ? $firedux.ref('teams').child(action.teamId).child('users').child(action.userId).remove() : Promise.resolve(), $firedux.ref('users').child(action.userId).child('REMOVE').set(true)]);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'USER.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('userRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/user/remove/remove-user.action.html',
    bindings: {
      userId: '<',
      teamId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.password) && angular.isString(action.oldPassword)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.updatePassword(action.oldPassword, action.password);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'USER.PASSWORD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('userPasswordAction', {
    controller: Controller,
    templateUrl: 'actions/user/password/password-user.action.html',
    bindings: {
      credentials: '<',
      user: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.userId) && angular.isString(action.password)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('users').child(action.userId).child('password').set(action.password);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'USER.ADMIN_PASSWORD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('userAdminPasswordAction', {
    controller: Controller,
    templateUrl: 'actions/user/adminPassword/adminPassword-user.action.html',
    bindings: {
      userId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.email) && angular.isString(action.password) && angular.isString(action.displayName) && angular.isString(action.role) && angular.isString(action.phone)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('users/ADD').set({
      email: action.email,
      password: action.password,
      displayName: action.displayName,
      role: action.teamId && action.role === 'admin' ? 'subadmin' : action.role,
      phone: action.phone,
      teamId: action.teamId,
      company: action.company || null,
      vendorId: angular.isString(action.vendorId) ? action.vendorId : null,
      repId: angular.isString((action.user || {}).repId) ? action.user.repId : null,
      products: action.products || null,
      displays: action.displays || null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'USER.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('userAddAction', {
    controller: Controller,
    templateUrl: 'actions/user/add/add-user.action.html',
    bindings: {
      credentials: '<',
      teamId: '<',
      user: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.displayName)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('teams').child(uid).child('metadata/displayName').set(action.displayName);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'TEAM.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('teamAddAction', {
    controller: Controller,
    templateUrl: 'actions/team/add/add-team.action.html',
    bindings: {
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.supplierId) && angular.isObject(action.supplier) && angular.isString(action.supplier.displayName) && angular.isString(action.supplier.contactName) && angular.isString(action.supplier.contactPhone)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('suppliers').child(action.supplierId).child('metadata').transaction(function (supplier) {
      supplier = supplier || {};
      return {
        displayName: action.supplier.displayName,
        address: action.supplier.address,
        territories: action.supplier.territories,
        website: action.supplier.website,
        contactName: action.supplier.contactName,
        contactPhone: action.supplier.contactPhone,
        userId: $firedux.auth.uid,
        notes: angular.isString(action.supplier.notes) ? action.supplier.notes : null
      };
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SUPPLIER.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('supplierUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/supplier/update/update-supplier.action.html',
    bindings: {
      supplier: '<',
      supplierId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.supplierId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('suppliers').child(action.supplierId).child('metadata').set({
      userId: $firedux.auth.uid
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SUPPLIER.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('supplierRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/supplier/remove/remove-supplier.action.html',
    bindings: {
      supplierId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  // function isAddress(address) {
  //   return angular.isString(address.address1) &&
  //           (angular.isString(address.address2) || !address.address2) &&
  //           angular.isString(address.city) &&
  //           angular.isString(address.state) &&
  //           angular.isString(address.zip);
  // }
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isObject(action.supplier) && angular.isString(action.supplier.displayName)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(_ref, $firedux) {
    var _ref$supplier = _ref.supplier;
    var displayName = _ref$supplier.displayName;
    var contactName = _ref$supplier.contactName;
    var contactPhone = _ref$supplier.contactPhone;
    var notes = _ref$supplier.notes;

    var uid = $firedux['var']('UID');
    return $firedux.ref('suppliers').child(uid).child('metadata').set({
      userId: $firedux.auth.uid,
      displayName: displayName,
      contactName: contactName || null,
      contactPhone: contactPhone || null,
      notes: notes || null
    }).then(function () {
      return uid;
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SUPPLIER.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('supplierAddAction', {
    controller: Controller,
    templateUrl: 'actions/supplier/add/add-supplier.action.html',
    bindings: {
      supplier: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId) && angular.isObject(action.suppliers)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('sites').child(action.siteId).child('suppliers').set(action.suppliers);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SITE.UPDATE_SUPPLIERS',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteUpdateSuppliersAction', {
    controller: Controller,
    templateUrl: 'actions/site/updateSuppliers/updateSuppliers-site.action.html',
    bindings: {
      siteId: '<',
      suppliers: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId) && angular.isString(action.productId) && angular.isArray(action.gallery)) {
      returnable = true;
    } else if (angular.isString(action.siteId) && angular.isString(action.productId) && angular.isObject(action.registration) && angular.isObject(action.registration.agent) && angular.isString(action.registration.agent.displayName) && angular.isString(action.registration.agent.phone) && angular.isNumber(action.registration.date)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux, _) {
    return !action.gallery ? $firedux.ref('sites').child(action.siteId).child('products').child(action.productId).child('registration').update({
      isApproved: true,
      userId: $firedux.auth.uid,
      date: action.registration.date,
      supplierId: action.registration.supplierId || null,
      notes: action.registration.notes || '',
      gallery: action.registration.gallery || null,
      galleryRotation: action.registration.galleryRotation || null,
      agent: {
        displayName: action.registration.agent.displayName,
        phone: action.registration.agent.phone
      },
      contact: action.registration.contact || null
    }) : $firedux.ref('sites').child(action.siteId).child('products').child(action.productId).child('registration/gallery').update((function () {
      return _(action.gallery).chain().map(function (photoURL) {
        return [$firedux['var']('UID'), photoURL];
      }).object().value();
    })());
  }
  angular.module('reducers').run(run);
  function run($firedux, $window) {
    $firedux.reducer({
      trigger: 'SITE.UPDATE_PRODUCT',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux, $window._) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteUpdateProductAction', {
    controller: Controller,
    templateUrl: 'actions/site/updateProduct/updateProduct-site.action.html',
    bindings: {
      siteId: '<',
      registration: '<',
      productId: '<',
      supplierId: '<',
      gallery: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function isAddress(address) {
    return angular.isString(address.address1) && (angular.isString(address.address2) || !address.address2) && angular.isString(address.city) && angular.isString(address.state) && angular.isString(address.zip);
  }
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId) && angular.isObject(action.site) && angular.isString(action.site.displayName) && angular.isString(action.site.contactName) && angular.isString(action.site.contactPhone) && isAddress(action.site.address)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('sites').child(action.siteId).child('metadata').transaction(function (site) {
      site = site || {};
      return {
        isApproved: true,
        teamId: site.teamId || null,
        displayName: action.site.displayName,
        contactName: action.site.contactName,
        contactPhone: action.site.contactPhone,
        email: action.site.email || null,
        address: action.site.address,
        tier: action.site.tier,
        tierSet: true,
        userId: site.userId || $firedux.auth.uid,
        notes: angular.isString(action.site.notes) ? action.site.notes : null
      };
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SITE.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/site/update/update-site.action.html',
    bindings: {
      site: '<',
      siteId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('sites').child(action.siteId).child('metadata').set({
      userId: $firedux.auth.uid
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SITE.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/site/remove/remove-site.action.html',
    bindings: {
      siteId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId) && (angular.isString(action.productId) || angular.isObject(action.products)) && angular.isObject(action.registration) && angular.isObject(action.registration.agent) && angular.isString(action.registration.agent.displayName) && angular.isString(action.registration.agent.phone) && angular.isNumber(action.registration.date)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux, _) {
    if (action.products) {
      return Promise.all(_.map(_.keys(action.products), function (productId) {
        return saveRegistration({
          siteId: action.siteId,
          productId: productId,
          contact: action.registration.contact,
          displayName: action.registration.agent.displayName,
          phone: action.registration.agent.phone,
          gallery: action.registration.gallery,
          notes: action.registration.notes,
          date: action.registration.date,
          $firedux: $firedux
        });
      }));
    }
    if (action.productId) {
      return saveRegistration({
        siteId: action.siteId,
        productId: action.productId,
        contact: action.registration.contact,
        displayName: action.registration.agent.displayName,
        phone: action.registration.agent.phone,
        gallery: action.registration.gallery,
        notes: action.registration.notes,
        date: action.registration.date,
        $firedux: $firedux
      });
    }
  }
  function saveRegistration(_ref) {
    var siteId = _ref.siteId;
    var productId = _ref.productId;
    var contact = _ref.contact;
    var displayName = _ref.displayName;
    var phone = _ref.phone;
    var gallery = _ref.gallery;
    var notes = _ref.notes;
    var date = _ref.date;
    var $firedux = _ref.$firedux;

    return $firedux.ref('sites').child(siteId).child('products').child(productId).child('registration').set({
      isApproved: true,
      userId: $firedux.auth.uid,
      date: date,
      notes: notes || '',
      gallery: gallery || null,
      agent: {
        displayName: displayName,
        phone: phone
      },
      contact: contact || null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux, $window) {
    $firedux.reducer({
      trigger: 'SITE.ADD_PRODUCT',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux, $window._) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteAddProductAction', {
    controller: Controller,
    templateUrl: 'actions/site/addProduct/addProduct-site.action.html',
    bindings: {
      siteId: '<',
      registration: '<',
      productId: '<',
      products: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function isAddress(address) {
    return angular.isString(address.address1) && (angular.isString(address.address2) || !address.address2) && angular.isString(address.city) && angular.isString(address.state) && angular.isString(address.zip);
  }
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isObject(action.site) && angular.isString(action.site.displayName) && isAddress(action.site.address)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('sites').child(uid).child('metadata').set({
      isApproved: true,
      userId: $firedux.auth.uid,
      teamId: action.teamId || null,
      displayName: action.site.displayName,
      contactName: action.site.contactName || null,
      contactPhone: action.site.contactPhone || null,
      address: action.site.address,
      tier: action.site.tier,
      tierSet: true,
      notes: angular.isString(action.site.notes) ? action.site.notes : null
    }).then(function () {
      return uid;
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'SITE.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('siteAddAction', {
    controller: Controller,
    templateUrl: 'actions/site/add/add-site.action.html',
    bindings: {
      site: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.reviewId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('reviews').child(action.reviewId).set(null);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'REVIEW.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('reviewRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/review/remove/remove-review.action.html',
    bindings: {
      reviewId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.siteId) && angular.isString(action.productId) && angular.isObject(action.review) && angular.isNumber(action.review.amount) && angular.isNumber(action.review.date)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('reviews').child(uid).set({
      timestamp: $firedux['var']('TIMESTAMP'),
      isApproved: true,
      productId: action.productId,
      siteId: action.siteId,
      userId: $firedux.auth.uid,
      review: {
        gallery: action.gallery || [],
        amount: action.review.amount,
        date: action.review.date,
        notes: action.review.notes || ''
      }
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'REVIEW.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('reviewAddAction', {
    controller: Controller,
    templateUrl: 'actions/review/add/add-review.action.html',
    bindings: {
      review: '<',
      gallery: '<',
      productId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    return returnable * action;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('products').child(action.productId).child('metadata').update(action['null']);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'PRODUCT.UPLOAD_REVIEWS',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($firedux) {
      _classCallCheck(this, Controller);

      this.$firedux = $firedux;
    }

    _createClass(Controller, [{
      key: 'notifyImport',
      value: function notifyImport() {
        var _this = this;

        return this.$firedux.ref('import/reviews').set(Date.now()).then(function () {
          return _this.then();
        });
      }
    }]);

    return Controller;
  })();

  angular.module('actions').component('productUploadReviews', {
    controller: Controller,
    templateUrl: 'actions/product/uploadReviews/uploadReviews-product.action.html',
    bindings: {
      productId: '<',
      'catch': '&',
      then: '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.productId) && angular.isObject(action.product) && angular.isString(action.product.displayName) && angular.isNumber(action.product.price) && angular.isString(action.product.categoryId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('products').child(action.productId).child('metadata').update({
      isApproved: true,
      vendorId: action.product.vendorId || null,
      displayName: action.product.displayName,
      price: action.product.price,
      categoryId: action.product.categoryId,
      display: action.product.display || null,
      caseCount: action.product.caseCount || null,
      unitsPerSite: action.product.unitsPerSite || null,
      distributorPrice: action.product.distributorPrice || null,
      marketing: action.product.marketing || null,
      tiers: action.product.tiers || null,
      notes: angular.isString(action.product.notes) ? action.product.notes : null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'PRODUCT.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('productUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/product/update/update-product.action.html',
    bindings: {
      productId: '<',
      product: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.productId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('products').child(action.productId).remove();
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'PRODUCT.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('productRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/product/remove/remove-product.action.html',
    bindings: {
      productId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.vendorId) && angular.isObject(action.product) && angular.isString(action.product.displayName) && angular.isNumber(action.product.price) && angular.isString(action.product.categoryId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('products').child(uid).child('metadata').set({
      isApproved: true,
      vendorId: action.vendorId,
      teamId: action.teamId || null,
      displayName: action.product.displayName,
      price: action.product.price,
      categoryId: action.product.categoryId,
      display: action.product.display || null,
      caseCount: action.product.caseCount || null,
      unitsPerSite: action.product.unitsPerSite || null,
      distributorPrice: action.product.distributorPrice || null,
      marketing: action.product.marketing || null,
      tiers: action.product.tiers || null,
      notes: angular.isString(action.product.notes) ? action.product.notes : null
    }).then(function () {
      return new Promise(function (resolve, reject) {
        $firedux.ref('products').child(uid).child('metadata').child('isApproved').on('value', function (snap) {
          var isApproved = snap.val();
          if (isApproved) {
            resolve(uid);
          }
        }, reject);
      });
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'PRODUCT.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('productAddAction', {
    controller: Controller,
    templateUrl: 'actions/product/add/add-product.action.html',
    bindings: {
      vendorId: '<',
      teamId: '<',
      product: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isObject(action.display)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(_ref, $firedux) {
    var displayId = _ref.displayId;
    var _ref$display = _ref.display;
    var _ref$display$metadata = _ref$display.metadata;
    var vendorId = _ref$display$metadata.vendorId;
    var displayName = _ref$display$metadata.displayName;
    var notes = _ref$display$metadata.notes;
    var products = _ref$display.products;

    return $firedux.ref('displays').child(displayId).update({
      metadata: {
        vendorId: vendorId,
        displayName: displayName,
        notes: notes || null
      },
      products: products || null
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'DISPLAY.UPDATE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('displayUpdateAction', {
    controller: Controller,
    templateUrl: 'actions/display/update/update-display.action.html',
    bindings: {
      display: '<',
      displayId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.displayId) && angular.isString(action.vendorId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return Promise.all([$firedux.ref('displays').child(action.displayId).remove(), $firedux.ref('vendors').child(action.vendorId).child('displays').child(action.displayId).remove()]);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'DISPLAY.REMOVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('displayRemoveAction', {
    controller: Controller,
    templateUrl: 'actions/display/remove/remove-display.action.html',
    bindings: {
      displayId: '<',
      vendorId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isObject(action.display)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(_ref, $firedux) {
    var _ref$display = _ref.display;
    var _ref$display$metadata = _ref$display.metadata;
    var displayName = _ref$display$metadata.displayName;
    var notes = _ref$display$metadata.notes;
    var products = _ref$display.products;
    var vendorId = _ref.vendorId;

    var uid = $firedux['var']('UID');
    return $firedux.ref('displays').child(uid).set({
      metadata: {
        vendorId: vendorId,
        displayName: displayName,
        notes: notes || null
      },
      products: products || null
    }).then(function () {
      return $firedux.ref('vendors').child(vendorId).child('displays').child(uid).set(true);
    }).then(function () {
      return uid;
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'DISPLAY.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('displayAddAction', {
    controller: Controller,
    templateUrl: 'actions/display/add/add-display.action.html',
    bindings: {
      display: '<',
      vendorId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.categoryId) && angular.isString(action.reviewId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    return $firedux.ref('categories').child(action.categoryId).child('reviews').child(action.reviewId).set(null);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'CATEGORY.REMOVE_REVIEW',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);

    this.creationDate = new Date();
    this.$timestamp = Date.now();
  };

  angular.module('actions').component('categoryRemoveReviewAction', {
    controller: Controller,
    templateUrl: 'actions/category/removeReview/removeReview-category.action.html',
    bindings: {
      categoryId: '<',
      reviewId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isNumber(action.amount) && angular.isNumber(action.timestamp) && angular.isString(action.categoryId)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('categories').child(action.categoryId).child('reviews').child(uid).set({
      timestamp: action.timestamp,
      amount: action.amount
    });
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'CATEGORY.ADD_REVIEW',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);

    this.creationDate = new Date();
    this.$timestamp = Date.now();
  };

  angular.module('actions').component('categoryAddReviewAction', {
    controller: Controller,
    templateUrl: 'actions/category/addReview/addReview-category.action.html',
    bindings: {
      categoryId: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.displayName)) {
      returnable = true;
    }
    return returnable;
  }
  function _reducer(action, $firedux) {
    var uid = $firedux['var']('UID');
    return $firedux.ref('categories').child(uid).child('metadata/displayName').set(action.displayName);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'CATEGORY.ADD',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('categoryAddAction', {
    controller: Controller,
    templateUrl: 'actions/category/add/add-category.action.html',
    bindings: {
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('authLoginAction', {
    controller: Controller,
    templateUrl: 'actions/auth/login/login-auth.action.html',
    bindings: {
      credentials: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function _reducer(action, $firedux) {
    return $firedux.ref('approval').set(null);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'APPROVAL.CLEAR',
      reducer: function reducer(action) {
        return _reducer(action, $firedux);
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('approvalClearAction', {
    controller: Controller,
    templateUrl: 'actions/approval/clear/clear-approval.action.html',
    bindings: {
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  function validate() {
    var action = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var returnable = undefined;
    if (angular.isString(action.approvalType) && angular.isArray(action.batch)) {
      returnable = true;
    }
    return returnable;
  }
  function getRequests(batch) {
    var requests = {};
    angular.forEach(batch, function (item) {
      requests[item] = null;
    });
    return requests;
  }
  function _reducer(action, $firedux) {
    var updatedRequests = getRequests(action.batch);
    return $firedux.ref('approval').child(action.approvalType).update(updatedRequests);
  }
  angular.module('reducers').run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'APPROVAL.APPROVE',
      reducer: function reducer(action) {
        return validate(action) ? _reducer(action, $firedux) : Promise.reject('VALIDATION ERROR');
      }
    });
  }
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('actions').component('approvalApproveAction', {
    controller: Controller,
    templateUrl: 'actions/approval/approve/approve-approval.action.html',
    bindings: {
      type: '@',
      batch: '<',
      then: '&',
      'catch': '&'
    }
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('vendor', [
  // Components
  'vendor.detail', 'vendor.metadata', 'vendor.products', 'vendor.displays',
  // Routes
  'vendor.list', 'vendor.add', 'vendor.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/vendor', '/vendor/list');
    $stateProvider.state('vendor', {
      abstract: false,
      url: '/vendor?vendorId',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('user', [
  // Components
  'user.detail',
  // Routes
  'user.list', 'user.add', 'user.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/user', '/user/list');
    $stateProvider.state('user', {
      abstract: false,
      url: '/user',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('team', [
  // Components
  // 'team.reviews',
  // Routes
  'team.list', 'team.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/team', '/team/list');
    $stateProvider.state('team', {
      abstract: false,
      url: '/team',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('supplier', [
  // Components
  'supplier.detail', 'supplier.metadata', 'supplier.products',
  // Routes
  'supplier.list', 'supplier.add', 'supplier.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/supplier', '/supplier/list');
    $stateProvider.state('supplier', {
      abstract: false,
      url: '/supplier?supplierId',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('site', [
  // Components
  'site.detail', 'site.metadata', 'site.products', 'site.productRegistration', 'site.productMetadata', 'site.suppliers',
  // Routes
  'site.list', 'site.add', 'site.update', 'site.addProduct', 'site.addProducts', 'site.updateProduct', 'site.addDisplay', 'site.register']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/site', '/site/list');
    $stateProvider.state('site', {
      abstract: false,
      url: '/site?siteId',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('review', [
  // Components
  'review.detail',
  // 'review.metadata',
  // Routes
  'review.add', 'review.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/review', '/review/list');
    $stateProvider.state('review', {
      abstract: false,
      url: '/review',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('product', [
  // Components
  'product.detail', 'product.metadata', 'product.reviews', 'product.sites', 'product.reports',
  // Routes
  'product.add', 'product.update', 'product.list']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/product', '/product/list');
    $stateProvider.state('product', {
      abstract: false,
      url: '/product',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('login', []).component('loginEl', {
    controller: Controller,
    templateUrl: 'root/login/login.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('login', {
      abstract: false,
      url: '/login',
      template: '<login-el/>'
    });
  });
})();
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = function Controller() {
    _classCallCheck(this, Controller);
  };

  angular.module('home', []).component('homeEl', {
    controller: Controller,
    templateUrl: 'root/home/home.route.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('home', {
      abstract: false,
      url: '/home',
      template: '<home-el/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('display', [
  // Components
  'display.detail', 'display.metadata', 'display.products',
  // Routes
  'display.list', 'display.add', 'display.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/display', '/display/list');
    $stateProvider.state('display', {
      abstract: false,
      url: '/display?displayId',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('category', [
  // Components
  'category.reviews',
  // Routes
  'category.list', 'category.update']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/category', '/category/list');
    $stateProvider.state('category', {
      abstract: false,
      url: '/category',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  angular.module('approval', [
  // Components
  'approval.registerProductSite', 'approval.updateProduct', 'approval.updateSite', 'approval.updateReview', 'approval.uploadedSites', 'approval.invalidTier', 'approval.tierUpdates',
  // Routes
  'approval.list']).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/approval', '/approval/list');
    $stateProvider.state('approval', {
      abstract: false,
      url: '/approval',
      template: '<ui-view/>'
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($mdSidenav, $window) {
      _classCallCheck(this, Controller);

      this.$mdSidenav = $mdSidenav;
      this.base = $window.base;
      if ($window.location.href.indexOf('embedded') !== -1) {
        this.$embedded = true;
      }
    }

    _createClass(Controller, [{
      key: '$toggleSidenav',
      value: function $toggleSidenav(sidenavId) {
        this.$mdSidenav(sidenavId).toggle();
      }
    }]);

    return Controller;
  })();

  angular.module('root', [
  // Components
  'toolbar', 'sidenav', 'streetview', 'table',
  // Routes
  'login', 'site', 'user', 'vendor', 'product', 'review', 'approval', 'category', 'home', 'supplier', 'display', 'team']).component('rootEl', {
    controller: Controller,
    templateUrl: 'root/root.comp.html'
  });
})();
'use strict';

(function () {
  'use strict';
  function config($mdThemingProvider, $windowProvider) {
    var greenMap = $mdThemingProvider.extendPalette('teal', {
      300: '#6FB98F',
      400: '#2C7873',
      500: '#004445',
      600: '#021C1E',
      contrastDefaultColor: 'light',
      contrastDarkColors: ['300']
    });
    $mdThemingProvider.definePalette('green-map', greenMap);
    if ($windowProvider.$get().location.origin === 'http://localhost:3000') {
      $windowProvider.$get().base = 'staging';
    } else if ($windowProvider.$get().location.origin === 'http://staging.localhost:3000') {
      $windowProvider.$get().base = 'staging';
    } else if ($windowProvider.$get().location.origin === 'http://production.localhost:3000') {
      $windowProvider.$get().base = 'production';
    } else if ($windowProvider.$get().location.origin === 'https://drip.danielangel.co') {
      $windowProvider.$get().base = 'paul';
    } else if ($windowProvider.$get().location.origin === 'https://drip.webcat.app') {
      $windowProvider.$get().base = 'paul';
    } else if ($windowProvider.$get().location.origin === 'https://aatacdrip.co') {
      $windowProvider.$get().base = 'production';
    } else if ($windowProvider.$get().location.origin === 'https://drip-1e853.firebaseapp.com') {
      $windowProvider.$get().base = 'production';
    } else {
      $windowProvider.$get().base = 'staging';
    }
    if ($windowProvider.$get().base === 'paul') {
      $mdThemingProvider.theme('default').primaryPalette('blue', {
        'default': '700',
        'hue-1': '500',
        'hue-2': '600'
      }).accentPalette('light-blue', {
        'default': '500',
        'hue-1': '100',
        'hue-2': '700'
      });
    } else {
      $mdThemingProvider.theme('default').primaryPalette('deep-orange', {
        'default': '700',
        'hue-1': '500',
        'hue-2': '600'
      }).accentPalette('light-blue', {
        'default': '500',
        'hue-1': '100',
        'hue-2': '700'
      });
    }
    $mdThemingProvider.theme('grey-theme').primaryPalette('grey', {
      'default': '400',
      'hue-1': '900',
      'hue-2': '100'
    });
  }
  angular.module('app.themes', []).config(config);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.routes', ['ui.router']).config(config);

  function config($urlRouterProvider, $locationProvider, $windowProvider) {
    $urlRouterProvider.otherwise('/home');
    $locationProvider.hashPrefix('');
    if ($windowProvider.$get().location.protocol === 'https:') {
      $locationProvider.html5Mode(true);
    }
  }
})();